(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9851],{

/***/ 62988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var QueryHandler = __webpack_require__(61755);
var each = (__webpack_require__(26665).each);

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),

/***/ 38177:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MediaQuery = __webpack_require__(62988);
var Util = __webpack_require__(26665);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),

/***/ 61755:
/***/ (function(module) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),

/***/ 26665:
/***/ (function(module) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),

/***/ 24974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(38177);
module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 80973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(71169);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ 91296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 93096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;


/***/ }),

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 82908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 90939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(37005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    equalArrays = __webpack_require__(67114),
    equalByTag = __webpack_require__(18351),
    equalObjects = __webpack_require__(16096),
    getTag = __webpack_require__(64160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isTypedArray = __webpack_require__(36719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 67114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arraySome = __webpack_require__(82908),
    cacheHas = __webpack_require__(74757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 18351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    Uint8Array = __webpack_require__(11149),
    eq = __webpack_require__(77813),
    equalArrays = __webpack_require__(67114),
    mapToArray = __webpack_require__(68776),
    setToArray = __webpack_require__(21814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 16096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(58234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 18446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(23279),
    isObject = __webpack_require__(13218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 1861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ OverlayScrollbarsComponent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var overlayscrollbars__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45432);
/* harmony import */ var overlayscrollbars__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(overlayscrollbars__WEBPACK_IMPORTED_MODULE_1__);



/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

class OverlayScrollbarsComponent extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
    constructor(props) {
        super(props);
        this._osInstance = null;
        this._osTargetRef = react__WEBPACK_IMPORTED_MODULE_0__.createRef();
    }
    osInstance() {
        return this._osInstance;
    }
    osTarget() {
        return this._osTargetRef.current || null;
    }
    componentDidMount() {
        this._osInstance = overlayscrollbars__WEBPACK_IMPORTED_MODULE_1___default()(this.osTarget(), this.props.options || {}, this.props.extensions);
        mergeHostClassNames(this._osInstance, this.props.className);
    }
    componentWillUnmount() {
        if (overlayscrollbars__WEBPACK_IMPORTED_MODULE_1___default().valid(this._osInstance)) {
            this._osInstance.destroy();
            this._osInstance = null;
        }
    }
    componentDidUpdate(prevProps) {
        if (overlayscrollbars__WEBPACK_IMPORTED_MODULE_1___default().valid(this._osInstance)) {
            this._osInstance.options(this.props.options);
            if (prevProps.className !== this.props.className) {
                mergeHostClassNames(this._osInstance, this.props.className);
            }
        }
    }
    render() {
        const _a = this.props, divProps = __rest(_a, ["options", "extensions", "children", "className"]);
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", Object.assign({ className: "os-host" }, divProps, { ref: this._osTargetRef }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-resize-observer-host" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-padding" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-viewport" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-content" }, this.props.children))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar os-scrollbar-horizontal " },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar-track" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar-handle" }))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar os-scrollbar-vertical" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar-track" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar-handle" }))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar-corner" })));
    }
}
function mergeHostClassNames(osInstance, className) {
    if (overlayscrollbars__WEBPACK_IMPORTED_MODULE_1___default().valid(osInstance)) {
        const { host } = osInstance.getElements();
        const regex = new RegExp(`(^os-host([-_].+|)$)|${osInstance.options().className.replace(/\s/g, "$|")}$`, 'g');
        const osClassNames = host.className.split(' ')
            .filter(name => name.match(regex))
            .join(' ');
        host.className = `${osClassNames} ${className || ''}`;
    }
}


//# sourceMappingURL=overlayscrollbars-react.esm.js.map


/***/ }),

/***/ 1216:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Iq = __webpack_unused_export__ = __webpack_unused_export__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(54081);

var _scrollParent = __webpack_require__(38315);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(38282);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(40821);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: 0,
  height: 0
};
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = component.ref;

  var parentTop = void 0;
  var parentLeft = void 0;
  var parentHeight = void 0;
  var parentWidth = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentLeft = _parent$getBoundingCl.left;
    parentHeight = _parent$getBoundingCl.height;
    parentWidth = _parent$getBoundingCl.width;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentLeft = defaultBoundingClientRect.left;
    parentHeight = defaultBoundingClientRect.height;
    parentWidth = defaultBoundingClientRect.width;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width

  // check whether the element is visible in the intersection
  var top = void 0;
  var left = void 0;
  var height = void 0;
  var width = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    left = _node$getBoundingClie.left;
    height = _node$getBoundingClie.height;
    width = _node$getBoundingClie.width;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    left = defaultBoundingClientRect.left;
    height = defaultBoundingClientRect.height;
    width = defaultBoundingClientRect.width;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection
  var offsetLeft = left - intersectionLeft; // element's left relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = component.ref;

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = component.ref;
  if (!(node instanceof HTMLElement)) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

/**
 * Forces the component to display regardless of whether the element is visible in the viewport.
 */
var forceVisible = function forceVisible() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    listener.visible = true;
    listener.forceUpdate();
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var isString = function isString(string) {
  return typeof string === 'string';
};

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    _this.setRef = _this.setRef.bind(_this);
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var scrollport = window;
      var scrollContainer = this.props.scrollContainer;

      if (scrollContainer) {
        if (isString(scrollContainer)) {
          scrollport = scrollport.document.querySelector(scrollContainer);
        }
      }
      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && delayType === 'throttle' || delayType === 'debounce' && this.props.debounce === undefined;

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0 && typeof window !== 'undefined') {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(element) {
      if (element) {
        this.ref = element;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          height = _props2.height,
          children = _props2.children,
          placeholder = _props2.placeholder,
          className = _props2.className,
          classNamePrefix = _props2.classNamePrefix,
          style = _props2.style;


      return _react2.default.createElement(
        'div',
        { className: classNamePrefix + '-wrapper ' + className, ref: this.setRef, style: style },
        this.visible ? children : placeholder ? placeholder : _react2.default.createElement('div', {
          style: { height: height },
          className: classNamePrefix + '-placeholder'
        })
      );
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  className: _propTypes2.default.string,
  classNamePrefix: _propTypes2.default.string,
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  scrollContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  unmountIfInvisible: _propTypes2.default.bool,
  style: _propTypes2.default.object
};

LazyLoad.defaultProps = {
  className: '',
  classNamePrefix: 'lazyload',
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var decorator = function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component2) {
      _inherits(LazyLoadDecorated, _Component2);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this2 = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this2.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this2;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            LazyLoad,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

__webpack_unused_export__ = decorator;
exports.ZP = LazyLoad;
__webpack_unused_export__ = lazyLoadHandler;
exports.Iq = forceVisible;

/***/ }),

/***/ 38282:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),

/***/ 54081:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),

/***/ 38315:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

/**
 * @fileOverview Find scroll parent
 */

exports["default"] = function (node) {
  if (!(node instanceof HTMLElement)) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),

/***/ 40821:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),

/***/ 48477:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(31093);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports["default"] = (0, _scrollLink2.default)(ButtonElement);

/***/ }),

/***/ 35343:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(18000);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` and `name` from props
      var newProps = _extends({}, this.props);
      delete newProps.name;
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports["default"] = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),

/***/ 68939:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(31093);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports["default"] = (0, _scrollLink2.default)(LinkElement);

/***/ }),

/***/ 66261:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.OK = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = undefined;

var _Link = __webpack_require__(68939);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(48477);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(35343);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(82628);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(87606);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(53200);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(31093);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(18000);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(98482);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_unused_export__ = _Link2.default;
__webpack_unused_export__ = _Button2.default;
__webpack_unused_export__ = _Element2.default;
exports.OK = _scroller2.default;
__webpack_unused_export__ = _scrollEvents2.default;
__webpack_unused_export__ = _scrollSpy2.default;
__webpack_unused_export__ = _animateScroll2.default;
__webpack_unused_export__ = _scrollLink2.default;
__webpack_unused_export__ = _scrollElement2.default;
__webpack_unused_export__ = _Helpers2.default;
exports.ZP = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),

/***/ 98482:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(67294);
var ReactDOM = __webpack_require__(73935);

var utils = __webpack_require__(54259);
var scrollSpy = __webpack_require__(87606);
var defaultScroller = __webpack_require__(82628);
var PropTypes = __webpack_require__(45697);
var scrollHash = __webpack_require__(29678);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool,
  spyThrottle: PropTypes.number
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),

/***/ 53200:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(89765);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(50140);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  var setCancel = function setCancel() {
    options.data.cancel = true;
  };
  _cancelEvents2.default.subscribe(setCancel);

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

exports["default"] = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),

/***/ 50140:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(55236);

var events = ['mousedown', 'wheel', 'touchmove', 'keydown'];

exports["default"] = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),

/***/ 55236:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var listenerName = listener.name;
  if (!listenerName) {
    listenerName = eventName;
    console.warn('Listener must be a named function.');
  }

  if (!attachedListeners.has(eventName)) attachedListeners.set(eventName, new Set());
  var listeners = attachedListeners.get(eventName);
  if (listeners.has(listenerName)) return;

  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
  listeners.add(listenerName);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
  attachedListeners.get(eventName).delete(listener.name || eventName);
};

var attachedListeners = new Map();

/***/ }),

/***/ 18000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(73935);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(82628);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports["default"] = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),

/***/ 64592:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
	value: true
}));

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports["default"] = Events;

/***/ }),

/***/ 29678:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(55236);

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports["default"] = scrollHash;

/***/ }),

/***/ 31093:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(87606);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(82628);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(29678);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  activeStyle: _propTypes2.default.object,
  spy: _propTypes2.default.bool,
  horizontal: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool,
  saveHashHistory: _propTypes2.default.bool,
  spyThrottle: _propTypes2.default.number
};

exports["default"] = function (Component, customScroller) {
  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      _this.beforeUnmountCallbacks = [];
      return _this;
    }

    _createClass(Link, [{
      key: "getScrollSpyContainer",
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            var fn = _scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
            this.beforeUnmountCallbacks.push(fn);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
        this.beforeUnmountCallbacks.forEach(function (fn) {
          return fn();
        });
      }
    }, {
      key: "render",
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var style = {};

        if (this.state && this.state.active) {
          style = _extends({}, this.props.style, this.props.activeStyle);
        } else {
          style = _extends({}, this.props.style);
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.style = style;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {
      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();

          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;

        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),

/***/ 87606:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _lodash = __webpack_require__(93096);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(55236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
  var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
  return (0, _lodash2.default)(eventHandler, throttleAmount);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer, throttle) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      }, throttle);
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
      return function () {
        (0, _passiveEventListeners.removePassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
        scrollSpy.scrollSpyContainers.splice(scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer), 1);
      };
    }
    return function () {};
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.scrollY !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.scrollX : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.scrollX !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.scrollY : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length && scrollSpy.spySetState.indexOf(stateHandler) > -1) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports["default"] = scrollSpy;

/***/ }),

/***/ 82628:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(53200);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports["default"] = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),

/***/ 89765:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),

/***/ 54259:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

exports["default"] = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),

/***/ 8205:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PrevArrow = exports.NextArrow = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _classnames = _interopRequireDefault(__webpack_require__(93967));

var _innerSliderUtils = __webpack_require__(15518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  var _super = _createSuper(PrevArrow);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _super.apply(this, arguments);
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  var _super2 = _createSuper(NextArrow);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _super2.apply(this, arguments);
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;

/***/ }),

/***/ 23492:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;

/***/ }),

/***/ 16329:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Dots = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _classnames = _interopRequireDefault(__webpack_require__(93967));

var _innerSliderUtils = __webpack_require__(15518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  var _super = _createSuper(Dots);

  function Dots() {
    _classCallCheck(this, Dots);

    return _super.apply(this, arguments);
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave,
          infinite = _this$props.infinite,
          slidesToScroll = _this$props.slidesToScroll,
          slidesToShow = _this$props.slidesToShow,
          slideCount = _this$props.slideCount,
          currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];

      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;

        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);

        var _leftBound = rightBound - (slidesToScroll - 1);

        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }

      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;

/***/ }),

/***/ 46066:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _slider = _interopRequireDefault(__webpack_require__(5798));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports.Z = _default;

/***/ }),

/***/ 46948:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
var _default = initialState;
exports["default"] = _default;

/***/ }),

/***/ 58517:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _initialState = _interopRequireDefault(__webpack_require__(46948));

var _lodash = _interopRequireDefault(__webpack_require__(91296));

var _classnames = _interopRequireDefault(__webpack_require__(93967));

var _innerSliderUtils = __webpack_require__(15518);

var _track = __webpack_require__(64740);

var _dots = __webpack_require__(16329);

var _arrows = __webpack_require__(8205);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(91033));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  var _super = _createSuper(InnerSlider);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      _this.ro.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      var setTrackStyle = _this.didPropsChange(prevProps);

      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (_this.props.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)

      if (!isTrackMounted) return;

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }

        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        return {
          trackStyle: _trackStyle
        };
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
        index: index
      }, _this.props), _this.state), {}, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }

      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }

        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }

      _this.props.autoplay && _this.autoPlay("update");

      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");

        nodes[0] && nodes[0].focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;

    var ssrState = _this.ssrInit();

    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }

  _createClass(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;

      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];

        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
          continue;
        }

        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);

  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;

/***/ }),

/***/ 5798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _innerSlider = __webpack_require__(58517);

var _json2mq = _interopRequireDefault(__webpack_require__(80973));

var _defaultProps = _interopRequireDefault(__webpack_require__(23492));

var _innerSliderUtils = __webpack_require__(15518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(24974);

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
      } else {
        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {}

        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: className
        }, children);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;

/***/ }),

/***/ 64740:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Track = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _classnames = _interopRequireDefault(__webpack_require__(93967));

var _innerSliderUtils = __webpack_require__(15518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var focusedSlide;

  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }

  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;

    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread(_objectSpread({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  var _super = _createSuper(Track);

  function Track() {
    var _this;

    _classCallCheck(this, Track);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "node", null);

    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
      _this.node = ref;
    });

    return _this;
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;

/***/ }),

/***/ 15518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.checkSpecKeys = exports.checkNavigable = exports.changeSlide = exports.canUseDOM = exports.canGoNext = void 0;
exports.clamp = clamp;
exports.swipeStart = exports.swipeMove = exports.swipeEnd = exports.slidesOnRight = exports.slidesOnLeft = exports.slideHandler = exports.siblingDirection = exports.safePreventDefault = exports.lazyStartIndex = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.keyHandler = exports.initializedState = exports.getWidth = exports.getTrackLeft = exports.getTrackCSS = exports.getTrackAnimateCSS = exports.getTotalSlides = exports.getSwipeDirection = exports.getSlideCount = exports.getRequiredLazySlides = exports.getPreClones = exports.getPostClones = exports.getOnDemandLazySlides = exports.getNavigableIndexes = exports.getHeight = exports.extractObject = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}

var safePreventDefault = function safePreventDefault(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];

  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};

exports.safePreventDefault = safePreventDefault;

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }

    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      previousTargetSlide = spec.targetSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (infinite) {
      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && safePreventDefault(e);
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return safePreventDefault(e);
  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread(_objectSpread({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e);
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe,
      targetSlide = spec.targetSlide,
      currentSlide = spec.currentSlide,
      infinite = spec.infinite;

  if (!dragging) {
    if (swipe) safePreventDefault(e);
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e);

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = activeSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread(_objectSpread({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),

/***/ 91033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),

/***/ 71169:
/***/ (function(module) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ 71739:
/***/ (function(module) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),

/***/ 24750:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x7": function() { return /* binding */ floating_ui_dom_arrow; },
  "Me": function() { return /* binding */ autoUpdate; },
  "oo": function() { return /* binding */ floating_ui_dom_computePosition; },
  "RR": function() { return /* binding */ floating_ui_dom_flip; },
  "Qo": function() { return /* binding */ floating_ui_dom_inline; },
  "cv": function() { return /* binding */ floating_ui_dom_offset; },
  "uY": function() { return /* binding */ floating_ui_dom_shift; }
});

// UNUSED EXPORTS: autoPlacement, detectOverflow, getOverflowAncestors, hide, limitShift, platform, size

;// CONCATENATED MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const floating_ui_utils_sides = (/* unused pure expression or super */ null && (['top', 'right', 'bottom', 'left']));
const alignments = (/* unused pure expression or super */ null && (['start', 'end']));
const floating_ui_utils_placements = /*#__PURE__*/(/* unused pure expression or super */ null && (floating_ui_utils_sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), [])));
const floating_ui_utils_min = Math.min;
const floating_ui_utils_max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function clamp(start, value, end) {
  return floating_ui_utils_max(start, floating_ui_utils_min(value, end));
}
function floating_ui_utils_evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function floating_ui_utils_getSide(placement) {
  return placement.split('-')[0];
}
function floating_ui_utils_getAlignment(placement) {
  return placement.split('-')[1];
}
function floating_ui_utils_getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function floating_ui_utils_getSideAxis(placement) {
  const firstChar = placement[0];
  return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return floating_ui_utils_getOppositeAxis(floating_ui_utils_getSideAxis(placement));
}
function floating_ui_utils_getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = floating_ui_utils_getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [floating_ui_utils_getOppositeAlignmentPlacement(placement), oppositePlacement, floating_ui_utils_getOppositeAlignmentPlacement(oppositePlacement)];
}
function floating_ui_utils_getOppositeAlignmentPlacement(placement) {
  return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const lrPlacement = ['left', 'right'];
const rlPlacement = ['right', 'left'];
const tbPlacement = ['top', 'bottom'];
const btPlacement = ['bottom', 'top'];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case 'left':
    case 'right':
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = floating_ui_utils_getAlignment(placement);
  let list = getSideList(floating_ui_utils_getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(floating_ui_utils_getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  const side = floating_ui_utils_getSide(placement);
  return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
  var _padding$top, _padding$right, _padding$bottom, _padding$left;
  return {
    top: (_padding$top = padding.top) != null ? _padding$top : 0,
    right: (_padding$right = padding.right) != null ? _padding$right : 0,
    bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
    left: (_padding$left = padding.left) != null ? _padding$left : 0
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}



;// CONCATENATED MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.mjs



function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = floating_ui_utils_getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = floating_ui_utils_getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  const alignment = floating_ui_utils_getAlignment(placement);
  if (alignment) {
    coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
  }
  return coords;
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = floating_ui_utils_evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) && (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const MAX_RESET_COUNT = 50;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const platformWithDetectOverflow = platform.detectOverflow ? platform : {
    ...platform,
    detectOverflow
  };
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let resetCount = 0;
  const middlewareData = {};
  for (let i = 0; i < middleware.length; i++) {
    const currentMiddleware = middleware[i];
    if (!currentMiddleware) {
      continue;
    }
    const {
      name,
      fn
    } = currentMiddleware;
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platformWithDetectOverflow,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData[name] = {
      ...middlewareData[name],
      ...data
    };
    if (reset && resetCount < MAX_RESET_COUNT) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = floating_ui_utils_evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = floating_ui_utils_min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = floating_ui_utils_min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(minPadding, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && floating_ui_utils_getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1 = alignment !== undefined || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const overflow = await platform.detectOverflow(state, detectOverflowOptions);
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = getAlignment(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      getAlignment(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = floating_ui_utils_getSide(placement);
      const initialSideAxis = floating_ui_utils_getSideAxis(initialPlacement);
      const isBasePlacement = floating_ui_utils_getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await platform.detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = floating_ui_utils_getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== floating_ui_utils_getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow ||
          // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every(d => floating_ui_utils_getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) {
            // Try next placement and re-run the lifecycle.
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$filter2;
                const placement = (_overflowsData$filter2 = overflowsData.filter(d => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = floating_ui_utils_getSideAxis(d.placement);
                    return currentSideAxis === initialSideAxis ||
                    // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === 'y';
                  }
                  return true;
                }).map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects,
        platform
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await platform.detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await platform.detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

function getBoundingRect(rects) {
  const minX = floating_ui_utils_min(...rects.map(rect => rect.left));
  const minY = floating_ui_utils_min(...rects.map(rect => rect.top));
  const maxX = floating_ui_utils_max(...rects.map(rect => rect.right));
  const maxY = floating_ui_utils_max(...rects.map(rect => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(rect => rectToClientRect(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform,
        strategy
      } = state;
      // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
      // ClientRect's bounds, despite the event listener being triggered. A
      // padding of 2 seems to handle this issue.
      const {
        padding = 2,
        x,
        y
      } = floating_ui_utils_evaluate(options, state);
      const nativeClientRects = Array.from((await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) || []);

      // No rects (e.g. a hidden or detached reference, or a collapsed range) —
      // keep the existing reference rect rather than resetting to an invalid
      // one with non-finite values.
      if (!nativeClientRects.length) {
        return {};
      }
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = rectToClientRect(getBoundingRect(nativeClientRects));
      const paddingObject = getPaddingObject(padding);
      function getBoundingClientRect() {
        // There are two rects and they are disjoined.
        if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) {
          // Find the first rect in which the point is fully inside.
          return clientRects.find(rect => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }

        // There are 2 or more connected rects.
        if (clientRects.length >= 2) {
          if (floating_ui_utils_getSideAxis(placement) === 'y') {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = floating_ui_utils_getSide(placement) === 'top';
            const top = firstRect.top;
            const bottom = lastRect.bottom;
            const left = isTop ? firstRect.left : lastRect.left;
            const right = isTop ? firstRect.right : lastRect.right;
            return rectToClientRect({
              x: left,
              y: top,
              width: right - left,
              height: bottom - top
            });
          }
          const isLeftSide = floating_ui_utils_getSide(placement) === 'left';
          const maxRight = floating_ui_utils_max(...clientRects.map(rect => rect.right));
          const minLeft = floating_ui_utils_min(...clientRects.map(rect => rect.left));
          const measureRects = clientRects.filter(rect => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          return rectToClientRect({
            x: minLeft,
            y: top,
            width: maxRight - minLeft,
            height: bottom - top
          });
        }
        return fallback;
      }
      const resetRects = await platform.getElementRects({
        reference: {
          getBoundingClientRect
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};

const originSides = /*#__PURE__*/new Set(['left', 'top']);

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = floating_ui_utils_getSide(placement);
  const alignment = floating_ui_utils_getAlignment(placement);
  const isVertical = floating_ui_utils_getSideAxis(placement) === 'y';
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = floating_ui_utils_evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement,
        platform
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await platform.detectOverflow(state, detectOverflowOptions);
      const crossAxis = floating_ui_utils_getSideAxis(placement);
      const mainAxis = floating_ui_utils_getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const clampCoord = (axis, coord) => clamp(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
      if (checkMainAxis) {
        mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
      }
      if (checkCrossAxis) {
        crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      var _rawOffset$mainAxis, _rawOffset$crossAxis;
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
        crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = originSides.has(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await platform.detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const shiftData = state.middlewareData.shift;
      const noShift = !shiftData;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if (shiftData != null && shiftData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if (shiftData != null && shiftData.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        if (isYAxis) {
          availableWidth = width - 2 * max(overflow.left, overflow.right);
        } else {
          availableHeight = height - 2 * max(overflow.top, overflow.bottom);
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};



// EXTERNAL MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
var floating_ui_utils_dom = __webpack_require__(37317);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs





function getCssDimensions(element) {
  const css = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !(0,floating_ui_utils_dom/* isElement */.kK)(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!(0,floating_ui_utils_dom/* isHTMLElement */.Re)(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  if (!(0,floating_ui_utils_dom/* isWebKit */.Pf)() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if ((0,floating_ui_utils_dom/* isElement */.kK)(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement && offsetParent) {
    const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(domElement);
    const offsetWin = (0,floating_ui_utils_dom/* isElement */.kK)(offsetParent) ? (0,floating_ui_utils_dom/* getWindow */.Jj)(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = (0,floating_ui_utils_dom/* getFrameElement */.wK)(currentWin);
    while (currentIFrame && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = (0,floating_ui_utils_dom/* getWindow */.Jj)(currentIFrame);
      currentIFrame = (0,floating_ui_utils_dom/* getFrameElement */.wK)(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
  const leftScroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect((0,floating_ui_utils_dom/* getDocumentElement */.tF)(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}

function getHTMLOffset(documentElement, scroll) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(offsetParent);
  const topLayer = elements ? (0,floating_ui_utils_dom/* isTopLayer */.tR)(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(offsetParent);
  if (isOffsetParentAnElement || !isFixed) {
    if ((0,floating_ui_utils_dom/* getNodeName */.wk)(offsetParent) !== 'body' || (0,floating_ui_utils_dom/* isOverflowElement */.ao)(documentElement)) {
      scroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}

function getClientRects(element) {
  return element.getClientRects ? Array.from(element.getClientRects()) : [];
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(html) {
  const scroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(html);
  const body = html.ownerDocument.body;
  const width = floating_ui_utils_max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = floating_ui_utils_max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(html);
  const y = -scroll.scrollTop;
  if ((0,floating_ui_utils_dom/* getComputedStyle */.Dx)(body).direction === 'rtl') {
    x += floating_ui_utils_max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy, rootBoundary) {
  if (rootBoundary === void 0) {
    rootBoundary = 'viewport';
  }
  const isLayoutViewport = rootBoundary === 'layoutViewport';
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  const html = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    // Client coordinates are relative to the layout viewport, except in
    // WebKit with an `absolute` strategy, where they are relative to the
    // visual viewport.
    const layoutRelativeClientCoords = !(0,floating_ui_utils_dom/* isWebKit */.Pf)() || strategy === 'fixed';
    if (isLayoutViewport) {
      if (!layoutRelativeClientCoords) {
        x = -visualViewport.offsetLeft;
        y = -visualViewport.offsetTop;
      }
    } else {
      width = visualViewport.width;
      height = visualViewport.height;
      if (layoutRelativeClientCoords) {
        x = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }
  }
  const windowScrollbarX = getWindowScrollBarX(html);
  // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
  // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
  // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
  // reserves an empty inline-start gutter that clips nothing, so exclude just
  // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
  // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
  // `getHTMLOffset`/`visualViewport.width`; skip it here.
  if (windowScrollbarX <= 0) {
    const doc = html.ownerDocument;
    const body = doc.body;
    const bodyStyles = getComputedStyle(body);
    const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
    const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
    if (gutter <= SCROLLBAR_MAX) {
      width -= gutter;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = getScale(element);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') {
    rect = getViewportRect(element, strategy, clippingAncestor);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect((0,floating_ui_utils_dom/* getDocumentElement */.tF)(element));
  } else if ((0,floating_ui_utils_dom/* isElement */.kK)(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(element, [], false).filter(el => (0,floating_ui_utils_dom/* isElement */.kK)(el) && (0,floating_ui_utils_dom/* getNodeName */.wk)(el) !== 'body');
  let lastKeptComputedStyle = null;
  const elementIsFixed = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).position === 'fixed';
  let currentNode = elementIsFixed ? (0,floating_ui_utils_dom/* getParentNode */.Ow)(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while ((0,floating_ui_utils_dom/* isElement */.kK)(currentNode) && !(0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(currentNode)) {
    const computedStyle = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(currentNode);
    const currentNodeIsContaining = (0,floating_ui_utils_dom/* isContainingBlock */.hT)(currentNode);
    // Position of the containing block chain below the current node. A fixed
    // element whose containing block hasn't been found yet is a fixed chain.
    const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';

    // A non-containing ancestor does not clip the element when the chain
    // below it escapes it: a fixed chain escapes all ancestors up to the
    // next containing block, an absolute chain escapes static ancestors.
    const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // The kept node carries the chain position for the next iteration.
      lastKeptComputedStyle = computedStyle;
    }
    currentNode = (0,floating_ui_utils_dom/* getParentNode */.Ow)(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? (0,floating_ui_utils_dom/* isTopLayer */.tR)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
  let top = firstRect.top;
  let right = firstRect.right;
  let bottom = firstRect.bottom;
  let left = firstRect.left;
  for (let i = 1; i < clippingAncestors.length; i++) {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
    top = floating_ui_utils_max(rect.top, top);
    right = floating_ui_utils_min(rect.right, right);
    bottom = floating_ui_utils_min(rect.bottom, bottom);
    left = floating_ui_utils_max(rect.left, left);
  }
  return {
    width: right - left,
    height: bottom - top,
    x: left,
    y: top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(offsetParent);
  const documentElement = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isFixed) {
    if ((0,floating_ui_utils_dom/* getNodeName */.wk)(offsetParent) !== 'body' || (0,floating_ui_utils_dom/* isOverflowElement */.ao)(documentElement)) {
      scroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }

  // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
  // Firefox with layout.scrollbar.side = 3 in about:config to test this.
  if (!isOffsetParentAnElement && documentElement) {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function isStaticPositioned(element) {
  return (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).position === 'static';
}

function getTrueOffsetParent(element, polyfill) {
  if (!(0,floating_ui_utils_dom/* isHTMLElement */.Re)(element) || (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;

  // Firefox returns the <html> element as the offsetParent if it's non-static,
  // while Chrome and Safari return the <body> element. The <body> element must
  // be used to perform the correct calculations even if the <html> element is
  // non-static.
  if ((0,floating_ui_utils_dom/* getDocumentElement */.tF)(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  if ((0,floating_ui_utils_dom/* isTopLayer */.tR)(element)) {
    return win;
  }
  if (!(0,floating_ui_utils_dom/* isHTMLElement */.Re)(element)) {
    let svgOffsetParent = (0,floating_ui_utils_dom/* getParentNode */.Ow)(element);
    while (svgOffsetParent && !(0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(svgOffsetParent)) {
      if ((0,floating_ui_utils_dom/* isElement */.kK)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = (0,floating_ui_utils_dom/* getParentNode */.Ow)(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && (0,floating_ui_utils_dom/* isTableElement */.Ze)(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(offsetParent) && isStaticPositioned(offsetParent) && !(0,floating_ui_utils_dom/* isContainingBlock */.hT)(offsetParent)) {
    return win;
  }
  return offsetParent || (0,floating_ui_utils_dom/* getContainingBlock */.gQ)(element) || win;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};

function isRTL(element) {
  return (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: floating_ui_utils_dom/* getDocumentElement */.tF,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: floating_ui_utils_dom/* isElement */.kK,
  isRTL
};

function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove, ancestorResize) {
  let io = null;
  let timeoutId;
  const root = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: floating_ui_utils_max(0, floating_ui_utils_min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;

      // The entry is a snapshot, so the reference may have moved since the
      // intersection was computed (under performance constraints, or between
      // consecutive frames of a multi-frame layout shift). The reported ratio
      // and the observed area are stale in that case and cannot be trusted to
      // detect subsequent movement, so refresh regardless of the ratio.
      if (!rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        return refresh();
      }
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped in place, the ratio is 0. Throttle
          // the refresh to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  // The window is a resize ancestor, so when `ancestorResize` is enabled its
  // listener already runs the update on resize. Here we only need to rebuild
  // the `IntersectionObserver` for the new root size, skipping a redundant
  // update. When `ancestorResize` is disabled, this becomes the sole update.
  const handleResize = () => refresh(ancestorResize);
  win.addEventListener('resize', handleResize);
  refresh(true);
  return () => {
    win.removeEventListener('resize', handleResize);
    cleanup();
  };
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(referenceEl) : []), ...(floating ? (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(floating) : [])] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update);
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update, ancestorResize) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    if (floating) {
      resizeObserver.observe(floating);
    }
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
const floating_ui_dom_detectOverflow = (/* unused pure expression or super */ null && (detectOverflow$1));

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const floating_ui_dom_offset = offset;

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const floating_ui_dom_autoPlacement = (/* unused pure expression or super */ null && (autoPlacement$1));

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const floating_ui_dom_shift = shift;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const floating_ui_dom_flip = flip;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const floating_ui_dom_size = (/* unused pure expression or super */ null && (size$1));

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const floating_ui_dom_hide = (/* unused pure expression or super */ null && (hide$1));

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const floating_ui_dom_arrow = arrow;

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const floating_ui_dom_inline = inline;

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const floating_ui_dom_limitShift = (/* unused pure expression or super */ null && (limitShift$1));

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const floating_ui_dom_computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = options != null ? options : {};
  const platformWithCache = {
    ...platform,
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};




/***/ }),

/***/ 1371:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qo": function() { return /* binding */ inline; },
/* harmony export */   "RR": function() { return /* binding */ flip; },
/* harmony export */   "YF": function() { return /* binding */ useFloating; },
/* harmony export */   "cv": function() { return /* binding */ offset; },
/* harmony export */   "uY": function() { return /* binding */ shift; },
/* harmony export */   "x7": function() { return /* binding */ arrow; }
/* harmony export */ });
/* unused harmony exports autoPlacement, hide, limitShift, size */
/* harmony import */ var _floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24750);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);






var isClient = typeof document !== 'undefined';

var noop = function noop() {};
var index = isClient ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : noop;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef(value) {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = react__WEBPACK_IMPORTED_MODULE_0__.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const [_floating, _setFloating] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const setReference = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const floatingRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const dataRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const openRef = useLatestRef(open);
  const update = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .computePosition */ .oo)(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        react_dom__WEBPACK_IMPORTED_MODULE_1__.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .arrow */ .x7)({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .arrow */ .x7)({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = (options, deps) => {
  const result = (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .offset */ .cv)(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = (options, deps) => {
  const result = (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .shift */ .uY)(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = (options, deps) => {
  const result = limitShift$1(options);
  return {
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = (options, deps) => {
  const result = (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .flip */ .RR)(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = (options, deps) => {
  const result = size$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = (options, deps) => {
  const result = autoPlacement$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = (options, deps) => {
  const result = hide$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = (options, deps) => {
  const result = (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .inline */ .Qo)(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = (options, deps) => {
  const result = arrow$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};




/***/ }),

/***/ 97145:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ activeElement; },
/* harmony export */   "El": function() { return /* binding */ getNodeChildren; },
/* harmony export */   "G6": function() { return /* binding */ isSafari; },
/* harmony export */   "II": function() { return /* binding */ useLatestRef; },
/* harmony export */   "MM": function() { return /* binding */ isReactEvent; },
/* harmony export */   "Me": function() { return /* binding */ getDocument; },
/* harmony export */   "Pe": function() { return /* binding */ isEventTargetWithin; },
/* harmony export */   "U9": function() { return /* binding */ getTarget; },
/* harmony export */   "V5": function() { return /* binding */ isMac; },
/* harmony export */   "WL": function() { return /* binding */ matchesFocusVisible; },
/* harmony export */   "Xj": function() { return /* binding */ index; },
/* harmony export */   "ex": function() { return /* binding */ isRootElement; },
/* harmony export */   "iW": function() { return /* binding */ useEffectEvent; },
/* harmony export */   "j7": function() { return /* binding */ isTypeableElement; },
/* harmony export */   "r": function() { return /* binding */ isMouseLikePointerType; },
/* harmony export */   "r3": function() { return /* binding */ contains; },
/* harmony export */   "zd": function() { return /* binding */ getFloatingFocusElement; }
/* harmony export */ });
/* unused harmony exports createGridCellMap, disableFocusInside, enableFocusInside, findNonDisabledListIndex, getDeepestNode, getGridCellIndexOfCorner, getGridCellIndices, getGridNavigatedIndex, getMaxListIndex, getMinListIndex, getNextTabbable, getNodeAncestors, getPlatform, getPreviousTabbable, getTabbableOptions, getUserAgent, isAndroid, isDifferentGridRow, isIndexOutOfListBounds, isJSDOM, isListIndexDisabled, isOutsideEvent, isTypeableCombobox, isVirtualClick, isVirtualPointerEvent, stopEvent */
/* harmony import */ var _floating_ui_utils_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37317);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);






// Avoid Chrome DevTools blue warning.
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map(_ref => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(' ');
  }
  return navigator.userAgent;
}
function isSafari() {
  // Chrome DevTools does not complain about navigator.vendor
  return /apple/i.test(navigator.vendor);
}
function isAndroid() {
  const re = /android/i;
  return re.test(getPlatform()) || re.test(getUserAgent());
}
function isMac() {
  return getPlatform().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function isJSDOM() {
  return getUserAgent().includes('jsdom/');
}

const FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled])," + "[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';

function activeElement(doc) {
  let activeElement = doc.activeElement;
  while (((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null) {
    var _activeElement;
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}
function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && (0,_floating_ui_utils_dom__WEBPACK_IMPORTED_MODULE_1__/* .isShadowRoot */ .Zq)(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}
function getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  }

  // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
  const e = event;
  return e.target != null && node.contains(e.target);
}
function isRootElement(element) {
  return element.matches('html,body');
}
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function isTypeableElement(element) {
  return (0,_floating_ui_utils_dom__WEBPACK_IMPORTED_MODULE_1__/* .isHTMLElement */ .Re)(element) && element.matches(TYPEABLE_SELECTOR);
}
function isTypeableCombobox(element) {
  if (!element) return false;
  return element.getAttribute('role') === 'combobox' && isTypeableElement(element);
}
function matchesFocusVisible(element) {
  // We don't want to block focus from working with `visibleOnly`
  // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
  if (!element || isJSDOM()) return true;
  try {
    return element.matches(':focus-visible');
  } catch (_e) {
    return true;
  }
}
function getFloatingFocusElement(floatingElement) {
  if (!floatingElement) {
    return null;
  }
  // Try to find the element that has `{...getFloatingProps()}` spread on it.
  // This indicates the floating element is acting as a positioning wrapper, and
  // so focus should be managed on the child element with the event handlers and
  // aria props.
  return floatingElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}

function getNodeChildren(nodes, id, onlyOpenChildren) {
  if (onlyOpenChildren === void 0) {
    onlyOpenChildren = true;
  }
  const directChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
  });
  return directChildren.flatMap(child => [child, ...getNodeChildren(nodes, child.id, onlyOpenChildren)]);
}
function getDeepestNode(nodes, id) {
  let deepestNodeId;
  let maxDepth = -1;
  function findDeepest(nodeId, depth) {
    if (depth > maxDepth) {
      deepestNodeId = nodeId;
      maxDepth = depth;
    }
    const children = getNodeChildren(nodes, nodeId);
    children.forEach(child => {
      findDeepest(child.id, depth + 1);
    });
  }
  findDeepest(id, 0);
  return nodes.find(node => node.id === deepestNodeId);
}
function getNodeAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find(node => node.id === id)) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find(node => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}

function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
function isReactEvent(event) {
  return 'nativeEvent' in event;
}

// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function isVirtualClick(event) {
  // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
  // Try to find a workaround for this. `react-aria` source still has the check.
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  if (isAndroid() && event.pointerType) {
    return event.type === 'click' && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  if (isJSDOM()) return false;
  return !isAndroid() && event.width === 0 && event.height === 0 || isAndroid() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' ||
  // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function isMouseLikePointerType(pointerType, strict) {
  // On some Linux machines with Chromium, mouse inputs return a `pointerType`
  // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
  const values = ['mouse', 'pen'];
  if (!strict) {
    values.push('', undefined);
  }
  return values.includes(pointerType);
}

var isClient = typeof document !== 'undefined';

var noop = function noop() {};
var index = isClient ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : noop;

// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const SafeReact = {
  .../*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))
};

function useLatestRef(value) {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function useEffectEvent(callback) {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(() => {
    if (false) {}
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

function isDifferentGridRow(index, cols, prevRow) {
  return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfListBounds(listRef, index) {
  return index < 0 || index >= listRef.current.length;
}
function getMinListIndex(listRef, disabledIndices) {
  return findNonDisabledListIndex(listRef, {
    disabledIndices
  });
}
function getMaxListIndex(listRef, disabledIndices) {
  return findNonDisabledListIndex(listRef, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices
  });
}
function findNonDisabledListIndex(listRef, _temp) {
  let {
    startingIndex = -1,
    decrement = false,
    disabledIndices,
    amount = 1
  } = _temp === void 0 ? {} : _temp;
  let index = startingIndex;
  do {
    index += decrement ? -amount : amount;
  } while (index >= 0 && index <= listRef.current.length - 1 && isListIndexDisabled(listRef, index, disabledIndices));
  return index;
}
function getGridNavigatedIndex(listRef, _ref) {
  let {
    event,
    orientation,
    loop,
    rtl,
    cols,
    disabledIndices,
    minIndex,
    maxIndex,
    prevIndex,
    stopEvent: stop = false
  } = _ref;
  let nextIndex = prevIndex;
  if (event.key === ARROW_UP) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = maxIndex;
    } else {
      nextIndex = findNonDisabledListIndex(listRef, {
        startingIndex: nextIndex,
        amount: cols,
        decrement: true,
        disabledIndices
      });
      if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
        const col = prevIndex % cols;
        const maxCol = maxIndex % cols;
        const offset = maxIndex - (maxCol - col);
        if (maxCol === col) {
          nextIndex = maxIndex;
        } else {
          nextIndex = maxCol > col ? offset : offset - cols;
        }
      }
    }
    if (isIndexOutOfListBounds(listRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }
  if (event.key === ARROW_DOWN) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = minIndex;
    } else {
      nextIndex = findNonDisabledListIndex(listRef, {
        startingIndex: prevIndex,
        amount: cols,
        disabledIndices
      });
      if (loop && prevIndex + cols > maxIndex) {
        nextIndex = findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex % cols - cols,
          amount: cols,
          disabledIndices
        });
      }
    }
    if (isIndexOutOfListBounds(listRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }

  // Remains on the same row/column.
  if (orientation === 'both') {
    const prevRow = floor(prevIndex / cols);
    if (event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT)) {
      stop && stopEvent(event);
      if (prevIndex % cols !== cols - 1) {
        nextIndex = findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex,
          disabledIndices
        });
        if (loop && isDifferentGridRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledListIndex(listRef, {
            startingIndex: prevIndex - prevIndex % cols - 1,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      }
      if (isDifferentGridRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    if (event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT)) {
      stop && stopEvent(event);
      if (prevIndex % cols !== 0) {
        nextIndex = findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex,
          decrement: true,
          disabledIndices
        });
        if (loop && isDifferentGridRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledListIndex(listRef, {
            startingIndex: prevIndex + (cols - prevIndex % cols),
            decrement: true,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex + (cols - prevIndex % cols),
          decrement: true,
          disabledIndices
        });
      }
      if (isDifferentGridRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    const lastRow = floor(maxIndex / cols) === prevRow;
    if (isIndexOutOfListBounds(listRef, nextIndex)) {
      if (loop && lastRow) {
        nextIndex = event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT) ? maxIndex : findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      } else {
        nextIndex = prevIndex;
      }
    }
  }
  return nextIndex;
}

/** For each cell index, gets the item index that occupies that cell */
function createGridCellMap(sizes, cols, dense) {
  const cellMap = [];
  let startIndex = 0;
  sizes.forEach((_ref2, index) => {
    let {
      width,
      height
    } = _ref2;
    if (width > cols) {
      if (false) {}
    }
    let itemPlaced = false;
    if (dense) {
      startIndex = 0;
    }
    while (!itemPlaced) {
      const targetCells = [];
      for (let i = 0; i < width; i++) {
        for (let j = 0; j < height; j++) {
          targetCells.push(startIndex + i + j * cols);
        }
      }
      if (startIndex % cols + width <= cols && targetCells.every(cell => cellMap[cell] == null)) {
        targetCells.forEach(cell => {
          cellMap[cell] = index;
        });
        itemPlaced = true;
      } else {
        startIndex++;
      }
    }
  });

  // convert into a non-sparse array
  return [...cellMap];
}

/** Gets cell index of an item's corner or -1 when index is -1. */
function getGridCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
  if (index === -1) return -1;
  const firstCellIndex = cellMap.indexOf(index);
  const sizeItem = sizes[index];
  switch (corner) {
    case 'tl':
      return firstCellIndex;
    case 'tr':
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + sizeItem.width - 1;
    case 'bl':
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + (sizeItem.height - 1) * cols;
    case 'br':
      return cellMap.lastIndexOf(index);
  }
}

/** Gets all cell indices that correspond to the specified indices */
function getGridCellIndices(indices, cellMap) {
  return cellMap.flatMap((index, cellIndex) => indices.includes(index) ? [cellIndex] : []);
}
function isListIndexDisabled(listRef, index, disabledIndices) {
  if (typeof disabledIndices === 'function') {
    return disabledIndices(index);
  } else if (disabledIndices) {
    return disabledIndices.includes(index);
  }
  const element = listRef.current[index];
  return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}

const getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck:
  // JSDOM does not support the `tabbable` library. To solve this we can
  // check if `ResizeObserver` is a real function (not polyfilled), which
  // determines if the current environment is JSDOM-like.
  typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
});
function getTabbableIn(container, dir) {
  const list = tabbable(container, getTabbableOptions());
  const len = list.length;
  if (len === 0) return;
  const active = activeElement(getDocument(container));
  const index = list.indexOf(active);
  const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
  return list[nextIndex];
}
function getNextTabbable(referenceElement) {
  return getTabbableIn(getDocument(referenceElement).body, 1) || referenceElement;
}
function getPreviousTabbable(referenceElement) {
  return getTabbableIn(getDocument(referenceElement).body, -1) || referenceElement;
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach(element => {
    element.dataset.tabindex = element.getAttribute('tabindex') || '';
    element.setAttribute('tabindex', '-1');
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll('[data-tabindex]');
  elements.forEach(element => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute('tabindex', tabindex);
    } else {
      element.removeAttribute('tabindex');
    }
  });
}




/***/ }),

/***/ 37317:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ getComputedStyle; },
/* harmony export */   "Jj": function() { return /* binding */ getWindow; },
/* harmony export */   "Kx": function() { return /* binding */ getOverflowAncestors; },
/* harmony export */   "Lw": function() { return /* binding */ getNodeScroll; },
/* harmony export */   "Ow": function() { return /* binding */ getParentNode; },
/* harmony export */   "Pf": function() { return /* binding */ isWebKit; },
/* harmony export */   "Py": function() { return /* binding */ isLastTraversableNode; },
/* harmony export */   "Re": function() { return /* binding */ isHTMLElement; },
/* harmony export */   "Ze": function() { return /* binding */ isTableElement; },
/* harmony export */   "Zq": function() { return /* binding */ isShadowRoot; },
/* harmony export */   "ao": function() { return /* binding */ isOverflowElement; },
/* harmony export */   "gQ": function() { return /* binding */ getContainingBlock; },
/* harmony export */   "hT": function() { return /* binding */ isContainingBlock; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "tF": function() { return /* binding */ getDocumentElement; },
/* harmony export */   "tR": function() { return /* binding */ isTopLayer; },
/* harmony export */   "wK": function() { return /* binding */ getFrameElement; },
/* harmony export */   "wk": function() { return /* binding */ getNodeName; }
/* harmony export */ });
/* unused harmony exports getNearestOverflowAncestor, isNode */
function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function isTableElement(element) {
  return /^(table|td|th)$/.test(getNodeName(element));
}
function isTopLayer(element) {
  try {
    if (element.matches(':popover-open')) {
      return true;
    }
  } catch (_e) {
    // no-op
  }
  try {
    return element.matches(':modal');
  } catch (_e) {
    return false;
  }
}
const willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const containRe = /paint|layout|strict|content/;
const isNotNone = value => !!value && value !== 'none';
let isWebKitValue;
function isContainingBlock(elementOrCss) {
  const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  // https://drafts.csswg.org/css-transforms-2/#individual-transforms
  return isNotNone(css.transform) || isNotNone(css.translate) || isNotNone(css.scale) || isNotNone(css.rotate) || isNotNone(css.perspective) || !isWebKit() && (isNotNone(css.backdropFilter) || isNotNone(css.filter)) || willChangeRe.test(css.willChange || '') || containRe.test(css.contain || '');
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (isWebKitValue == null) {
    isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
  }
  return isWebKitValue;
}
function isLastTraversableNode(node) {
  return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return (node.ownerDocument || node).body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  } else {
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
  }
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}




/***/ }),

/***/ 46718:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(87338);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(29050);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.module.css.mjs
var classes = {"buttonRoot":"GckgD","label":"AheTB","sections":"E54xC","buttonSizeLarge":"_0qQpH","buttonSizeMedium":"_0JISY","buttonSizeSmall":"u12Wo","buttonVariantPrimary":"f6Mqv","buttonVariantSecondary":"BG-c7","buttonVariantBrand":"WlIAM","buttonHover":"L-dLx","buttonFullWidth":"-ok9U","iconButton":"iwgFy","iconButtonSizeLarge":"ZBrOP","iconButtonSizeMedium":"jgT9U","iconButtonSizeSmall":"BEaHw"};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.utils.mjs


const buttonSizeClasses = {
  small: classes.buttonSizeSmall,
  medium: classes.buttonSizeMedium,
  large: classes.buttonSizeLarge
};
const buttonVariantClasses = {
  primary: classes.buttonVariantPrimary,
  secondary: classes.buttonVariantSecondary,
  brand: classes.buttonVariantBrand
};
const buttonIconSizeClasses = {
  small: classes.iconButtonSizeSmall,
  medium: classes.iconButtonSizeMedium,
  large: classes.iconButtonSizeLarge
};
const buttonTypographySize = {
  small: "button-s",
  medium: "button-l",
  large: "button-l"
};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs








const Button = (0,factory_utils/* polymorphicFactory */.bq)(
  (props, ref) => {
    const {
      component = "button",
      children,
      fullWidth,
      size = "medium",
      leftSection,
      rightSection,
      disabled,
      variant = "primary",
      className,
      icon,
      hasHoverEffect = true,
      ...rest
    } = props;
    const classNames = (0,clsx/* default */.Z)(
      classes.buttonRoot,
      "kohler-button-root",
      className,
      size && !icon ? buttonSizeClasses[size] : buttonIconSizeClasses[size],
      icon && classes.iconButton,
      fullWidth && classes.buttonFullWidth,
      variant && buttonVariantClasses[variant],
      hasHoverEffect && classes.buttonHover
    );
    const Icon = icon || void 0;
    return /* @__PURE__ */ react.createElement(
      Typography/* Typography */.Z,
      {
        className: classNames,
        component,
        ref,
        type: component === "button" ? "button" : void 0,
        disabled,
        size: buttonTypographySize[size],
        ...rest
      },
      leftSection && /* @__PURE__ */ react.createElement(Box/* Box */.x, { component: "span", className: (0,clsx/* default */.Z)("kohler-button-section", classes.sections) }, leftSection),
      /* @__PURE__ */ react.createElement(Box/* Box */.x, { component: "span", className: classes.label }, Icon ? /* @__PURE__ */ react.createElement(Icon, { size: size === "small" ? "small" : "medium", withBoundingBox: true }) : children),
      rightSection && /* @__PURE__ */ react.createElement(Box/* Box */.x, { component: "span", className: (0,clsx/* default */.Z)("kohler-button-section", classes.sections) }, rightSection)
    );
  }
);




/***/ }),

/***/ 13684:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Link; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(87338);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(29050);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.module.css.mjs
var classes = {"root":"ieaVA","linkUnderline":"KQtnJ","icons":"XqqHZ"};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.utils.mjs
const linkSizeText = {
  small: "button-s",
  medium: "button-m",
  large: "button-xl"
};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.mjs








const Link = (0,factory_utils/* polymorphicFactory */.bq)(
  (props, ref) => {
    const { component = "a", children, size = "medium", underline = true, className, leftIcon, rightIcon, ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(classes.root, "kohler-text-link-root", className, underline && classes.linkUnderline);
    return /* @__PURE__ */ react.createElement(Typography/* Typography */.Z, { className: classNames, component, ref, ...rest, size: linkSizeText[size] }, leftIcon && /* @__PURE__ */ react.createElement(Box/* Box */.x, { component: "span", className: (0,clsx/* default */.Z)("kohler-text-link-icon", classes.icons) }, leftIcon), /* @__PURE__ */ react.createElement(Box/* Box */.x, { component: "span" }, children), rightIcon && /* @__PURE__ */ react.createElement(Box/* Box */.x, { component: "span", className: (0,clsx/* default */.Z)("kohler-text-link-icon", classes.icons) }, rightIcon));
  }
);




/***/ }),

/***/ 65072:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(87338);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/FocusTrap/FocusTrap.utils.mjs


const TABBABLE_NODES = /input|select|textarea|button|object/;
const FOCUS_SELECTOR = "a, input, select, textarea, button, object, [tabindex]";
function FocusTrap_utils_hidden(element) {
  return element.style.display === "none";
}
function visible(element) {
  const isHidden = element.getAttribute("aria-hidden") || element.getAttribute("hidden") || element.getAttribute("type") === "hidden";
  if (isHidden) {
    return false;
  }
  let parentElement = element;
  while (parentElement) {
    if (parentElement === document.body || parentElement.nodeType === 11) {
      break;
    }
    if (FocusTrap_utils_hidden(parentElement)) {
      return false;
    }
    parentElement = parentElement.parentNode;
  }
  return true;
}
function getElementTabIndex(element) {
  let tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) {
    tabIndex = void 0;
  }
  return parseInt(tabIndex, 10);
}
function randomId() {
  return `kohler-${Math.random().toString(36).slice(2, 11)}`;
}
function focusable(element) {
  const nodeName = element.nodeName.toLowerCase();
  const isTabIndexNotNaN = !Number.isNaN(getElementTabIndex(element));
  const res = (
    // @ts-expect-error function accepts any html element but if it is a button, it should not be disabled to trigger the condition
    TABBABLE_NODES.test(nodeName) && !element.disabled || (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN)
  );
  return res && visible(element);
}
function tabbable(element) {
  const tabIndex = getElementTabIndex(element);
  const isTabIndexNaN = Number.isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}
function findTabbableDescendants(element) {
  return Array.from(element.querySelectorAll(FOCUS_SELECTOR)).filter(tabbable);
}
function scopeTab(node, event) {
  const tabbable2 = findTabbableDescendants(node);
  if (!tabbable2.length) {
    event.preventDefault();
    return;
  }
  const finalTabbable = tabbable2[event.shiftKey ? 0 : tabbable2.length - 1];
  const root = node.getRootNode();
  let leavingFinalTabbable = finalTabbable === root.activeElement || node === root.activeElement;
  const activeElement = root.activeElement;
  const activeElementIsRadio = activeElement.tagName === "INPUT" && activeElement.getAttribute("type") === "radio";
  if (activeElementIsRadio) {
    const activeRadioGroup = tabbable2.filter(
      (element) => element.getAttribute("type") === "radio" && element.getAttribute("name") === activeElement.getAttribute("name")
    );
    leavingFinalTabbable = activeRadioGroup.includes(finalTabbable);
  }
  if (!leavingFinalTabbable) {
    return;
  }
  event.preventDefault();
  const target = tabbable2[event.shiftKey ? tabbable2.length - 1 : 0];
  if (target) {
    target.focus();
  }
}
function useFocusTrap(active = true) {
  const ref = useRef();
  const restoreAria = useRef(null);
  const focusNode = (node) => {
    let focusElement = node.querySelector("[data-autofocus]");
    if (!focusElement) {
      const children = Array.from(node.querySelectorAll(FOCUS_SELECTOR));
      focusElement = children.find(tabbable) || children.find(focusable) || null;
      if (!focusElement && focusable(node)) focusElement = node;
    }
    if (focusElement) {
      focusElement.focus({ preventScroll: true });
    } else {
      console.warn("[@kohler-dsm-library/kohler-core/use-focus-trap] Failed to find focusable element within provided node", node);
    }
  };
  const setRef = useCallback(
    (node) => {
      if (!active) {
        return;
      }
      if (node === null) {
        if (restoreAria.current) {
          restoreAria.current();
          restoreAria.current = null;
        }
        return;
      }
      if (ref.current === node) {
        return;
      }
      if (node) {
        setTimeout(() => {
          if (node.getRootNode()) {
            focusNode(node);
          } else {
            console.warn("[@kohler-dsm-library/kohler-core/use-focus-trap] Ref node is not part of the dom", node);
          }
        });
        ref.current = node;
      } else {
        ref.current = null;
      }
    },
    [active]
  );
  useEffect(() => {
    if (!active) {
      return void 0;
    }
    if (ref.current) {
      setTimeout(() => focusNode(ref.current));
    }
    const handleKeyDown = (event) => {
      if (event.key === "Tab" && ref.current) {
        scopeTab(ref.current, event);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      if (restoreAria.current) {
        restoreAria.current();
      }
    };
  }, [active]);
  return setRef;
}



// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-isomorphic-effect.mjs
var use_isomorphic_effect = __webpack_require__(3465);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/Dropdown/subcomponent/Combobox/use-react-id.mjs


function useReactId() {
  const id = (0,react.useId)();
  return id ? `kohler-${id.replace(/:/g, "")}` : "";
}



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/Dropdown/subcomponent/Combobox/use-id.mjs





function useId(staticId) {
  const reactId = useReactId();
  const [uuid, setUuid] = (0,react.useState)(reactId);
  (0,use_isomorphic_effect/* useIsomorphicEffect */.Y)(() => {
    setUuid(randomId());
  }, []);
  if (typeof staticId === "string") {
    return staticId;
  }
  if (typeof window === "undefined") {
    return reactId;
  }
  return uuid;
}



// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(29050);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/get-floating-position/get-floating-position.mjs
function getFloatingPosition(dir, position) {
  return position;
}



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/FloatingArrow/get-arrow-position-styles.mjs
function horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
  if (placement === "center" || arrowPosition === "center") {
    return { top: arrowY };
  }
  if (placement === "end") {
    return { bottom: arrowOffset };
  }
  if (placement === "start") {
    return { top: arrowOffset };
  }
  return {};
}
function verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
  if (placement === "center" || arrowPosition === "center") {
    return { left: arrowX };
  }
  if (placement === "end") {
    return { [dir === "ltr" ? "right" : "left"]: arrowOffset };
  }
  if (placement === "start") {
    return { [dir === "ltr" ? "left" : "right"]: arrowOffset };
  }
  return {};
}
const radiusByFloatingSide = {
  bottom: "borderTopLeftRadius",
  left: "borderTopRightRadius",
  right: "borderBottomLeftRadius",
  top: "borderBottomRightRadius"
};
function getArrowPositionStyles({
  position,
  arrowSize,
  arrowOffset,
  arrowRadius,
  arrowPosition,
  arrowX,
  arrowY,
  dir
}) {
  const [side, placement = "center"] = position.split("-");
  const baseStyles = {
    width: arrowSize,
    height: arrowSize,
    transform: "rotate(45deg)",
    position: "absolute",
    [radiusByFloatingSide[side]]: arrowRadius
  };
  const arrowPlacement = -arrowSize / 4;
  if (side === "left") {
    return {
      ...baseStyles,
      ...horizontalSide(placement, arrowY, arrowOffset, arrowPosition),
      right: arrowPlacement,
      borderLeftColor: "transparent",
      borderBottomColor: "transparent"
    };
  }
  if (side === "right") {
    return {
      ...baseStyles,
      ...horizontalSide(placement, arrowY, arrowOffset, arrowPosition),
      left: arrowPlacement,
      borderRightColor: "transparent",
      borderTopColor: "transparent"
    };
  }
  if (side === "top") {
    return {
      ...baseStyles,
      ...verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir),
      bottom: arrowPlacement,
      borderTopColor: "transparent",
      borderLeftColor: "transparent"
    };
  }
  if (side === "bottom") {
    return {
      ...baseStyles,
      ...verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir),
      top: arrowPlacement,
      borderBottomColor: "transparent",
      borderRightColor: "transparent"
    };
  }
  return {};
}



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/FloatingArrow/FloatingArrow.mjs



const FloatingArrow = (0,react.forwardRef)(
  ({ position, arrowSize, arrowOffset, arrowRadius, arrowPosition, visible, arrowX, arrowY, style, ...others }, ref) => {
    const dir = "ltr";
    if (!visible) {
      return null;
    }
    return /* @__PURE__ */ react.createElement(
      "div",
      {
        ...others,
        ref,
        style: {
          ...style,
          ...getArrowPositionStyles({
            position,
            arrowSize,
            arrowOffset,
            arrowRadius,
            arrowPosition,
            dir,
            arrowX,
            arrowY
          })
        }
      }
    );
  }
);



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverTarget/PopoverTarget.utils.mjs


function isElement(value) {
  if (Array.isArray(value) || value === null) {
    return false;
  }
  if (typeof value === "object") {
    if (value.type === react.Fragment) {
      return false;
    }
    return true;
  }
  return false;
}



// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverTarget/use-merged-ref.mjs
var use_merged_ref = __webpack_require__(37390);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/Tooltip.module.css.mjs
var classes = {"tooltip":"MX352","tooltipOpened":"OFydy"};



// EXTERNAL MODULE: ./node_modules/@floating-ui/react/dist/floating-ui.react.mjs
var floating_ui_react = __webpack_require__(93075);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var floating_ui_react_dom = __webpack_require__(1371);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(27051);
// EXTERNAL MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs + 2 modules
var floating_ui_dom = __webpack_require__(24750);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/use-floating-auto-update.mjs




function useFloatingAutoUpdate({ opened, floating, position, positionDependencies }) {
  const [delayedUpdate, setDelayedUpdate] = (0,react.useState)(0);
  (0,react.useEffect)(() => {
    if (floating.refs.reference.current && floating.refs.floating.current) {
      return (0,floating_ui_dom/* autoUpdate */.Me)(floating.refs.reference.current, floating.refs.floating.current, floating.update);
    }
    return void 0;
  }, [floating.refs.reference.current, floating.refs.floating.current, opened, delayedUpdate, position]);
  (0,hooks/* useDidUpdate */.lR)(() => {
    floating.update();
  }, positionDependencies);
  (0,hooks/* useDidUpdate */.lR)(() => {
    setDelayedUpdate((c) => c + 1);
  }, [opened]);
}



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/use-tooltip.mjs







function useTooltip(settings) {
  const [uncontrolledOpened, setUncontrolledOpened] = (0,react.useState)(false);
  const controlled = typeof settings.opened === "boolean";
  const opened = controlled ? settings.opened : uncontrolledOpened;
  const uid = useId();
  const onChange = (0,react.useCallback)(
    (_opened) => {
      setUncontrolledOpened(_opened);
    },
    [uid]
  );
  const {
    x,
    y,
    context,
    refs,
    update,
    placement,
    middlewareData: { arrow: { x: arrowX, y: arrowY } = {} }
  } = (0,floating_ui_react/* useFloating */.YF)({
    strategy: settings.strategy,
    placement: settings.position,
    open: opened,
    onOpenChange: onChange,
    middleware: [
      (0,floating_ui_react_dom/* offset */.cv)(settings.offset),
      (0,floating_ui_react_dom/* shift */.uY)({ padding: 8 }),
      (0,floating_ui_react_dom/* flip */.RR)(),
      (0,floating_ui_react_dom/* arrow */.x7)({ element: settings.arrowRef, padding: settings.arrowOffset }),
      ...settings.inline ? [(0,floating_ui_react_dom/* inline */.Qo)()] : []
    ]
  });
  const { getReferenceProps, getFloatingProps } = (0,floating_ui_react/* useInteractions */.NI)([
    (0,floating_ui_react/* useHover */.XI)(context, {
      enabled: settings.events?.hover,
      delay: { open: settings.openDelay, close: settings.closeDelay },
      mouseOnly: !settings.events?.touch
    }),
    (0,floating_ui_react/* useFocus */.KK)(context, { enabled: settings.events?.focus, visibleOnly: true }),
    (0,floating_ui_react/* useRole */.qs)(context, { role: "tooltip" }),
    (0,floating_ui_react/* useDismiss */.bQ)(context, { enabled: typeof settings.opened === "undefined" })
  ]);
  useFloatingAutoUpdate({
    opened,
    position: settings.position,
    positionDependencies: settings.positionDependencies,
    floating: { refs, update }
  });
  (0,hooks/* useDidUpdate */.lR)(() => {
    settings.onPositionChange?.(placement);
  }, [placement]);
  return {
    x,
    y,
    arrowX,
    arrowY,
    reference: refs.setReference,
    floating: refs.setFloating,
    getFloatingProps,
    getReferenceProps,
    isGroupPhase: false,
    opened,
    placement
  };
}



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/Tooltip.mjs
'use client';












const Tooltip = (0,factory_utils/* factory */.d5)((props, ref) => {
  const {
    children,
    position,
    refProp = "ref",
    label,
    onPositionChange,
    opened,
    className,
    multiline = true,
    zIndex,
    onClick,
    onMouseEnter,
    onMouseLeave,
    inline,
    offset = 5,
    ...rest
  } = props;
  const dir = "ltr";
  const events = { hover: true, focus: false, touch: false };
  const arrowSize = 16;
  const arrowRef = (0,react.useRef)(null);
  const withArrow = false;
  const arrowOffset = 5;
  const arrowPosition = "side";
  const tooltip = useTooltip({
    position: getFloatingPosition(dir, position),
    closeDelay: void 0,
    openDelay: void 0,
    onPositionChange,
    opened,
    events,
    arrowRef,
    arrowOffset: void 0,
    offset: typeof offset === "number" ? offset + (0) : offset,
    positionDependencies: [...[], children],
    inline,
    strategy: void 0
  });
  if (!isElement(children)) {
    throw new Error(
      "[@kohler/core] Tooltip component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
    );
  }
  const targetRef = (0,use_merged_ref/* useMergedRef */.Yx)(tooltip.reference, children.ref, ref);
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
    Typography/* Typography */.Z,
    {
      component: "div",
      size: "paragraph-small",
      ...rest,
      ...tooltip.getFloatingProps({
        ref: tooltip.floating,
        className: (0,clsx/* default */.Z)(classes.tooltip, tooltip.opened && classes.tooltipOpened, className, "kohler-tooltip-root"),
        style: {
          zIndex,
          top: tooltip.y ?? 0,
          left: tooltip.x ?? 0
        }
      }),
      "data-multiline": multiline
    },
    label,
    /* @__PURE__ */ react.createElement(
      FloatingArrow,
      {
        ref: arrowRef,
        arrowX: tooltip.arrowX,
        arrowY: tooltip.arrowY,
        visible: withArrow,
        position: tooltip.placement,
        arrowSize,
        arrowOffset,
        arrowRadius: 0,
        arrowPosition
      }
    )
  ), (0,react.cloneElement)(
    children,
    tooltip.getReferenceProps({
      onClick,
      onMouseEnter,
      onMouseLeave,
      onMouseMove: props.onMouseMove,
      onPointerDown: props.onPointerDown,
      onPointerEnter: props.onPointerEnter,
      [refProp]: targetRef,
      className: (0,clsx/* default */.Z)(children.props.className),
      ...children.props
    })
  ));
});



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/Checkbox.context.mjs


const CheckboxGroupContext = (0,react.createContext)(null);
const CheckboxGroupProvider = CheckboxGroupContext.Provider;
const useCheckboxGroupContext = () => (0,react.useContext)(CheckboxGroupContext);



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/Checkbox.module.css.mjs
var Checkbox_module_css_classes = {"checkboxContainer":"xQrET","checkboxInput":"_0FmnM","checkboxInner":"qhpmx","checkboxLabelWrapper":"WWTn2","checkboxLabel":"eDKHW","checkboxIcon":"GJS7K","checkboxWrapper":"_48FCt"};



// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/constants.mjs
var constants = __webpack_require__(43228);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CheckmarkIcon.mjs



const withoutBoundingBoxWidth = {
  large: 24,
  medium: 14,
  small: 14,
  xSmall: 12
};
const CheckmarkIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : withoutBoundingBoxWidth[size];
    iconHeight = constants/* iconSize */.E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "xSmall":
        return /* @__PURE__ */ react.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 16 16",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.9601 3.27002L13.7127 3.92852L6.03151 12.707L2.30005 8.97556L3.00716 8.26845L5.98216 11.2436L12.9601 3.27002Z",
              fill: "currentColor"
            }
          )
        );
      case "small":
        return /* @__PURE__ */ react.createElement(
          "svg",
          {
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            fill: "none",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            ...others
          },
          /* @__PURE__ */ react.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M16.2853 4.5L17 5.15557L8.59735 15.5L3 10.7495L3.57941 9.97664L8.46677 14.1253L16.2853 4.5Z",
              fill: "currentColor"
            }
          )
        );
      case "medium":
      case "large":
      default:
        return /* @__PURE__ */ react.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M21.2853 9L22 9.65557L13.5973 20L8 15.2495L8.57941 14.4766L13.4668 18.6253L21.2853 9Z",
              fill: "currentColor"
            }
          )
        );
    }
  };
  return /* @__PURE__ */ react.createElement(react.Fragment, null, renderIcon());
};
CheckmarkIcon.iconName = "CheckmarkIcon";



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/MinusIcon.mjs



const MinusIcon_withoutBoundingBoxWidth = {
  large: 30,
  medium: 20,
  small: 14,
  xSmall: 10
};
const MinusIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : MinusIcon_withoutBoundingBoxWidth[size];
    iconHeight = constants/* iconSize */.E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "large":
        return /* @__PURE__ */ react.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 40 40",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react.createElement("path", { d: "M5 19.5H35V20.5H5V19.5Z", fill: "white" }),
          /* @__PURE__ */ react.createElement("path", { d: "M5 19.5H35V20.5H5V19.5Z", fill: "currentColor" })
        );
      case "xSmall":
        return /* @__PURE__ */ react.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 16 16",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 7.5H13V8.5H3V7.5Z", fill: "white" }),
          /* @__PURE__ */ react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 7.5H13V8.5H3V7.5Z", fill: "currentColor" })
        );
      case "small":
        return /* @__PURE__ */ react.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 9.5H17V10.5H3V9.5Z", fill: "white" }),
          /* @__PURE__ */ react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 9.5H17V10.5H3V9.5Z", fill: "currentColor" })
        );
      case "medium":
      default:
        return /* @__PURE__ */ react.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react.createElement("path", { d: "M5 14.5H25V15.5H5V14.5Z", fill: "currentColor" }),
          /* @__PURE__ */ react.createElement("path", { d: "M5 14.5H25V15.5H5V14.5Z", fill: "currentColor" })
        );
    }
  };
  return /* @__PURE__ */ react.createElement(react.Fragment, null, renderIcon());
};
MinusIcon.iconName = "MinusIcon";



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/CheckboxIcon.mjs




function CheckIcon({ ...rest }) {
  return /* @__PURE__ */ react.createElement(CheckmarkIcon, { size: "xSmall", withBoundingBox: true, className: (0,clsx/* default */.Z)(rest.className, "kohler-check-icon") });
}
function CheckboxIcon({ indeterminate, ...rest }) {
  if (indeterminate) {
    return /* @__PURE__ */ react.createElement(MinusIcon, { size: "xSmall", withBoundingBox: true, className: (0,clsx/* default */.Z)(rest.className, "kohler-check-icon") });
  }
  return /* @__PURE__ */ react.createElement(CheckIcon, { ...rest });
}



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/Checkbox.mjs
'use client';











const ConditionalWrapper = ({ tooltip, className, children, ...rest }) => {
  if (tooltip) {
    return /* @__PURE__ */ react.createElement(Box/* Box */.x, { className, ...rest }, /* @__PURE__ */ react.createElement(Tooltip, { ...tooltip }, children));
  }
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, { className, ...rest }, children);
};
const Checkbox = (0,factory_utils/* factory */.d5)((props, ref) => {
  const { className, style, id, label, disabled, onChange, indeterminate, checked, tooltip, ...rest } = props;
  const ctx = useCheckboxGroupContext();
  const inputId = useId(id);
  const contextProps = ctx ? {
    checked: ctx.value.includes(rest.value),
    onChange: (event) => {
      ctx.onChange(event);
      onChange?.(event);
    }
  } : {};
  return /* @__PURE__ */ react.createElement(
    ConditionalWrapper,
    {
      className: (0,clsx/* default */.Z)(className, "kohler-checkbox-root", Checkbox_module_css_classes.checkboxWrapper),
      style,
      "data-checked": contextProps.checked || checked || void 0,
      tooltip
    },
    /* @__PURE__ */ react.createElement(Box/* Box */.x, { className: Checkbox_module_css_classes.checkboxContainer }, /* @__PURE__ */ react.createElement(Box/* Box */.x, { className: (0,clsx/* default */.Z)("kohler-checkbox-radio", Checkbox_module_css_classes.checkboxInner) }, /* @__PURE__ */ react.createElement(
      Box/* Box */.x,
      {
        onChange,
        className: (0,clsx/* default */.Z)("kohler-checkbox-radio-input", Checkbox_module_css_classes.checkboxInput),
        component: "input",
        ref,
        id: inputId,
        disabled,
        checked,
        ...rest,
        ...contextProps,
        type: "checkbox"
      }
    ), /* @__PURE__ */ react.createElement(CheckboxIcon, { "aria-hidden": true, className: Checkbox_module_css_classes.checkboxIcon, indeterminate })), /* @__PURE__ */ react.createElement("div", { "data-disabled": disabled || void 0, className: Checkbox_module_css_classes.checkboxLabelWrapper }, label && /* @__PURE__ */ react.createElement(
      Typography/* Typography */.Z,
      {
        component: "label",
        htmlFor: inputId,
        size: "label-regular-m",
        className: Checkbox_module_css_classes.checkboxLabel,
        "data-disabled": disabled || void 0
      },
      label
    )))
  );
});




/***/ }),

/***/ 52386:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ CartBadge; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/constants.mjs
var constants = __webpack_require__(43228);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartEmptyIcon.mjs



const withoutBoundingBoxWidth = {
  large: 34,
  medium: 25,
  small: 18,
  xSmall: 14
};
const CartEmptyIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : withoutBoundingBoxWidth[size];
    iconHeight = constants/* iconSize */.E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.22998 5.79001H6.77605L7.24498 7.78801L26.5559 7.67627L23.2376 20.57H9.22391L5.98398 6.79001H2.22998V5.79001ZM25.263 8.68301L7.47998 8.78501L10.015 19.569H22.462L25.263 8.68301Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M11.27 22.97C11.27 23.5831 10.773 24.08 10.16 24.08C9.54694 24.08 9.04998 23.5831 9.04998 22.97C9.04998 22.357 9.54694 21.86 10.16 21.86C10.773 21.86 11.27 22.357 11.27 22.97Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M22.68 24.08C23.293 24.08 23.79 23.5831 23.79 22.97C23.79 22.357 23.293 21.86 22.68 21.86C22.0669 21.86 21.57 22.357 21.57 22.97C21.57 23.5831 22.0669 24.08 22.68 24.08Z",
        fill: "currentColor"
      }
    )
  );
};
CartEmptyIcon.iconName = "CartEmptyIcon";



// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
const DsmColor = {
  BackgroundPrimary: "var(--background-primary)",
  OverlayDark: "var(--overlay-dark)",
  OverlayMedium: "var(--overlay-medium)",
  OverlayLight: "var(--overlay-light)",
  ContentPrimary: "var(--content-primary)",
  ContentPrimaryHover: "var(--content-primary-hover)",
  ContentSecondary: "var(--content-secondary)",
  ContentTertiary: "var(--content-tertiary)",
  ContentError: "var(--content-error)",
  ContentWarning: "var(--content-warning)",
  ContentSuccess: "var(--content-success)",
  ContentInfo: "var(--content-info)",
  ContentBrand: "var(--content-brand)",
  ContentOnPhoto: "var(--content-on-photo)",
  ContentOnSurfaceBrand: "var(--content-on-surface-brand)",
  ContentOnSurfaceActionPrimary: "var(--content-on-surface-action-primary)",
  ContentOnSurfaceActionSecondary: "var(--content-on-surface-action-secondary)",
  ContentOnSurfaceInfo: "var(--content-on-surface-info)",
  ContentActionDefault: "var(--content-action-default)",
  ContentActionDefaultHover: "var(--content-action-default-hover)",
  ContentActionInactive: "var(--content-action-inactive)",
  ContentOnSurfaceActionInactive: "var(--content-on-surface-action-inactive)",
  ContentPermaWhite: "var(--content-perma-white)",
  ContentOnSurfacePermaWhite: "var(--content-on-surface-perma-white)",
  ContentOnSurfaceError: "var(--content-on-surface-error)",
  BorderPrimary: "var(--border-primary)",
  BorderSecondary: "var(--border-secondary)",
  BorderTertiary: "var(--border-tertiary)",
  BorderNeutralHighContrast: "var(--border-neutral-high-contrast)",
  BorderNeutralMediumContrast: "var(--border-neutral-medium-contrast)",
  BorderNeutralLowContrast: "var(--border-neutral-low-contrast)",
  BorderError: "var(--border-error)",
  BorderWarning: "var(--border-warning)",
  BorderSuccess: "var(--border-success)",
  BorderBrand: "var(--border-brand)",
  BorderPermaWhite: "var(--border-perma-white)",
  SurfacePermaWhite: "var(--surface-perma-white)",
  SurfacePermaDark: "var(--surface-perma-dark)",
  SurfacePermaBlack: "var(--surface-perma-black)",
  SurfaceTransparent: "var(--surface-transparent)",
  SurfaceActionPrimary: "var(--surface-action-primary)",
  SurfaceActionPrimaryHover: "var(--surface-action-primary-hover)",
  SurfaceActionSecondary: "var(--surface-action-secondary)",
  SurfaceActionSecondaryHover: "var(--surface-action-secondary-hover)",
  SurfaceActionBrand: "var(--surface-action-brand)",
  SurfaceActionBrandHover: "var(--surface-action-brand-hover)",
  SurfaceActionInactive: "var(--surface-action-inactive)",
  SurfaceActionInvert: "var(--surface-action-invert)",
  SurfaceActionInvertHover: "var(--surface-action-invert-hover)",
  SurfaceActionUnselected: "var(--surface-action-unselected)",
  SurfaceActionSelected: "var(--surface-action-selected)",
  SurfaceNeutralLowContrast: "var(--surface-neutral-low-contrast)",
  SurfaceNeutralMediumContrast: "var(--surface-neutral-medium-contrast)",
  SurfaceNeutralHighContrast: "var(--surface-neutral-high-contrast)",
  SurfaceError: "var(--surface-error)",
  SurfaceWarning: "var(--surface-warning)",
  SurfaceSuccess: "var(--surface-success)",
  SurfaceInfo: "var(--surface-info)",
  SurfaceHighlightLowContrast: "var(--surface-highlight-low-contrast)",
  SurfaceHighlightMediumContrast: "var(--surface-highlight-medium-contrast)",
  SurfaceColorSwatchDefault: "var(--surface-color-swatch-default)",
  SurfaceColorSwatch1: "var(--surface-color-swatch-1)",
  SurfaceColorSwatch2: "var(--surface-color-swatch-2)",
  SurfaceColorSwatch3: "var(--surface-color-swatch-3)",
  SurfaceColorSwatch4: "var(--surface-color-swatch-4)",
  SurfaceColorSwatch5: "var(--surface-color-swatch-5)",
  SurfaceColorSwatch6: "var(--surface-color-swatch-6)",
  SurfaceColorSwatch7: "var(--surface-color-swatch-7)",
  SurfaceColorSwatch8: "var(--surface-color-swatch-8)",
  SurfaceColorSwatch9: "var(--surface-color-swatch-9)"
};



// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(87338);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(83815);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(29050);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CartBadge/CartBadge.module.css.mjs
var classes = {"cartBadgeRoot":"UEOHe"};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartOneDigitIcon.mjs



const CartOneDigitIcon_withoutBoundingBoxWidth = {
  large: 34,
  medium: 25,
  small: 18,
  xSmall: 15
};
const CartOneDigitIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartOneDigitIcon_withoutBoundingBoxWidth[size];
    iconHeight = constants/* iconSize */.E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M2.34009 5.84998H6.88616L10.129 19.6299H22.5529L25.6398 7.73624H26.666L23.3477 20.63H9.33401L6.09409 6.84998H2.34009V5.84998Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M11.3801 23.03C11.3801 23.643 10.8831 24.14 10.2701 24.14C9.65706 24.14 9.1601 23.643 9.1601 23.03C9.1601 22.4169 9.65706 21.92 10.2701 21.92C10.8831 21.92 11.3801 22.4169 11.3801 23.03Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M22.7901 24.14C23.4031 24.14 23.9001 23.643 23.9001 23.03C23.9001 22.4169 23.4031 21.92 22.7901 21.92C22.177 21.92 21.6801 22.4169 21.6801 23.03C21.6801 23.643 22.177 24.14 22.7901 24.14Z",
        fill: "currentColor"
      }
    )
  );
};
CartOneDigitIcon.iconName = "CartOneDigitIcon";



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartTwoDigitIcon.mjs



const CartTwoDigitIcon_withoutBoundingBoxWidth = {
  large: 34,
  medium: 25,
  small: 17,
  xSmall: 14
};
const CartTwoDigitIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartTwoDigitIcon_withoutBoundingBoxWidth[size];
    iconHeight = constants/* iconSize */.E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M3.55005 5.84998H8.09612L11.339 19.6299H23.7629L25.4246 13.24H26.4508L24.5577 20.63H10.544L7.30405 6.84998H3.55005V5.84998Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M12.5901 23.03C12.5901 23.643 12.0931 24.14 11.4801 24.14C10.867 24.14 10.3701 23.643 10.3701 23.03C10.3701 22.4169 10.867 21.92 11.4801 21.92C12.0931 21.92 12.5901 22.4169 12.5901 23.03Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M24 24.14C24.6131 24.14 25.11 23.643 25.11 23.03C25.11 22.4169 24.6131 21.92 24 21.92C23.387 21.92 22.89 22.4169 22.89 23.03C22.89 23.643 23.387 24.14 24 24.14Z",
        fill: "currentColor"
      }
    )
  );
};
CartTwoDigitIcon.iconName = "CartTwoDigitIcon";



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartThreeDigitIcon.mjs



const CartThreeDigitIcon_withoutBoundingBoxWidth = {
  large: 34,
  medium: 26,
  small: 17,
  xSmall: 14
};
const CartThreeDigitIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartThreeDigitIcon_withoutBoundingBoxWidth[size];
    iconHeight = constants/* iconSize */.E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M3.55005 5.84998H8.09612L11.339 19.6299H23.7629L25.4246 13.24H26.4508L24.5577 20.63H10.544L7.30405 6.84998H3.55005V5.84998Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M12.5901 23.03C12.5901 23.643 12.0931 24.14 11.4801 24.14C10.867 24.14 10.3701 23.643 10.3701 23.03C10.3701 22.4169 10.867 21.92 11.4801 21.92C12.0931 21.92 12.5901 22.4169 12.5901 23.03Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M24 24.14C24.6131 24.14 25.11 23.643 25.11 23.03C25.11 22.4169 24.6131 21.92 24 21.92C23.387 21.92 22.89 22.4169 22.89 23.03C22.89 23.643 23.387 24.14 24 24.14Z",
        fill: "currentColor"
      }
    )
  );
};
CartThreeDigitIcon.iconName = "CartThreeDigitIcon";



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartEmptyBoldIcon.mjs



const CartEmptyBoldIcon_withoutBoundingBoxWidth = {
  large: 34,
  medium: 25,
  small: 18,
  xSmall: 14
};
const CartEmptyBoldIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartEmptyBoldIcon_withoutBoundingBoxWidth[size];
    iconHeight = constants/* iconSize */.E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.97466 5.54004H1.98047V7.04004H5.78643L9.02636 20.82H23.4319L26.8794 7.42443L7.44332 7.53689L6.97466 5.54004ZM10.2135 19.319L7.79563 9.03324L24.9405 8.9349L22.2687 19.319H10.2135Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M10.1605 21.61C9.40936 21.61 8.80047 22.2189 8.80047 22.97C8.80047 23.7212 9.40936 24.33 10.1605 24.33C10.9116 24.33 11.5205 23.7212 11.5205 22.97C11.5205 22.2189 10.9116 21.61 10.1605 21.61Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M22.6805 21.61C21.9294 21.61 21.3205 22.2189 21.3205 22.97C21.3205 23.7212 21.9294 24.33 22.6805 24.33C23.4316 24.33 24.0405 23.7212 24.0405 22.97C24.0405 22.2189 23.4316 21.61 22.6805 21.61Z",
        fill: "currentColor"
      }
    )
  );
};
CartEmptyBoldIcon.iconName = "CartEmptyBoldIcon";



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartOneDigitBoldIcon.mjs



const CartOneDigitBoldIcon_withoutBoundingBoxWidth = {
  large: 34,
  medium: 25,
  small: 18,
  xSmall: 15
};
const CartOneDigitBoldIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartOneDigitBoldIcon_withoutBoundingBoxWidth[size];
    iconHeight = constants/* iconSize */.E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M2.82996 5.8501H7.37603L10.6189 19.63H23.0428L26.1297 7.73636H27.1559L23.8376 20.6301H9.82388L6.58396 6.8501H2.82996V5.8501Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M11.87 23.0301C11.87 23.6431 11.373 24.1401 10.76 24.1401C10.1469 24.1401 9.64996 23.6431 9.64996 23.0301C9.64996 22.4171 10.1469 21.9201 10.76 21.9201C11.373 21.9201 11.87 22.4171 11.87 23.0301Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M23.28 24.1401C23.893 24.1401 24.39 23.6431 24.39 23.0301C24.39 22.4171 23.893 21.9201 23.28 21.9201C22.6669 21.9201 22.17 22.4171 22.17 23.0301C22.17 23.6431 22.6669 24.1401 23.28 24.1401Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M2.82996 5.8501H7.37603L10.6189 19.63H23.0428L26.1297 7.73636H27.1559L23.8376 20.6301H9.82388L6.58396 6.8501H2.82996V5.8501Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M11.87 23.0301C11.87 23.6431 11.373 24.1401 10.76 24.1401C10.1469 24.1401 9.64996 23.6431 9.64996 23.0301C9.64996 22.4171 10.1469 21.9201 10.76 21.9201C11.373 21.9201 11.87 22.4171 11.87 23.0301Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M23.28 24.1401C23.893 24.1401 24.39 23.6431 24.39 23.0301C24.39 22.4171 23.893 21.9201 23.28 21.9201C22.6669 21.9201 22.17 22.4171 22.17 23.0301C22.17 23.6431 22.6669 24.1401 23.28 24.1401Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    )
  );
};
CartOneDigitBoldIcon.iconName = "CartOneDigitBoldIcon";



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartTwoDigitBoldIcon.mjs



const CartTwoDigitBoldIcon_withoutBoundingBoxWidth = {
  large: 34,
  medium: 23,
  small: 18,
  xSmall: 15
};
const CartTwoDigitBoldIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartTwoDigitBoldIcon_withoutBoundingBoxWidth[size];
    iconHeight = constants/* iconSize */.E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    )
  );
};
CartTwoDigitBoldIcon.iconName = "CartTwoDigitBoldIcon";



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartThreeDigitBoldIcon.mjs



const CartThreeDigitBoldIcon_withoutBoundingBoxWidth = {
  large: 34,
  medium: 23,
  small: 18,
  xSmall: 15
};
const CartThreeDigitBoldIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartThreeDigitBoldIcon_withoutBoundingBoxWidth[size];
    iconHeight = constants/* iconSize */.E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    )
  );
};
CartThreeDigitBoldIcon.iconName = "CartThreeDigitBoldIcon";



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CartBadge/CartBadge.utils.mjs


const iconMap = {
  default: {
    0: CartEmptyIcon,
    1: CartOneDigitIcon,
    2: CartTwoDigitIcon,
    3: CartThreeDigitIcon
  },
  bold: {
    0: CartEmptyBoldIcon,
    1: CartOneDigitBoldIcon,
    2: CartTwoDigitBoldIcon,
    3: CartThreeDigitBoldIcon
  }
};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CartBadge/CartBadge.mjs











const CartBadge = (0,factory_utils/* polymorphicFactory */.bq)(
  (props, ref) => {
    const { component = "div", className, digit, thickness = "default", withBoundingBox = true, textColor, ...rest } = props;
    const digitString = digit?.toString();
    const classNames = (0,clsx/* default */.Z)("kohler-cart-badge-root", className, classes.cartBadgeRoot);
    const Icon = digitString && digitString !== "0" ? iconMap[thickness][digitString.length || 0] : CartEmptyIcon;
    return /* @__PURE__ */ react.createElement(
      Box/* Box */.x,
      {
        position: "relative",
        className: classNames,
        component,
        ref,
        textColor: textColor || DsmColor.ContentSecondary,
        ...rest
      },
      /* @__PURE__ */ react.createElement(Icon, { withBoundingBox, style: { maxWidth: "100%", display: "block" } }),
      digitString && digitString !== "0" && /* @__PURE__ */ react.createElement(Flex/* Flex */.k, { align: "center", position: "absolute", right: digitString.length > 2 ? 0 : 4, left: digitString.length > 2 ? 10 : 8, top: 0 }, /* @__PURE__ */ react.createElement(
        Typography/* Typography */.Z,
        {
          component: "span",
          size: "tag-s",
          display: "flex",
          width: "100%",
          justifyContent: "center",
          textColor: textColor || DsmColor.ContentSecondary
        },
        digitString
      ))
    );
  }
);




/***/ }),

/***/ 71998:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image_Image; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(29050);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.constants.mjs
const DEFAULT_IMG_PLACEHOLDER = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/RevealWhenReadyEnhancer.mjs
'use client';


function preload(src) {
  return new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => i.decode?.().catch(() => {
    }).finally(() => resolve());
    i.onerror = () => reject();
    i.src = src;
  });
}
function RevealWhenReadyEnhancer({ children }) {
  const containerRef = (0,react.useRef)(null);
  const [ready, setReady] = (0,react.useState)(false);
  const [errored, setErrored] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const container = containerRef.current;
    if (!container) return;
    const img = container.querySelector("img");
    if (!img) return;
    let cancelled = false;
    const finish = () => !cancelled && setReady(true);
    const fail = () => !cancelled && setErrored(true);
    const dataSrc = img.dataset?.src;
    if (dataSrc) {
      preload(dataSrc).then(() => {
        if (cancelled) return;
        img.src = dataSrc;
        img.removeAttribute("data-src");
        img.decode?.().catch(() => {
        }).finally(finish);
      }).catch(fail);
    } else {
      const onLoad = () => {
        img.decode?.().catch(() => {
        }).finally(finish);
      };
      if (img.complete) onLoad();
      else {
        img.addEventListener("load", onLoad, { once: true });
        img.addEventListener("error", fail, { once: true });
        return () => {
          cancelled = true;
          img.removeEventListener("load", onLoad);
          img.removeEventListener("error", fail);
        };
      }
    }
    return () => {
      cancelled = true;
    };
  }, [children]);
  const invisible = !ready && !errored;
  return /* @__PURE__ */ react.createElement(
    "div",
    {
      ref: containerRef,
      "aria-busy": invisible ? true : void 0,
      style: {
        opacity: invisible ? 0 : 1,
        visibility: invisible ? "hidden" : "visible",
        pointerEvents: invisible ? "none" : "auto",
        transition: "opacity 180ms ease",
        height: "100%",
        width: "100%"
      }
    },
    children
  );
}



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.hook.mjs


function useS7SmartCrop(ref) {
  (0,react.useEffect)(() => {
    const node = ref.current;
    if (!node || node.dataset.mode !== "smartcrop") return;
    const MAX_ATTEMPTS = 3;
    const INTERVAL = 3e3;
    const waitForS7 = () => new Promise((resolve, reject) => {
      let attempts = 0;
      const check = () => {
        if (typeof window.s7responsiveImage === "function") {
          resolve();
        } else if (++attempts < MAX_ATTEMPTS) {
          setTimeout(check, INTERVAL);
        } else {
          reject(new Error("s7responsiveImage not available after 3 attempts"));
        }
      };
      check();
    });
    const applySmartCrop = async () => {
      try {
        await waitForS7();
        window.s7responsiveImage?.(node);
      } catch (err) {
        console.warn(err.message);
      }
    };
    if (document.readyState === "complete") {
      applySmartCrop();
    } else {
      window.addEventListener("load", applySmartCrop);
      return () => window.removeEventListener("load", applySmartCrop);
    }
  }, [ref]);
}



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/SmartCropS7Enhancer.mjs
'use client';



const SmartCropS7Enhancer = ({ children }) => {
  const ref = (0,react.useRef)(null);
  useS7SmartCrop(ref);
  return react.cloneElement(children, { ref });
};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.mjs








const Image_Image = (0,factory_utils/* polymorphicFactory */.bq)((props, ref) => {
  const {
    component = "img",
    src,
    srcSet,
    alt,
    className,
    width = "100%",
    height = "100%",
    objectFit = "cover",
    position = "relative",
    objectPosition = "center",
    reveal = "default",
    inlineSwap = false,
    placeholderSrc = DEFAULT_IMG_PLACEHOLDER,
    ...rest
  } = props;
  const classNames = (0,clsx/* default */.Z)("kohler-image-root", className);
  const isSmartCrop = rest["data-mode"] === "smartcrop";
  const renderSrc = reveal === "when-ready" && inlineSwap && placeholderSrc ? placeholderSrc : src;
  const baseImg = /* @__PURE__ */ react.createElement(
    Box/* Box */.x,
    {
      className: classNames,
      component,
      ref,
      src: renderSrc,
      srcSet,
      alt,
      position,
      width,
      height,
      objectFit,
      objectPosition,
      ...reveal === "when-ready" && inlineSwap ? { "data-src": src } : {},
      ...rest
    }
  );
  const smart = isSmartCrop ? /* @__PURE__ */ react.createElement(SmartCropS7Enhancer, null, baseImg) : baseImg;
  return reveal === "when-ready" ? /* @__PURE__ */ react.createElement(RevealWhenReadyEnhancer, null, smart) : smart;
});




/***/ }),

/***/ 15506:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ BrandLogo; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/BrandLogo.module.css.mjs
var classes = {"root":"iUo1k"};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/AnnSacks.mjs


const AnnSacksLogo = /* @__PURE__ */ react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100", height: "27", viewBox: "0 0 100 27", fill: "none", "aria-label": "Ann Sacks Logo" }, /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34446 26.0693V14.5146H3.44459V26.0693H1.23364V14.4812H0V12.227H1.23364V3.91159C1.23364 1.95797 2.86782 0.355 4.90254 0.355C6.93725 0.355 8.57143 1.94127 8.57143 3.91159V26.0693H6.34446ZM4.8865 2.60917C4.08543 2.60917 3.44457 3.24368 3.44457 4.01176V12.1769H6.34444V4.01176C6.34444 3.24368 5.68756 2.60917 4.8865 2.60917Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7344 25.9852H62.5827V16.2632H59.7638V25.9852H57.6121V16.2295H56.5112V14.1102H57.6121V8.2568C57.6121 6.42341 59.1967 4.92642 61.1649 4.92642C63.1332 4.92642 64.7178 6.42341 64.7178 8.2568L64.7344 25.9852ZM61.265 7.0794C60.481 7.0794 59.8638 7.66811 59.8638 8.39137V14.0934H62.6828V8.39137C62.6828 7.66811 62.0489 7.0794 61.265 7.0794Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M18.5474 5.01053V17.4238L15.2447 5.01053H13.1431V25.9684H15.3115V13.2692L18.6308 25.9684H20.7158V5.01053H18.5474Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M30.4237 5.01053V17.4238L27.1211 5.01053H25.0194V25.9684H27.1878V13.2692L30.4904 25.9684H32.5754V5.01053H30.4237Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M70.856 15.5063V22.6043C70.856 23.3276 71.4898 23.9163 72.2571 23.9163C73.0411 23.9163 73.6582 23.3276 73.6582 22.6043V18.8198H75.81V22.7389C75.81 24.5723 74.2087 26.0693 72.2571 26.0693C70.2889 26.0693 68.7043 24.5723 68.7043 22.7389V8.27362C68.7043 6.44023 70.2889 4.94325 72.2571 4.94325C74.2254 4.94325 75.81 6.44023 75.81 8.27362V12.2095H73.6749V8.40819C73.6749 7.68492 73.0411 7.09622 72.2738 7.09622C71.4898 7.09622 70.8727 7.68492 70.8727 8.40819L70.856 15.5063Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M89.5877 9.43421C89.5877 11.0321 90.2382 12.4114 91.5726 14.1775C93.9745 17.3397 94.5583 18.1638 94.5583 20.3505V22.6043C94.5583 23.3276 93.9245 23.9163 93.1572 23.9163C92.3733 23.9163 91.7561 23.3276 91.7561 22.6043V19.8122H89.6044V22.7221C89.6044 24.5555 91.2057 26.0525 93.1572 26.0525C95.1255 26.0525 96.7101 24.5555 96.7101 22.7221V20.3505C96.7101 18.147 96.4265 17.4238 95.2923 15.5735C94.8568 14.8546 94.3273 14.1822 93.8114 13.5271C92.7463 12.1746 91.7394 10.896 91.7394 9.43421V8.39136C91.7394 7.6681 92.3733 7.0794 93.1405 7.0794C93.9245 7.0794 94.5417 7.6681 94.5417 8.39136V9.97245H96.6934V8.2568C96.6934 6.42341 95.1088 4.92642 93.1405 4.92642C91.1723 4.92642 89.5877 6.42341 89.5877 8.2568V9.43421Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4112 25.9515V24.6227H98.9283C99.0784 24.6227 99.1952 24.6564 99.2619 24.7237C99.3286 24.7909 99.362 24.875 99.362 24.9928C99.362 25.0432 99.3453 25.1105 99.3286 25.1442C99.312 25.1946 99.2953 25.2283 99.2619 25.2619C99.2286 25.2955 99.1952 25.3124 99.1618 25.3292C99.1285 25.346 99.0784 25.3628 99.0284 25.3628L99.4287 25.9515H99.2286L98.8616 25.3628H98.578V25.9515H98.4112ZM98.9452 25.2283C98.9848 25.2283 99.0139 25.2177 99.0492 25.205C99.0584 25.2017 99.0682 25.1981 99.0786 25.1946C99.112 25.1778 99.1453 25.161 99.162 25.1274C99.1787 25.0937 99.1954 25.0433 99.1954 24.9928C99.1954 24.9592 99.1954 24.9087 99.162 24.8751C99.1504 24.8516 99.1306 24.8363 99.1141 24.8235C99.1069 24.818 99.1003 24.8129 99.0953 24.8078C99.0619 24.791 99.0286 24.7741 98.9952 24.7741C98.9785 24.7741 98.9577 24.7699 98.9369 24.7657C98.916 24.7615 98.8951 24.7573 98.8784 24.7573H98.5782V25.2283H98.9452Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.844 26.6407C99.4807 26.6407 100 26.1214 100 25.4847C100 24.8481 99.4807 24.3288 98.844 24.3288C98.2073 24.3288 97.6879 24.8481 97.6879 25.4847C97.6879 26.1214 98.2073 26.6407 98.844 26.6407ZM97.8052 25.4512C97.822 24.8816 98.2744 24.446 98.8441 24.4628C99.3802 24.4795 99.8159 24.9151 99.8326 25.4512C99.8494 26.0041 99.4137 26.4732 98.8441 26.4899H98.7938C98.2241 26.4732 97.7885 26.0208 97.8052 25.4512Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M49.3148 2.63343C48.3095 2.63343 47.4885 3.38732 47.4885 4.3255L47.455 5.79978C47.455 7.60959 48.6695 9.19028 49.9535 10.8616C50.5713 11.6656 51.2051 12.4906 51.7276 13.3722C53.0681 15.6506 53.4199 16.5386 53.4199 19.2526V22.4859C53.4199 24.5466 51.5601 26.2219 49.2813 26.2219C47.0026 26.2219 45.1427 24.5466 45.1427 22.4859V18.6159H47.455V22.2681C47.455 23.2063 48.276 23.9602 49.2813 23.9602C50.2867 23.9602 51.1077 23.2063 51.1077 22.2681V19.3196C51.1077 16.6391 50.4207 15.6339 47.522 11.7472C45.9135 9.58599 45.1427 7.84366 45.1427 5.88354V4.09096C45.1427 2.03032 47.0026 0.355 49.2981 0.355C51.5936 0.355 53.4534 2.03032 53.4534 4.09096V6.55367H51.1412V4.3255C51.1412 3.40408 50.3202 2.63343 49.3148 2.63343Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M86.3446 5.28043L84.8533 14.9973C85.7414 15.6004 86.3278 16.5721 86.3111 17.661V26.1549H84.1496V17.7783C84.1496 17.0579 83.5297 16.4715 82.7422 16.4715H81.6866V26.1549H79.5084V5.28043H81.6866V14.3439H82.0887C82.4908 14.3271 82.8092 14.0758 82.8594 13.7575L84.1161 5.28043H86.3446Z",
    fill: "currentColor"
  }
));



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Kallista.mjs


const KallistaLogo = /* @__PURE__ */ react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "120", height: "20", viewBox: "0 0 120 20", fill: "none", "aria-label": "Kallista Logo" }, /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.0913V1.42895H1.56745V9.70491L9.47533 1.42895H11.5541L3.26383 9.87454L11.9481 19.0913H9.64267L1.56745 10.1274V19.0913H0Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7169 19.0913L20.0385 12.974H27.1958L29.4334 19.0913H31.1688L23.7966 0.389999L16.1038 19.0913H17.7169ZM23.6892 3.76242L26.6812 11.5762H20.577L23.6892 3.76242Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3636 19.6108V0.909476H37.9742V18.0219H44.1558V19.6108H36.3636Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3506 19.6108V0.909476H50.9615V18.0219H57.1428V19.6108H49.3506Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M64.9352 19.0913H66.4936V1.42895H64.9352V19.0913Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2856 16.0683L75.6446 15.305C75.896 16.2068 76.3294 16.9053 76.9471 17.4018C77.5631 17.8982 78.3028 18.146 79.1678 18.146C80.2592 18.146 81.1113 17.8039 81.724 17.1202C82.3368 16.4362 82.6433 15.4904 82.6433 14.2805C82.6433 13.3971 82.438 12.6623 82.0256 12.0782C81.6134 11.4942 80.728 10.8187 79.3691 10.0515C77.6317 9.07567 76.4756 8.21654 75.9025 7.47374C75.3285 6.73159 75.0415 5.83906 75.0415 4.79548C75.0415 3.49464 75.4571 2.43462 76.289 1.61687C77.1208 0.799281 78.1993 0.389999 79.5251 0.389999C80.3926 0.389999 81.1476 0.583561 81.7903 0.970196C82.433 1.35634 82.9553 1.93523 83.3572 2.70802L82.1128 3.49758C81.8614 2.96349 81.5067 2.55519 81.0474 2.27527C80.5882 1.99503 80.044 1.85491 79.4167 1.85491C78.5687 1.85491 77.8936 2.12114 77.3907 2.65246C76.888 3.18491 76.6374 3.90262 76.6374 4.80689C76.6374 6.09632 77.6342 7.29729 79.6285 8.41141C79.9899 8.61263 80.264 8.76806 80.4531 8.87576C81.9277 9.73326 82.9132 10.5432 83.4096 11.3046C83.9068 12.0658 84.1558 13.0535 84.1558 14.2681C84.1558 15.9078 83.7015 17.2082 82.7961 18.17C81.889 19.1303 80.656 19.6108 79.0967 19.6108C77.9608 19.6108 76.9898 19.3149 76.1831 18.7222C75.3745 18.1302 74.7424 17.2458 74.2856 16.0683Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2426 19.0913V2.9296H89.3508V1.42895H100.779V2.9296H95.8441V19.0913H94.2426Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.432 19.0913L105.753 12.974H112.91L115.148 19.0913H116.883L109.511 0.389999L101.818 19.0913H103.432ZM109.404 3.76242L112.396 11.5762H106.292L109.404 3.76242Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.747 17.9782V17.6071H118.991C119.115 17.6071 119.249 17.6346 119.249 17.783C119.249 17.967 119.113 17.9782 118.961 17.9782H118.747ZM118.747 18.1322H118.953L119.265 18.6514H119.465L119.129 18.1239C119.302 18.102 119.436 18.0085 119.436 17.7941C119.436 17.5575 119.297 17.4533 119.018 17.4533H118.568V18.6514H118.747V18.1322ZM118.963 19.0913C119.522 19.0913 120 18.6514 120 18.0499C120 17.4533 119.522 17.0134 118.963 17.0134C118.399 17.0134 117.922 17.4533 117.922 18.0499C117.922 18.6514 118.399 19.0913 118.963 19.0913ZM118.129 18.0499C118.129 17.5575 118.494 17.1867 118.963 17.1867C119.427 17.1867 119.794 17.5575 119.794 18.0499C119.794 18.5499 119.427 18.9183 118.963 18.9183C118.494 18.9183 118.129 18.5499 118.129 18.0499Z",
    fill: "currentColor"
  }
));



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Klafs.mjs


const KlafsLogo = /* @__PURE__ */ react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "82", height: "24", viewBox: "0 0 82 24", fill: "none" }, /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M10.76 1.51999H15.88L7.80004 10.56L16.36 21.12H11L4.20004 12.32V21.12H0.0400391V1.51999H4.20004V9.75999L10.76 1.51999ZM22.44 17.84H29.4V21.12H18.36V1.51999H22.44V17.84ZM59.8 4.79999V9.11999H66.84V12.48H59.8V21.12H55.72V1.51999H66.92V4.79999H59.8ZM79.32 5.83999C78.52 4.87999 77.56 4.23999 76.12 4.23999C74.76 4.23999 73.56 5.19999 73.56 6.47999C73.56 9.75999 81.96 8.39999 81.96 14.96C81.96 18.88 79.32 21.68 75 21.68C72.04 21.68 69.96 20.08 68.44 17.84L71.08 15.44C71.64 16.96 73.16 18.32 74.92 18.32C76.6 18.32 77.64 16.96 77.64 15.44C77.64 13.44 75.64 12.8 73.96 12.24C71.24 11.2 69.24 9.91999 69.24 6.87999C69.24 3.59999 71.88 0.959991 75.48 0.959991C77.4 0.959991 79.96 1.83999 81.24 3.11999L79.32 5.83999ZM54.36 21.12H49.32L42.44 8.95999L35.4 21.12H30.36L42.2 1.03999C42.2 1.03999 50.2 14.24 54.36 21.12Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { d: "M46.92 23.04H37.8L42.2 15.12L46.92 23.04Z", fill: "currentColor" }));



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/KlafsSaunaAndSpa.mjs


const KlafsSaunaAndSpaLogo = /* @__PURE__ */ react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "82", height: "32", viewBox: "0 0 82 32", fill: "none" }, /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M10.76 0.839999H15.88L7.80004 9.88L16.36 20.44H11L4.20004 11.64V20.44H0.0400391V0.839999H4.20004V9.08L10.76 0.839999ZM22.44 17.16H29.4V20.44H18.36V0.839999H22.44V17.16ZM59.8 4.12V8.44H66.84V11.8H59.8V20.44H55.72V0.839999H66.92V4.12H59.8ZM79.32 5.16C78.52 4.2 77.56 3.56 76.12 3.56C74.76 3.56 73.56 4.52 73.56 5.8C73.56 9.08 81.96 7.72 81.96 14.28C81.96 18.2 79.32 21 75 21C72.04 21 69.96 19.4 68.44 17.16L71.08 14.76C71.64 16.28 73.16 17.64 74.92 17.64C76.6 17.64 77.64 16.28 77.64 14.76C77.64 12.76 75.64 12.12 73.96 11.56C71.24 10.52 69.24 9.24 69.24 6.2C69.24 2.92 71.88 0.279999 75.48 0.279999C77.4 0.279999 79.96 1.16 81.24 2.44L79.32 5.16ZM54.36 20.44H49.32L42.44 8.28L35.4 20.44H30.36L42.2 0.359999C42.2 0.359999 50.2 13.56 54.36 20.44Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { d: "M46.92 22.36H37.8L42.2 14.44L46.92 22.36Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M1.00004 26.84L2.60004 30.52L4.20004 26.84L5.08004 31.48H4.60004L4.04004 28.52L2.60004 31.64L1.24004 28.52L0.680039 31.48H0.120039L1.00004 26.84ZM6.92004 27.16H7.48004L8.60004 29.08L9.72004 27.16H10.28L8.84004 29.64V31.48H8.36004V29.64L6.92004 27.16ZM17.64 27.96C17.48 27.64 17.24 27.48 16.92 27.48C16.52 27.48 16.2 27.72 16.2 28.12C16.2 28.52 16.6 28.68 16.92 28.84L17.24 29C17.8 29.24 18.28 29.56 18.28 30.2C18.28 31 17.64 31.56 16.92 31.56C16.2 31.56 15.72 31.08 15.56 30.44L16.04 30.28C16.12 30.76 16.44 31.08 16.92 31.08C17.4 31.08 17.8 30.68 17.8 30.2C17.8 29.72 17.4 29.48 17 29.32L16.76 29.24C16.28 29 15.8 28.76 15.8 28.12C15.8 27.48 16.36 27 17 27C17.48 27 17.88 27.24 18.12 27.64L17.64 27.96ZM22.12 28.04L21.4 29.8H22.84L22.12 28.04ZM21.16 30.28L20.6 31.48H20.04L22.04 26.92L24.04 31.48H23.48L23 30.28H21.16ZM26.6 29.72C26.6 30.04 26.6 30.44 26.76 30.68C26.92 30.92 27.32 31.08 27.64 31.08C27.96 31.08 28.28 30.92 28.52 30.68C28.76 30.44 28.76 30.04 28.76 29.64V27.08H29.24V29.88C29.24 30.36 29.24 30.76 28.84 31.08C28.52 31.4 28.12 31.56 27.64 31.56C27.24 31.56 26.84 31.4 26.52 31.08C26.12 30.68 26.12 30.28 26.12 29.8V27.08H26.6V29.72ZM31.72 31.48H32.2V28.12L35.64 31.72V27.16H35.16V30.52L31.72 26.92V31.48ZM39.8 28.04L39.08 29.8H40.52L39.8 28.04ZM38.84 30.28L38.28 31.48H37.72L39.72 26.92L41.72 31.48H41.16L40.68 30.28H38.84ZM48.92 28.04L48.2 29.8H49.64L48.92 28.04ZM48.04 30.28L47.48 31.48H46.92L48.92 26.92L50.92 31.48H50.36L49.88 30.28H48.04ZM53.08 31.48H53.56V28.12L57 31.72V27.16H56.44V30.52L53.08 26.92V31.48ZM60.36 31.08C60.92 31.08 61.32 31 61.72 30.6C62.04 30.28 62.28 29.8 62.28 29.32C62.28 28.84 62.12 28.36 61.72 28.04C61.32 27.72 60.92 27.64 60.36 27.64H60.04V31.08H60.36ZM60.28 27.16C60.92 27.16 61.48 27.24 61.96 27.72C62.44 28.12 62.68 28.76 62.68 29.4C62.68 30.04 62.44 30.6 61.96 31C61.4 31.48 60.92 31.56 60.2 31.56H59.4V27.16H60.28ZM70.28 27.96C70.12 27.64 69.88 27.48 69.56 27.48C69.16 27.48 68.84 27.72 68.84 28.12C68.84 28.52 69.24 28.68 69.56 28.84L69.88 29C70.44 29.24 70.92 29.56 70.92 30.2C70.92 31 70.28 31.56 69.56 31.56C68.84 31.56 68.36 31.08 68.2 30.44L68.68 30.28C68.76 30.76 69.08 31.08 69.56 31.08C70.04 31.08 70.44 30.68 70.44 30.2C70.44 29.72 70.04 29.48 69.64 29.32L69.4 29.24C68.92 29 68.44 28.76 68.44 28.12C68.44 27.48 69 27 69.64 27C70.12 27 70.52 27.24 70.76 27.64L70.28 27.96ZM73.72 29.16H74.04C74.6 29.16 75 29 75 28.36C75 27.64 74.44 27.56 73.88 27.56H73.72V29.16ZM73.24 31.48V27.08H73.96C74.36 27.08 74.76 27.08 75.08 27.32C75.4 27.56 75.56 27.96 75.56 28.28C75.56 28.6 75.4 29 75.16 29.24C74.84 29.48 74.52 29.56 74.12 29.56H73.8V31.48H73.24ZM78.76 28.04L78.04 29.8H79.48L78.76 28.04ZM77.8 30.28L77.32 31.48H76.76L78.76 26.92L80.76 31.48H80.2L79.72 30.28H77.8Z",
    fill: "currentColor"
  }
));



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Kohler.mjs


const KohlerLogo = /* @__PURE__ */ react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "98", height: "22", viewBox: "0 0 98 22", fill: "none", "aria-label": "Kohler Brand Logo" }, /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4246 21.0039V0.938011H58.8226V15.8755L64.8821 15.8759V21.0039H53.4246Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8363 21.0039V0.938011H41.2343V7.97396H46.6772V0.938011H52.0751V21.0039H46.6772V13.5395H41.2343V21.0039H35.8363Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4953 0.940677L9.69605 10.4966L18.6075 21.0111L11.4631 21.0073L5.40994 13.8491H5.39757L5.39794 21.0039H0V0.938011H5.39757V6.94837L5.35558 6.95332L10.4967 0.940677H17.4953Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7559 15.9475C27.2873 15.9475 29.3401 13.6431 29.3401 10.8005C29.3401 7.95796 27.2873 5.65352 24.7559 5.65352C22.2241 5.65352 20.1714 7.95796 20.1714 10.8005C20.1714 13.6431 22.2241 15.9475 24.7559 15.9475ZM14.5714 10.8043C14.5714 5.03086 19.1312 0.35 24.7559 0.35C30.3803 0.35 34.9401 5.03086 34.9401 10.8043C34.9401 16.5778 30.3803 21.2587 24.7559 21.2587C19.1312 21.2587 14.5714 16.5778 14.5714 10.8043Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9492 0.938011V5.56098L71.5295 5.57317L71.51 8.7402H76.5169V13.2322H71.5175L71.5216 16.2945H76.996V21.0039H65.9913V0.938011H76.9492Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0033 9.45236C86.0537 9.45236 86.9054 8.5871 86.9054 7.51962C86.9054 6.45214 86.0537 5.58688 85.0033 5.58688H83.4739V9.44741L85.0033 9.45236ZM88.1716 12.9854L93.7885 21.0149L87.8946 21.0043L83.4923 14.8439V20.9925H78.2034V0.930394H84.9704C90.9242 0.930394 94.7028 8.51931 88.1716 12.9854Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4177 19.6858C96.6243 19.6858 96.7412 19.6401 96.7412 19.4025C96.7412 19.2105 96.5028 19.2105 96.3233 19.2105H95.9233V19.6858H96.4177ZM97.0741 20.7636H96.6243L96.2108 19.9688H95.9233V20.7636H95.5095V18.8819H96.4087C96.8357 18.8819 97.1277 18.9596 97.1277 19.4569C97.1277 19.8046 96.9527 19.9459 96.6243 19.9688L97.0741 20.7636ZM97.5775 19.8454C97.5775 19.0323 96.9841 18.4569 96.2198 18.4569C95.442 18.4569 94.8621 19.0323 94.8621 19.8454C94.8621 20.6493 95.442 21.2248 96.2198 21.2248C96.9841 21.2248 97.5775 20.6493 97.5775 19.8454ZM94.4396 19.8454C94.4396 18.8362 95.2261 18.0276 96.2198 18.0276C97.2091 18.0276 98 18.8362 98 19.8454C98 20.8458 97.2091 21.6543 96.2198 21.6543C95.2261 21.6543 94.4396 20.8458 94.4396 19.8454Z",
    fill: "currentColor"
  }
));



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/KohlerBold.mjs


const KohlerBoldLogo = /* @__PURE__ */ react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "98", height: "30", viewBox: "0 0 98 30", fill: "none" }, /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9814 5.36964C41.9814 2.40469 39.5681 0 36.5922 0C33.6163 0 31.2029 2.40469 31.2029 5.36964C31.2029 8.33413 33.6163 10.7389 36.5922 10.7389C39.5681 10.7389 41.9814 8.33413 41.9814 5.36964ZM36.5922 0.64506C39.2104 0.64506 41.3338 2.76106 41.3338 5.36964C41.3338 7.97801 39.2104 10.0938 36.5922 10.0938C33.9738 10.0938 31.8504 7.97801 31.8504 5.36964C31.8504 2.76106 33.9738 0.64506 36.5922 0.64506Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.819 10.6262V0.11249H25.5315C25.612 0.111594 25.6926 0.110724 25.7733 0.109634C26.6821 0.0973585 27.6022 0.0849306 28.474 0.346039C30.3015 1.11194 30.5372 4.00614 28.8571 5.06623C29.6825 5.36063 30.5079 5.89079 30.8025 6.77423C31.4215 8.33499 30.331 10.1903 28.7098 10.5142C27.7738 10.663 26.8376 10.6475 25.9016 10.632C25.7782 10.6299 25.6548 10.6279 25.5315 10.6262H24.819ZM25.5315 0.758649V4.85992C25.7873 4.85164 26.048 4.86049 26.3094 4.86936C26.9499 4.8911 27.5941 4.91296 28.1792 4.68328C29.6825 4.09424 29.6529 1.61243 28.1792 0.994175C27.5252 0.768675 26.8367 0.767402 26.1533 0.766138C25.9452 0.765753 25.7375 0.765369 25.5315 0.758649ZM27.3984 10.0024C26.7655 10.0064 26.1125 10.0025 25.5315 9.97978C25.5315 9.57693 25.5289 9.1737 25.5263 8.7703C25.5193 7.68271 25.5123 6.59331 25.5559 5.50784C25.8781 5.5244 26.205 5.52474 26.5332 5.52509C27.376 5.52596 28.2278 5.52685 29.0339 5.80247C30.4194 6.30296 30.6552 8.39387 29.5647 9.30675C28.9729 9.88144 28.198 9.99711 27.3984 10.0024Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { d: "M6.21947 0.10524H0V0.766119H2.77086V10.6262H3.48331V0.766119H6.21947V0.10524Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9556 21.1252C46.9556 16.624 43.3237 12.9745 38.8454 12.9745C34.3669 12.9745 30.735 16.624 30.735 21.1252C30.735 25.6264 34.3669 29.2759 38.8454 29.2759C43.3237 29.2759 46.9556 25.6264 46.9556 21.1252ZM38.8454 17.1184C40.8502 17.1184 42.476 18.9124 42.476 21.1251C42.476 23.3379 40.8502 25.132 38.8454 25.132C36.8405 25.132 35.2146 23.3379 35.2146 21.1251C35.2146 18.9124 36.8405 17.1184 38.8454 17.1184Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M47.5744 13.4455H51.9074V18.908H56.1814V13.4455H60.5144V29.0985H56.1814V23.225H51.9074V29.0985H47.5744V13.4455Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { d: "M61.6346 13.4455H65.9676V25.0605H70.7427V29.0985H61.6346V13.4455Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M80.3813 13.4455H71.627V29.0985H80.3813V25.501H75.9599V23.0488H80.3813V19.4512H75.9599V17.043H80.3813V13.4455Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.687 13.4455H81.354V29.0985H85.687V24.485C85.8575 24.7193 86.0281 24.9543 86.1989 25.1895C87.1499 26.4993 88.1081 27.8191 89.1063 29.0985H93.7634L93.6069 28.8782L93.6063 28.8774C92.1856 26.8782 90.7648 24.8788 89.3125 22.9022C90.5211 22.0253 91.6118 20.8854 91.9064 19.3948C92.555 16.852 90.5505 14.1922 88.0745 13.666C87.285 13.52 86.4876 13.4633 85.687 13.4455ZM85.687 20.1183V17.0642C85.8082 17.0709 85.9311 17.0744 86.0544 17.0779C86.6788 17.0955 87.3125 17.1134 87.7799 17.5535C88.3989 18.0796 88.3989 19.1901 87.7503 19.6871C87.3303 20.1257 86.7275 20.12 86.1414 20.1146C85.9876 20.1131 85.8349 20.1117 85.687 20.1183Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M30.2204 16.8629C29.1033 18.2064 27.9856 19.5507 26.8823 20.9049L33.9566 29.0985H28.2381L23.4334 23.491V29.0985H19.1006V13.4455H23.4334V18.0659L27.5399 13.4519H33.0427C32.1089 14.5914 31.1669 15.7244 30.2249 16.8574L30.2216 16.8614L30.2204 16.8629Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M6.77438 10.6262V0.11249H7.48692V4.53234H13.8487V0.11249H14.5612V10.6262H13.8487V5.19322H7.48692V10.6262H6.77438Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M15.6813 0.11249V10.6262H20.7217V9.96546H16.3939V5.19322H20.7217V4.53234H16.3939V0.773369H20.7217V0.11249H15.6813Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { d: "M42.6813 0.11249V10.6262H47.6924V9.96546H43.3938V0.11249H42.6813Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3407 0.11249V10.6262H49.0534V10.6171C50.7516 10.6526 52.5691 10.6442 53.9119 9.48278C56.4467 7.47905 56.3878 3.14752 53.8234 1.2029C52.5017 0.11037 50.7635 0.113101 49.1192 0.115685L49.0534 0.115786V0.11249H48.3407ZM49.0534 9.98494V0.760846L49.1339 0.760809C50.6102 0.76002 52.2918 0.759122 53.4697 1.82159C55.5329 3.44215 55.6509 6.91924 53.735 8.71664C52.535 10.0039 50.6667 10.0421 49.0534 9.98494Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { d: "M60.0723 0.11249V10.6262H65.0833V9.96546H60.785V0.11249H60.0723Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M86.4469 10.6262V0.11249H87.1596V4.83971L91.9452 0.11249H92.9559L87.841 5.16619L93.2915 10.6262H92.284L87.1596 5.4907V10.6262H86.4469Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { d: "M11.7611 13.3868V23.9005H12.4736V18.4821H15.9034V17.8213H12.4736V14.0476H15.9761V13.3868H11.7611Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66602 13.2795C8.64188 13.2795 11.0553 15.6843 11.0553 18.649C11.0553 21.6136 8.64188 24.0184 5.66602 24.0184C2.69006 24.0184 0.276681 21.6136 0.276681 18.649C0.276681 15.6843 2.69006 13.2795 5.66602 13.2795ZM10.4077 18.649C10.4077 16.0404 8.28431 13.9246 5.66602 13.9246C3.04754 13.9246 0.92428 16.0404 0.92428 18.649C0.92428 21.2575 3.04754 23.3733 5.66602 23.3733C8.28431 23.3733 10.4077 21.2575 10.4077 18.649Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9126 0C71.8885 0 74.3021 2.40469 74.3021 5.36964C74.3021 8.33413 71.8885 10.7389 68.9126 10.7389C65.9367 10.7389 63.5234 8.33413 63.5234 5.36964C63.5234 2.40469 65.9367 0 68.9126 0ZM73.6544 5.36964C73.6544 2.76106 71.531 0.64506 68.9126 0.64506C66.2944 0.64506 64.171 2.76106 64.171 5.36964C64.171 7.97801 66.2944 10.0938 68.9126 10.0938C71.531 10.0938 73.6544 7.97801 73.6544 5.36964Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7566 5.36964C85.7566 2.40469 83.3433 0 80.3674 0C77.3915 0 74.9782 2.40469 74.9782 5.36964C74.9782 8.33413 77.3915 10.7389 80.3674 10.7389C83.3433 10.7389 85.7566 8.33413 85.7566 5.36964ZM80.3674 0.64506C82.9858 0.64506 85.1092 2.76106 85.1092 5.36964C85.1092 7.97801 82.9858 10.0938 80.3674 10.0938C77.749 10.0938 75.6256 7.97801 75.6256 5.36964C75.6256 2.76106 77.749 0.64506 80.3674 0.64506Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0743 29.2173H96.7662L96.515 28.5551H96.1053V29.2173H95.8138V27.6065H96.515C96.71 27.6065 96.8535 27.6503 96.945 27.7382C97.0368 27.8257 97.0824 27.9392 97.0824 28.0785C97.0824 28.2856 96.9854 28.4278 96.7909 28.5056L97.0743 29.2173ZM96.1053 28.3227H96.4678C96.5726 28.3227 96.6509 28.3009 96.7025 28.2566C96.7536 28.2127 96.7792 28.1519 96.7792 28.0749C96.7792 28.0041 96.7541 27.9469 96.7036 27.9033C96.6531 27.8595 96.5823 27.8377 96.4914 27.8377H96.1053V28.3227Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5332 27.2889C97.2447 27.0016 96.8463 26.8238 96.4061 26.8238C95.9659 26.8238 95.5672 27.0016 95.279 27.2889C94.9906 27.5762 94.812 27.9734 94.812 28.4118C94.812 28.8504 94.9906 29.2475 95.279 29.5348C95.5672 29.8221 95.9659 30 96.4061 30C96.8463 30 97.2447 29.8221 97.5332 29.5348C97.8216 29.2475 98 28.8504 98 28.4118C98 27.9734 97.8216 27.5762 97.5332 27.2889ZM96.4061 27.1351C96.7598 27.1351 97.0802 27.2781 97.3122 27.5092C97.544 27.7401 97.6875 28.0594 97.6875 28.4118C97.6875 28.7644 97.544 29.0836 97.3122 29.3146C97.0802 29.5456 96.7598 29.6885 96.4061 29.6885C96.0522 29.6885 95.7318 29.5456 95.5 29.3146C95.268 29.0836 95.1247 28.7644 95.1247 28.4118C95.1247 28.0594 95.268 27.7401 95.5 27.5092C95.7318 27.2781 96.0522 27.1351 96.4061 27.1351Z",
    fill: "currentColor"
  }
));



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Mira.mjs


const MiraLogo = /* @__PURE__ */ react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "80", height: "51", viewBox: "0 0 80 51", fill: "none", "aria-label": "Mira Shower Logo" }, /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M44.1386 35.0481C44.1007 35.0665 44.0629 35.0849 44.0061 35.1032C42.3795 35.7644 38.0669 37.0499 34.057 37.0499C29.9335 37.0499 25.0535 35.2501 22.0082 33.9095C21.1192 33.5238 17.1471 31.8894 11.5862 31.8894C7.00878 31.8894 2.6962 33.836 0.426421 35.2501L0.142699 35.4338C-0.0653639 35.5807 -0.103193 35.9847 0.426421 35.7827C2.54488 35.0114 6.25218 34.0564 10.1297 34.0564C14.6504 34.0564 20.4572 36.3704 22.0082 37.0866C23.4268 37.7477 27.607 39.4557 32.6005 39.4557C36.9888 39.4557 42.0958 36.9764 44.0061 35.6174C44.1385 35.5256 44.252 35.4338 44.3466 35.3603C44.5358 35.2318 44.479 34.9379 44.1386 35.0481Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M37.1968 0.154999H42.3984C43.7225 0.154999 45.7274 0.816129 45.387 3.00153L45.2735 3.53411H38.2372C37.4806 3.53411 36.6672 2.68933 36.8375 2.00984C36.932 1.60581 37.1968 0.154999 37.1968 0.154999Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M75.5372 31.9996C75.4994 32.0179 75.4616 32.0363 75.4048 32.0547C73.7781 32.7158 69.4655 34.0013 65.4556 34.0013C61.3322 34.0013 56.4522 32.2016 53.4069 30.861C52.5179 30.4753 48.5458 28.8408 42.9848 28.8408C38.4074 28.8408 34.0948 30.7875 31.8251 32.2016L31.5413 32.3852C31.3333 32.5321 31.2955 32.9362 31.8251 32.7342C33.9435 31.9628 37.6508 31.0079 41.5284 31.0079C46.049 31.0079 51.8559 33.3218 53.4069 34.0381C54.8255 34.6992 59.0057 36.4071 63.9992 36.4071C68.3874 36.4071 73.4944 33.9279 75.4048 32.5689C75.5372 32.477 75.6507 32.3852 75.7453 32.3118C75.9344 32.2016 75.8777 31.8894 75.5372 31.9996Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M29.3285 5.16857H2.96124L2.60186 7.57436L2.58295 7.70291C2.58295 8.47423 3.9259 8.60279 3.60435 10.3842L3.52869 10.8066L1.46697 22.8171L1.35348 23.4966C1.24 24.1027 1.52372 24.5251 2.05334 24.5251C3.20714 24.5434 7.17925 24.5251 7.17925 24.5251C8.10608 24.5251 8.40871 23.8639 8.46546 23.515C8.48437 23.4415 8.54112 23.2028 8.59786 22.8171C9.10856 20.0257 10.8109 10.072 10.8109 10.072H13.232C14.0453 10.072 14.4425 10.2373 14.2156 11.4677L12.2106 22.7988L12.0782 23.4783C11.9647 24.0843 12.2484 24.5067 12.778 24.5067C13.9318 24.5251 18.0553 24.5067 18.0553 24.5067C18.9821 24.5067 19.2847 23.8456 19.3415 23.4783C19.3604 23.4048 19.3982 23.1661 19.455 22.7988C19.9657 19.9522 21.6869 10.0536 21.6869 10.0536H23.9945C24.8079 10.0536 25.3753 10.1087 25.2051 11.284L23.1434 22.7988L23.0299 23.4599C22.9164 24.0659 23.2001 24.4883 23.7297 24.4883C24.8835 24.5067 28.9313 24.4883 28.9313 24.4883C29.8581 24.4883 30.1607 23.8272 30.2175 23.4599C30.2364 23.3864 30.2742 23.1477 30.331 22.7804C30.8606 19.8053 32.9034 8.25386 32.9034 8.25386C33.1493 6.72958 32.7332 5.16857 29.3285 5.16857Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M40.715 5.16857H36.1754L35.7593 7.57436L35.7404 7.68455C35.7404 8.4375 36.7618 8.63952 36.5916 10.1271L36.4781 10.8066L34.3407 22.8171L34.2272 23.4966C34.1137 24.1027 34.3974 24.5251 34.9271 24.5251C36.0809 24.5434 40.28 24.5251 40.28 24.5251C41.2068 24.5251 41.5094 23.8639 41.5662 23.4966C41.5851 23.4232 41.6418 23.1661 41.6986 22.7988C42.2849 19.7869 44.2521 8.34568 44.2521 8.34568L44.271 8.29059C44.498 6.72958 44.1007 5.16857 40.715 5.16857Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M68.0657 44.9102C68.5764 44.9102 69.106 45.0571 69.5032 45.2591L69.8248 44.1389C69.2573 43.9185 68.6332 43.845 68.0279 43.845C66.7038 43.845 65.4555 44.4694 65.4555 45.8835C65.4555 47.6833 67.8198 47.4813 67.8198 48.7117C67.8198 49.4463 67.1578 49.7585 66.4958 49.7585C65.9094 49.7585 65.342 49.5381 64.7934 49.2994L64.4341 50.4564C65.0583 50.6767 65.7392 50.842 66.4012 50.842C67.9144 50.842 69.2384 50.236 69.2384 48.5831C69.2384 46.7099 66.8741 46.7834 66.8741 45.6999C66.9119 45.0938 67.5739 44.9102 68.0657 44.9102ZM58.2678 46.8385H57.7571L58.1354 45.0204H58.7029C59.2703 45.0204 59.8945 45.0204 59.8945 45.7182C59.9134 46.6181 59.0055 46.8385 58.2678 46.8385ZM58.6083 43.9552H56.9627L55.5063 50.6951H56.8871L57.4923 47.8853H58.0219C58.7785 47.8853 58.7407 48.3811 58.892 49.0974L59.2325 50.6767H60.6889L60.0269 47.9588C59.9323 47.5915 59.7054 47.3527 59.3271 47.3343V47.316C60.462 47.2976 61.351 46.6732 61.351 45.5162C61.351 43.9369 59.8756 43.9552 58.6083 43.9552ZM47.1081 50.6951H51.2315L51.4774 49.6299H48.7348L49.132 47.7384H51.5531L51.7801 46.6732H49.359L49.7183 45.002H52.4232L52.6312 43.9369H48.5645L47.1081 50.6951ZM40.7905 49.1341H40.7716L40.7338 43.9552H38.8612L36.5536 49.1341L36.3456 43.9552H34.9648L35.3998 50.6951H37.1211L39.5611 45.2959H39.58L39.6557 50.6951H41.3958L44.687 43.9552H43.2495L40.7905 49.1341ZM26.7747 49.7585C25.7722 49.7585 25.3182 48.9688 25.3182 48.1057C25.3182 46.7467 26.1505 44.9102 27.7582 44.9102C28.7607 44.9102 29.2336 45.6631 29.2336 46.563C29.2525 47.9036 28.3635 49.7585 26.7747 49.7585ZM27.815 43.845C26.6801 43.845 25.7154 44.2674 24.9778 45.0938C24.2779 45.9019 23.8807 46.9303 23.8807 48.0138C23.8807 49.6116 24.9021 50.8237 26.6044 50.8237C27.7582 50.8237 28.8175 50.4747 29.5362 49.685C30.2739 48.877 30.69 47.7935 30.69 46.6916C30.69 44.9102 29.6875 43.845 27.815 43.845ZM18.3954 46.6916H15.596L16.1824 43.9736H14.8016L13.3451 50.7135H14.7259L15.369 47.7567H18.1684L17.5253 50.7135H18.9061L20.3625 43.9736H18.9818L18.3954 46.6916ZM5.64682 45.8835C5.64682 47.6833 8.01117 47.4813 8.01117 48.7117C8.01117 49.4463 7.34915 49.7585 6.68713 49.7585C6.10077 49.7585 5.53333 49.5381 4.9848 49.2994L4.62542 50.4564C5.24961 50.6767 5.93054 50.842 6.59256 50.842C8.10575 50.842 9.42978 50.236 9.42978 48.5831C9.42978 46.7099 7.06543 46.7834 7.06543 45.6999C7.06543 45.1122 7.72745 44.9286 8.21924 44.9286C8.72994 44.9286 9.25955 45.0755 9.65676 45.2775L9.97831 44.1572C9.41087 43.9369 8.78668 43.8634 8.1814 43.8634C6.8952 43.845 5.64682 44.4694 5.64682 45.8835Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M70.9599 18.2994C70.9031 18.9054 70.6383 19.6951 69.2008 19.64H65.3043C64.699 19.64 64.1883 19.5666 64.3775 18.7402L64.491 17.7301C64.491 17.1791 64.7558 16.8302 65.4367 16.8302H71.1679L70.9599 18.2994ZM76.483 5.16857H59.7812C58.5706 5.16857 56.2819 5.22367 55.2984 7.51927C54.9579 5.68279 53.8798 5.24203 52.0261 5.16857H47.3541L46.9191 7.68455C46.9191 8.40077 48.054 8.47423 47.8081 10.0903L45.5951 22.8171L45.4816 23.4966C45.3681 24.1027 45.6518 24.5251 46.1814 24.5251C47.3352 24.5434 51.3073 24.5251 51.3073 24.5251C52.2342 24.5251 52.5368 23.8639 52.5936 23.4966C52.6125 23.4232 52.6692 23.1661 52.726 22.7988C52.8205 22.3029 54.0689 14.9754 54.0689 14.9754C54.2959 13.3042 55.7902 10.1271 60.2162 10.072H71.5462C72.473 10.072 72.3785 10.4209 72.265 11.082L71.9434 12.7532H61.6916C60.5945 12.7532 59.0435 12.8634 58.5328 15.4896L57.4925 21.2378C57.3223 22.2478 57.2844 24.5251 60.2919 24.5251H74.2321C75.3859 24.5251 77.1639 24.4149 77.6935 21.2929L79.9444 8.69461C80.1714 7.1336 79.8309 5.22367 76.483 5.16857Z",
    fill: "currentColor"
  }
));



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Robern.mjs


const RobernLogo = /* @__PURE__ */ react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100", height: "27", viewBox: "0 0 100 27", fill: "none", "aria-label": "Robern Logo" }, /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6558 16.4847H30.455V0.0400009H34.1223V8.4595C35.8623 6.97832 38.1234 6.08395 40.5961 6.08395C46.0961 6.08395 50.5493 10.5089 50.5493 15.9741C50.5493 21.4392 46.0961 25.8642 40.5961 25.8642C35.2684 25.8642 30.923 21.7122 30.6558 16.4847ZM34.3484 15.9575C34.3484 19.3918 37.1566 22.1822 40.6128 22.1822C40.6627 22.1822 40.7291 22.1822 40.7624 22.1657C44.2186 22.1327 46.9935 19.3093 46.9437 15.875C46.9104 12.4407 44.069 9.68335 40.6128 9.73288C37.1566 9.73288 34.3484 12.5232 34.3484 15.9575Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M7.75129 7.21288C8.15136 7.21288 8.56809 7.24593 8.96816 7.29552V10.601C8.5756 10.601 7.99438 10.6244 7.80962 10.6318C7.7747 10.6332 7.75394 10.634 7.75129 10.634C5.38423 10.6836 3.6006 12.5843 3.6006 15.0799V26.2193H0V15.0799C0 10.4522 3.18386 7.21288 7.75129 7.21288Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M77.913 7.21288C78.3131 7.21288 78.7298 7.24593 79.1299 7.29552V10.601C78.7373 10.601 78.1561 10.6244 77.9713 10.6318C77.9364 10.6332 77.9157 10.634 77.913 10.634C75.546 10.6836 73.7623 12.5843 73.7623 15.0799V26.2193H70.1617V15.0799C70.1617 10.4522 73.3456 7.21288 77.913 7.21288Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M79.9966 15.0138C79.9966 10.3861 83.1804 7.14677 87.7478 7.14677C92.2986 7.14677 95.4825 10.3696 95.4991 14.9973V26.1698H91.8985V14.9973C91.8985 12.5182 90.0649 10.5679 87.7478 10.5679C85.4141 10.5679 83.5972 12.5182 83.5972 14.9973V26.1863H79.9966V15.0138Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8109 21.1785C65.9276 21.0793 66.0443 20.9802 66.1443 20.881C66.1443 20.881 66.1443 25.3434 66.1276 25.3269C65.7109 25.5252 65.2942 25.707 64.8774 25.8392C61.2768 27.0127 57.3262 26.0871 54.6591 23.4427C50.7584 19.5753 50.7584 13.3115 54.6591 9.44407C58.5597 5.57667 64.8774 5.57667 68.7781 9.44407C69.0448 9.70851 69.2948 9.98948 69.5282 10.2704L69.5449 10.287L66.1276 13.6751V13.6916L58.193 21.5586C58.3263 21.6578 58.4764 21.7404 58.6264 21.8231C58.6514 21.8396 58.6764 21.852 58.7014 21.8644C58.7264 21.8768 58.7514 21.8892 58.7764 21.9057C58.8186 21.9266 58.8598 21.9476 58.9004 21.9682C59.0202 22.0291 59.1353 22.0877 59.2598 22.1371C59.4098 22.2032 59.5599 22.2693 59.7266 22.3189C59.8433 22.3685 59.9599 22.4015 60.0766 22.4346C60.0933 22.4428 60.1141 22.447 60.135 22.4511C60.1558 22.4552 60.1766 22.4594 60.1933 22.4676C60.2767 22.4842 60.3559 22.5007 60.435 22.5172C60.5142 22.5337 60.5934 22.5503 60.6767 22.5668C60.6934 22.5668 60.7142 22.5709 60.7351 22.5751C60.7559 22.5792 60.7767 22.5833 60.7934 22.5833C60.8517 22.5916 60.9142 22.5999 60.9768 22.6081C61.0393 22.6164 61.1018 22.6246 61.1601 22.6329L61.3268 22.6494C61.5935 22.666 61.8769 22.666 62.1603 22.6494C62.227 22.6329 62.277 22.6329 62.327 22.6329C62.3405 22.6314 62.3542 22.6299 62.368 22.6284C62.5069 22.6133 62.6572 22.5969 62.7937 22.5668H62.8104C62.9176 22.5562 63.018 22.5319 63.1203 22.5071C63.177 22.4933 63.2344 22.4794 63.2938 22.4676L63.4438 22.4181C63.7772 22.3189 64.094 22.2032 64.4107 22.0545C64.5274 22.0049 64.6274 21.9553 64.7441 21.8892C64.7941 21.8561 64.8274 21.8396 64.8607 21.8231L64.8941 21.8065C64.9608 21.7652 65.0233 21.7239 65.0858 21.6826C65.1483 21.6413 65.2108 21.6 65.2775 21.5586L65.3775 21.4925C65.4942 21.4264 65.5942 21.3438 65.6942 21.2611L65.8109 21.1785ZM64.4941 10.8324C62.0771 9.67545 59.1933 10.1713 57.3096 12.0389C55.426 13.9065 54.9426 16.7657 56.1094 19.1456L64.4941 10.8324Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1497 25.2938H97.783V26.1863H97.4662V24.1038H98.2664C98.7498 24.1038 98.9998 24.2856 98.9998 24.6988C98.9998 25.079 98.7498 25.2442 98.4497 25.2773L99.0498 26.2028H98.6998L98.1497 25.2938ZM97.7831 24.3848V25.0459H98.1498C98.4332 25.0459 98.6665 25.0129 98.6665 24.6988C98.6665 24.4344 98.4332 24.3848 98.2165 24.3848H97.7831Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 25.1451C100 26.2028 99.1665 26.9631 98.1664 26.9631C97.1662 26.9631 96.3161 26.2028 96.3161 25.1451C96.3161 24.1038 97.1662 23.3436 98.1664 23.3436C99.1499 23.3436 100 24.1038 100 25.1451ZM98.1663 23.6411C97.3328 23.6411 96.6827 24.2856 96.6827 25.1451C96.6827 26.021 97.3328 26.6656 98.1663 26.6491C98.9831 26.6491 99.6332 26.021 99.6332 25.1451C99.6332 24.2856 98.9831 23.6411 98.1663 23.6411Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2472 15.9741C29.2472 10.5089 24.794 6.08396 19.2939 6.08396C13.7939 6.08396 9.34068 10.5089 9.34068 15.9741C9.34068 21.4392 13.7939 25.8642 19.2939 25.8642C24.794 25.8642 29.2472 21.4392 29.2472 15.9741ZM25.5749 15.9575C25.5749 19.3918 22.7668 22.1822 19.3105 22.1822C15.8543 22.1822 13.0628 19.3918 13.0461 15.9575C13.0461 12.5233 15.8543 9.73289 19.3105 9.73289C22.7668 9.73289 25.5749 12.5233 25.5749 15.9575Z",
    fill: "currentColor"
  }
));



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Sprig.mjs


const SprigLogo = /* @__PURE__ */ react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "90", height: "51", viewBox: "0 0 90 51", fill: "none", "aria-label": "Sprig Logo" }, /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M24.4297 43.9801C24.8075 43.9801 25.5423 43.9801 26.0934 44.4062C26.492 44.7106 26.7265 45.2377 26.7265 45.8063C26.7265 46.6792 26.1442 47.0341 25.9605 47.1351C26.41 47.2064 26.6745 47.3993 26.849 47.5613C27.2568 47.9472 27.3389 48.4744 27.3389 48.8293C27.3389 49.2255 27.2268 49.7837 26.7566 50.1995C26.2459 50.6462 25.6232 50.7473 25.0316 50.7473H22.7452V43.9789H24.4297V43.9801ZM24.0727 46.7906H24.4505C24.655 46.7906 25.4811 46.7699 25.4811 45.9074C25.4811 45.2883 25.0016 45.0551 24.4609 45.0551H24.0727V46.7906ZM24.0727 49.6723H24.6446C24.8895 49.6723 25.2569 49.6619 25.5527 49.4897C25.8797 49.2967 25.9709 48.9717 25.9709 48.7087C25.9709 48.495 25.8993 48.1298 25.4707 47.938C25.1853 47.8059 24.8479 47.8059 24.5626 47.8059H24.0727V49.6734V49.6723Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M29.0846 47.6531L26.7473 43.9801H28.3197L29.7789 46.3346L31.2381 43.9801H32.8106L30.4121 47.6531V50.7485H29.0857V47.6531H29.0846Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M10.8556 17.304C6.13833 16.5551 5.24988 15.5019 5.03152 13.508C4.77619 11.1776 6.6178 8.54862 10.2225 8.5693C14.2569 8.59227 15.0622 11.1547 15.8582 14.1501H19.1117L19.077 13.9675C19.0597 13.8721 19.0389 13.7779 19.0135 13.6849C18.0869 10.1589 16.1656 7.09686 10.2721 7.04058C5.45437 6.99464 1.33558 9.73392 1.33558 13.6252C1.33558 17.2167 3.64742 19.7607 9.58241 20.6773C13.5556 21.2906 16.2037 22.2496 16.2071 24.9717C16.2106 27.5157 14.6867 29.7335 10.4859 29.6796C5.34461 29.6129 4.3152 26.335 3.5261 23.2282H0C0 23.2282 0.0196408 23.335 0.0820293 23.6015C1.1357 28.3404 4.51277 31.384 10.4362 31.384C15.8062 31.384 19.8026 28.5907 19.8026 24.5502C19.8026 20.8082 17.2781 18.3503 10.8556 17.3028V17.304Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M35.0635 7.09801C34.9456 7.09801 34.8289 7.10031 34.7146 7.1049C32.2456 7.17841 30.3636 8.03752 28.9783 9.42381C26.9807 11.2224 26.1847 13.4081 26.1847 13.4081V7.64816H22.7233V38.4682H26.1847V24.9602C26.1847 24.9602 27.0627 27.4801 29.4104 29.3637C30.761 30.5077 32.5009 31.2324 34.6152 31.3633C34.6626 31.3668 34.7099 31.3691 34.7573 31.3714C34.8174 31.3748 34.8775 31.3771 34.9375 31.3794C35.0623 31.384 35.1871 31.3863 35.3142 31.3863C41.0331 31.3863 44.4945 27.0976 44.4945 19.268C44.4945 11.4384 41.1833 7.09916 35.0635 7.09916V7.09801ZM33.8596 28.3427C29.1943 28.3427 26.1847 25.0015 26.1847 20.1639V18.4181C26.1847 13.3817 29.1943 10.2393 33.8596 10.2393C38.5249 10.2393 41.0331 13.1313 41.0331 19.2657C41.0331 25.4001 38.6751 28.3415 33.8596 28.3415V28.3427Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M50.8004 13.2496V7.64701H47.4395V30.8361H50.9009V18.9165C50.9009 13.3312 53.2081 11.1363 58.3748 11.1363H59.4782V7.39663H58.525C52.4791 7.39663 50.7992 13.2485 50.7992 13.2485L50.8004 13.2496Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M82.9767 27.2458C80.3679 27.2458 77.5593 27.2952 74.8997 27.2952C73.2441 27.2952 72.3418 26.8966 72.3418 25.8492C72.3418 25.2508 72.6421 24.8017 73.0939 24.1539L73.9465 22.9066C75.1007 23.2557 76.4051 23.4051 77.8597 23.4051C84.2811 23.4051 87.5923 20.8622 87.5923 16.3231C87.5923 11.7841 82.0489 10.1887 82.0489 10.1887C84.206 10.3886 85.2342 10.4874 86.4889 10.4874H89.3484V7.64472H78.2617C72.0414 7.64472 68.3789 10.438 68.3789 15.7236C68.3789 19.005 70.023 21.4927 73.1285 22.6436C73.2325 22.6826 69.4823 24.5949 69.4823 26.7944C69.4823 28.3415 70.4585 29.2282 71.8265 29.66C71.8265 29.66 66.9244 30.626 66.9244 34.1256C66.9244 37.2175 69.5331 39.1619 78.2617 39.1619C86.9903 39.1619 90 37.1175 90 32.6784C90 29.2374 87.5414 27.2423 82.9767 27.2423V27.2458ZM71.5896 15.6765C71.5896 12.5341 73.4959 10.5402 77.8597 10.5402C82.2234 10.5402 84.4821 12.4847 84.4821 15.6765C84.4821 18.8683 82.4753 20.7634 77.9105 20.7634C73.3457 20.7634 71.5896 18.9177 71.5896 15.6765ZM78.3622 36.4227C71.741 36.4227 69.8843 35.4751 69.8843 33.1815C69.8843 31.6849 71.2384 29.9403 74.4491 29.9403H83.0275C85.8373 29.9403 87.0412 31.1876 87.0412 32.7829C87.0412 35.1765 85.4364 36.4238 78.3622 36.4238V36.4227Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { d: "M65.2341 7.64701H61.8224V30.8361H65.2341V7.64701Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement("path", { d: "M65.2341 0H61.8224V3.82351H65.2341V0Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement("path", { d: "M53.5617 50.7772V43.9364H55.4414V49.0291H57.5534V50.7772H53.5617Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M47.4326 50.7772V43.9364H49.3135V46.3358H51.2105V43.9364H53.0914V50.7772H51.2105V48.2332H49.3135V50.7772H47.4326Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M41.0424 43.9376L38.325 47.1949L41.4294 50.7806L38.9408 50.7783L36.8312 48.3388H36.8277V50.7772H34.9468V43.9364H36.8277V45.9855L36.8127 45.9877L38.6035 43.9376H41.0424Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M40.0234 47.3005C40.0234 45.3319 41.612 43.7366 43.5714 43.7366C45.5309 43.7366 47.1195 45.3319 47.1195 47.3005C47.1195 49.2691 45.5309 50.8645 43.5714 50.8645C41.612 50.8645 40.0234 49.2691 40.0234 47.3005ZM43.5714 49.0544C44.4541 49.0544 45.1681 48.2688 45.1681 47.2994C45.1681 46.33 44.4529 45.5444 43.5714 45.5444C42.6899 45.5444 41.9736 46.33 41.9736 47.2994C41.9736 48.2688 42.6887 49.0544 43.5714 49.0544Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M61.7577 43.9364V45.5123L59.8698 45.5168L59.8629 46.5965H61.6075V48.1275H59.8652L59.8664 49.1715H61.7738V50.7772H57.9393V43.9364H61.7577Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M65.6685 48.0436L67.6256 50.7818L65.5714 50.7783L64.0372 48.6776V50.7737H62.1944V43.9342H64.5524C66.6263 43.9342 67.9434 46.5218 65.6673 48.0436H65.6685ZM64.564 46.8388C64.9302 46.8388 65.2272 46.5436 65.2272 46.1796C65.2272 45.8155 64.9302 45.5203 64.564 45.5203H64.0314V46.8365H64.564V46.8388Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M67.8521 50.3832C67.8521 50.0387 68.1259 49.763 68.4725 49.763C68.8191 49.763 69.0929 50.0387 69.0929 50.3832C69.0929 50.7278 68.8168 51 68.4725 51C68.1282 51 67.8521 50.7243 67.8521 50.3832ZM68.945 50.3832C68.945 50.1064 68.7382 49.91 68.4725 49.91C68.2068 49.91 68 50.1064 68 50.3832C68 50.66 68.2022 50.853 68.4725 50.853C68.7429 50.853 68.945 50.6566 68.945 50.3832ZM68.7694 50.6968H68.6123L68.4679 50.4257H68.3674V50.6968H68.223V50.0547H68.5361C68.6851 50.0547 68.7868 50.0812 68.7868 50.2511C68.7868 50.3694 68.7255 50.4177 68.6112 50.4257L68.7683 50.6968H68.7694ZM68.5407 50.3293C68.6123 50.3293 68.6539 50.3143 68.6539 50.2328C68.6539 50.1673 68.5707 50.1673 68.5083 50.1673H68.3685V50.3293H68.5407Z",
    fill: "currentColor"
  }
));



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Sterling.mjs


const SterlingLogo = /* @__PURE__ */ react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "120", height: "15", viewBox: "0 0 120 15", fill: "none", "aria-label": "Sterling Logo" }, /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M11.5161 3.1635C10.4365 2.38491 8.74294 1.92197 7.19758 1.92197C5.63105 1.92197 3.64113 2.36387 3.64113 3.71062C3.64113 4.95613 5.66903 5.6167 7.84937 6.32692C10.3842 7.15261 13.125 8.04541 13.125 10.0025C13.125 12.1068 10.0343 14.0638 5.7369 14.0638C4.06452 14.0638 2.37097 13.8954 0.804435 13.4745L0 11.0125C1.63004 12.0226 3.87399 12.6328 6.03327 12.6328C7.5998 12.6328 9.97077 11.9595 9.97077 10.5917C9.97077 9.1723 7.94657 8.52545 5.7685 7.82942C3.23204 7.01886 0.486895 6.14162 0.486895 3.9C0.486895 1.41693 4.04335 0.470001 7.40927 0.470001C8.78528 0.470001 10.1825 0.617302 11.5161 0.911903V3.1635Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M74.4275 3.45729C74.4472 2.55076 74.4733 1.34737 73.125 1.00278V0.938751H78.75V1.00278C77.4098 1.35056 77.4323 2.59048 77.4486 3.48724C77.4503 3.58099 77.4519 3.67099 77.4519 3.75582V11.268C77.4519 11.3527 77.4503 11.4424 77.4486 11.5357C77.4323 12.4291 77.4101 13.652 78.75 13.9997V14.0638H73.125V13.9997C74.4651 13.6713 74.4427 12.4332 74.4264 11.5366C74.4247 11.4429 74.4231 11.3529 74.4231 11.268V3.75582C74.4231 3.66161 74.4253 3.56102 74.4275 3.45729Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M22.257 11.5366L22.257 2.50025H24.7536C25.6711 2.50025 26.7807 2.58465 27.1434 3.28099H27.2288L28.125 0.938751H28.0396C27.6769 1.06536 27.2288 1.08646 26.7594 1.08646H15.7062C15.6069 1.07418 15.5058 1.06548 15.4039 1.05671C15.1556 1.03533 14.9027 1.01356 14.6607 0.938751H14.5753L13.5938 3.28099H13.6791C14.554 2.71126 15.7916 2.50025 16.9865 2.50025H19.4191V11.2995C19.4191 11.3835 19.4206 11.4725 19.4222 11.565C19.4374 12.4483 19.4583 13.6566 18.2028 14.0004V14.0638H23.708V14.0004C22.2565 13.3972 22.2567 12.6298 22.257 11.5366Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M33.8732 12.4125L37.2192 12.6454C38.9632 12.7724 40.7883 12.349 42.1064 11.4811H42.1875L40.9911 14.0638H30V14.0002C31.2258 13.6706 31.2099 12.4176 31.1985 11.5261C31.1974 11.4445 31.1964 11.3651 31.1964 11.2906V3.83895C31.1964 3.7545 31.1978 3.6655 31.1993 3.5732C31.2135 2.6707 31.2326 1.45378 30 1.10811V1.0446H38.4359C38.5177 1.0446 38.5994 1.04602 38.6805 1.04743C39.0421 1.05372 39.3914 1.05979 39.6729 0.938751H39.7541V3.24621H39.6729C38.8618 2.52645 37.7667 2.46294 36.55 2.46294C35.6172 2.46294 34.7047 2.48411 33.853 2.61113V6.31577H36.9962C37.422 6.31577 37.8479 6.31577 38.152 6.18875H38.2332V8.28452H38.152C37.7407 7.73247 36.7052 7.73336 35.8858 7.73406L33.853 7.73411L33.8732 12.4125Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M54.9929 4.16131C54.9929 2.34729 52.9688 0.960093 49.2614 0.960093L42.6562 0.938751V1.00278C43.9177 1.34737 43.8933 2.55062 43.8749 3.45715C43.8728 3.5612 43.8707 3.66134 43.8707 3.75582V11.268C43.8707 11.3599 43.8728 11.4578 43.8749 11.56C43.8933 12.4546 43.9184 13.6741 42.6562 13.9997V14.0638H47.9403V13.9997C46.6453 13.6706 46.6654 12.4458 46.6802 11.5361C46.6818 11.4431 46.6832 11.3532 46.6832 11.268V2.32595C47.3011 2.26192 47.919 2.1979 48.5582 2.17656C50.4119 2.13387 52.1378 2.96619 52.1378 4.39607C52.1378 6.27412 49.5597 7.02107 47.3438 7.25582L49.9432 10.0302L53.2884 13.0607C54.1193 13.8077 55.0355 14.0638 56.5057 14.0638H59.0625C57.4858 13.3381 55.7386 12.3138 54.5668 11.268L50.5824 7.66131C52.8622 7.29851 54.9929 5.91131 54.9929 4.16131Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M66.9893 12.6339C68.7679 12.7192 70.3242 12.2497 71.6379 11.4174H71.7188L70.3444 14.0638H59.5312V13.9997C60.753 13.6674 60.7371 12.4042 60.7258 11.5054C60.7247 11.4229 60.7237 11.3434 60.7237 11.268V3.75582C60.7237 3.67064 60.7251 3.58086 60.7266 3.48776C60.7407 2.57792 60.7597 1.35126 59.5312 1.00278V0.938751H64.5639V1.00278C63.3666 1.34755 63.3905 2.56909 63.4079 3.46389C63.4099 3.56606 63.4118 3.66397 63.4118 3.75582V12.4418L66.9893 12.6339Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M84.8946 11.3964L84.8946 3.72073L94.0683 12.2774C95.2407 13.4155 96.084 14.0688 97.9763 14.5325V3.4889C97.9763 2.37189 97.9763 1.59209 99.375 1.00198V0.938751H94.6648V1.00198C96.0639 1.58375 96.0637 2.37036 96.0635 3.44259L96.0634 10.9497L86.2727 1.845L85.9025 1.44457C85.6968 1.29704 85.594 1.19166 85.4911 0.959827V0.938751H81.5831V1.00198C82.9817 1.59209 82.9817 2.39297 82.9817 3.4889V11.3501C82.9817 12.4671 82.9817 13.2469 81.5625 13.8581V13.9213H86.2933V13.8581C84.8941 13.2555 84.8943 12.4686 84.8946 11.3964Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M115.084 3.10445C113.991 2.1982 111.949 1.92422 110.299 1.92422C106.113 1.92422 102.917 3.9264 102.917 7.10881C102.917 10.2701 106.361 12.6728 110.588 12.6728C111.826 12.6728 113.104 12.5463 114.321 12.2934V9.4482C114.321 8.54195 114.3 7.57247 113.084 7.21419V7.15096H117.188V7.21419C117.043 7.44602 117.043 7.76215 117.043 8.05721V12.5885C117.043 12.6178 117.043 12.6474 117.043 12.6771C117.041 12.946 117.039 13.2269 117.188 13.4736L117.069 13.4899C114.965 13.7794 112.899 14.0638 110.774 14.0638C103.906 14.0638 99.8438 11.3028 99.8438 7.34064C99.8438 3.10445 104.422 0.470001 110.918 0.470001C112.341 0.470001 113.743 0.596455 115.125 0.807211L115.166 3.10445H115.084Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.723 13.1874H118.887V12.7798H119.011C119.135 12.7798 119.217 12.8206 119.238 12.9632C119.258 13.1059 119.3 13.1874 119.32 13.2282H119.506C119.485 13.1874 119.464 13.1263 119.444 12.9632C119.423 12.8002 119.361 12.7186 119.258 12.6983C119.361 12.6575 119.464 12.576 119.464 12.4333C119.464 12.3314 119.423 12.2499 119.361 12.2091C119.3 12.1684 119.196 12.1276 119.032 12.1276C118.887 12.1276 118.805 12.1276 118.723 12.148V13.1874ZM119.011 12.6167H118.887V12.2499H119.011C119.196 12.2499 119.258 12.3314 119.258 12.4333C119.258 12.576 119.155 12.6167 119.011 12.6167Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 12.6575C120 12.1276 119.588 11.72 119.073 11.72C118.537 11.72 118.125 12.1276 118.125 12.6575C118.125 13.1874 118.558 13.595 119.073 13.595C119.588 13.595 120 13.1874 120 12.6575ZM118.31 12.6575C118.31 12.2091 118.661 11.8627 119.073 11.8627C119.485 11.8627 119.835 12.2091 119.835 12.6575C119.835 13.1059 119.485 13.4523 119.073 13.4523C118.661 13.4523 118.31 13.1059 118.31 12.6575Z",
    fill: "currentColor"
  }
));



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/StudioKohlerLarge.mjs


const StudioKohlerLargeLogo = /* @__PURE__ */ react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "173", height: "22", viewBox: "0 0 173 22", fill: "none", "aria-label": "Studio Kohler Logo" }, /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.635 0.35C95.1038 0.35 90.6338 4.9736 90.6338 10.6586C90.6338 16.3557 95.1158 20.9671 100.642 20.9671C106.169 20.9671 110.643 16.3394 110.643 10.6504C110.639 4.95734 106.157 0.35 100.635 0.35ZM105.14 10.6463C105.14 13.4522 103.122 15.7254 100.638 15.7254C98.158 15.7294 96.1363 13.4603 96.1363 10.6504C96.1323 7.85264 98.154 5.57947 100.634 5.57947C103.126 5.5754 105.14 7.84857 105.14 10.6463Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M1.85996 14.2167C1.77623 18.2913 4.63528 19.5397 8.19613 19.5397C10.2338 19.5397 13.336 18.4011 13.336 15.518C13.336 13.2733 11.1589 12.3827 9.34055 11.9395L5.01808 10.8578C2.73323 10.2763 0.639782 9.19458 0.639782 6.08778C0.639782 4.14806 1.86395 0.512618 7.33084 0.512618C11.1908 0.512618 14.5084 2.59059 14.5084 6.66929H12.6582C12.5226 3.67228 10.1301 2.12295 7.35476 2.12295C4.82668 2.12295 2.486 3.12331 2.486 6.05931C2.486 7.9177 3.81783 8.72286 5.42082 9.08072L10.154 10.2722C12.9014 11.0204 15.1862 12.2688 15.1862 15.4854C15.1862 16.8436 14.6439 21.1419 7.76149 21.1419C3.16787 21.1419 -0.205571 19.0355 0.00975459 14.2086H1.85996V14.2167Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M20.4615 6.42532H23.3166V7.89332H20.4615V17.5431C20.4615 18.6817 20.625 19.3446 21.8492 19.43C22.3396 19.43 22.8301 19.4015 23.3166 19.3446V20.841C23.0574 20.841 22.8062 20.8553 22.555 20.8695C22.3038 20.8837 22.0525 20.898 21.7933 20.898C19.5085 20.898 18.719 20.1213 18.7469 17.6814V7.89332H16.2985V6.42532H18.7469V2.12703H20.4615V6.42532Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M34.9763 20.7353H36.5554V6.4253H34.8407V13.9361C34.8407 16.8477 33.5647 19.678 30.6259 19.678C27.9064 19.678 26.9534 18.3198 26.8737 15.7416V6.4253H25.159V15.7172C25.159 19.0762 26.5188 21.1541 30.0796 21.1541C32.1731 21.1541 34.0233 20.0724 34.9205 18.1571H34.9763V20.7353Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4147 20.7353H50.9938V0.935533H49.2791V9.14578H49.2233C48.5135 7.0922 46.4201 6.01051 44.3545 6.01051C40.0839 6.01051 38.0463 9.50363 38.0463 13.5823C38.0463 17.661 40.0839 21.1541 44.3545 21.1541C46.3962 21.1541 48.6252 19.9057 49.3589 18.0189H49.4147V20.7353ZM49.2788 13.5783C49.2788 16.5428 47.9749 19.678 44.3582 19.678C41.0964 19.678 39.7646 16.5428 39.7646 13.5783C39.7646 10.6138 41.0964 7.47857 44.3582 7.47857C47.9749 7.47857 49.2788 10.6138 49.2788 13.5783Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { d: "M53.6861 0.935533H55.4007V3.73735H53.6861V0.935533Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement("path", { d: "M53.6861 6.4253H55.4007V20.7353H53.6861V6.4253Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0174 21.1501C68.288 21.1501 70.6526 17.6813 70.6526 13.5783C70.6526 9.47517 68.288 6.00645 64.0174 6.00645C59.7468 6.00645 57.3822 9.4711 57.3822 13.5783C57.3822 17.6854 59.7468 21.1501 64.0174 21.1501ZM64.0177 19.6779C60.7559 19.6779 59.0971 16.5996 59.0971 13.5782C59.0971 10.5568 60.7559 7.47846 64.0177 7.47846C67.2795 7.47846 68.9383 10.5568 68.9383 13.5782C68.9383 16.5996 67.2795 19.6779 64.0177 19.6779Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { d: "M128.787 0.919272L128.795 20.6987L140.048 20.6946V15.6359H134.102L134.094 0.915205L128.787 0.919272Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M111.528 20.7069L111.512 0.927442L116.816 0.923376L116.82 7.86488L122.163 7.85674L122.159 0.923376L127.463 0.919309L127.471 20.6987H122.171V13.3424L116.82 13.3506L116.828 20.7028L111.528 20.7069Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M85.8488 10.3658L93.5008 0.939642H86.6303L81.622 6.82175V0.939642L76.3226 0.943708L76.3306 20.7231H81.626L81.622 13.6718H81.634L87.5873 20.7231H94.6054L85.8488 10.3658Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M151.89 0.903043L146.443 0.915243H141.128L141.14 20.6947L151.95 20.6865L151.942 16.0426L146.567 16.0467V13.0334L151.475 13.0212L151.471 8.60091H146.551L146.575 5.47785L151.89 5.46158V0.903043Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.442 20.6865L162.92 12.7731C169.331 8.36505 165.619 0.886771 159.769 0.894904L153.126 0.89897L153.138 20.6743L158.326 20.6703V14.6112L162.644 20.6865H168.442ZM161.676 7.38502C161.676 8.43825 160.834 9.29221 159.806 9.29221L158.302 9.28814V5.48597L159.798 5.48191C160.834 5.48191 161.676 6.3318 161.676 7.38502Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.621 20.7475H171.979L171.337 19.7512C171.712 19.739 172.011 19.5845 172.011 19.1534C172.011 18.6858 171.637 18.5801 171.258 18.5801H170.325L170.329 20.7475H170.624V19.7472H170.983L171.621 20.7475ZM171.078 19.4476C171.349 19.453 171.712 19.4603 171.712 19.1494C171.708 18.9258 171.421 18.8892 171.189 18.8892H170.623V19.4422C170.623 19.4463 170.982 19.4463 170.982 19.4463C171.012 19.4463 171.045 19.4469 171.078 19.4476Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.1 19.678C169.1 18.5719 169.962 17.6977 171.05 17.6977C172.139 17.6977 173 18.5719 173 19.674C173.004 20.776 172.143 21.6543 171.054 21.6543C169.962 21.6543 169.1 20.7841 169.1 19.678ZM172.701 19.674C172.701 18.7468 171.935 18.0026 171.054 18.0026C170.165 18.0026 169.407 18.7468 169.407 19.678C169.407 20.6093 170.165 21.3494 171.062 21.3494C171.943 21.3453 172.701 20.6052 172.701 19.674Z",
    fill: "currentColor"
  }
));



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/StudioKohlerSmall.mjs


const StudioKohlerSmallLogo = /* @__PURE__ */ react.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "120", height: "15", viewBox: "0 0 120 15", fill: "none", "aria-label": "Studio Kohler Logo" }, /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8043 0.389999C65.968 0.389999 62.8674 3.4753 62.8674 7.26884C62.8674 11.0705 65.9763 14.1477 69.8098 14.1477C73.6434 14.1477 76.7467 11.0597 76.7467 7.26341C76.7439 3.46445 73.6351 0.389999 69.8043 0.389999ZM72.9296 7.26067C72.9296 9.13302 71.53 10.6499 69.8068 10.6499C68.0864 10.6526 66.6841 9.13844 66.6841 7.26338C66.6814 5.39647 68.0837 3.87959 69.8041 3.87959C71.5328 3.87688 72.9296 5.39375 72.9296 7.26067Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M1.29015 9.64316C1.23206 12.3621 3.21522 13.1952 5.68518 13.1952C7.09856 13.1952 9.25043 12.4354 9.25043 10.5115C9.25043 9.01362 7.74025 8.41935 6.47899 8.12357L3.48075 7.40177C1.89588 7.01374 0.44378 6.29193 0.44378 4.21878C0.44378 2.92442 1.29291 0.498513 5.08497 0.498513C7.76237 0.498513 10.0636 1.88513 10.0636 4.60682H8.78023C8.68619 2.60694 7.02664 1.57308 5.10157 1.57308C3.34798 1.57308 1.7244 2.24061 1.7244 4.19979C1.7244 5.43988 2.64821 5.97716 3.7601 6.21595L7.04324 7.01102C8.94895 7.51031 10.5338 8.34337 10.5338 10.4898C10.5338 11.3961 10.1576 14.2643 5.38369 14.2643C2.19737 14.2643 -0.142593 12.8587 0.00676619 9.63773H1.29015V9.64316Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M14.193 4.44402H16.1734V5.42361H14.193V11.8629C14.193 12.6226 14.3064 13.065 15.1555 13.1219C15.4957 13.1219 15.8359 13.1029 16.1734 13.065V14.0635C15.9936 14.0635 15.8193 14.073 15.6451 14.0825C15.4708 14.092 15.2966 14.1015 15.1168 14.1015C13.5319 14.1015 12.9843 13.5832 13.0036 11.9551V5.42361H11.3054V4.44402H13.0036V1.5758H14.193V4.44402Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M24.261 13.993H25.3563V4.44401H24.167V9.45593C24.167 11.3988 23.2819 13.2875 21.2434 13.2875C19.3571 13.2875 18.696 12.3811 18.6407 10.6607V4.44401H17.4514V10.6445C17.4514 12.8858 18.3945 14.2725 20.8645 14.2725C22.3166 14.2725 23.6 13.5507 24.2223 12.2726H24.261V13.993Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2761 13.993H35.3714V0.780721H34.1821V6.25937H34.1433C33.651 4.88903 32.1989 4.16723 30.7662 4.16723C27.8039 4.16723 26.3905 6.49816 26.3905 9.21985C26.3905 11.9415 27.8039 14.2725 30.7662 14.2725C32.1823 14.2725 33.7285 13.4394 34.2374 12.1803H34.2761V13.993ZM34.1818 9.21717C34.1818 11.1953 33.2774 13.2875 30.7687 13.2875C28.5062 13.2875 27.5824 11.1953 27.5824 9.21717C27.5824 7.239 28.5062 5.14685 30.7687 5.14685C33.2774 5.14685 34.1818 7.239 34.1818 9.21717Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { d: "M37.2389 0.780721H38.4283V2.65035H37.2389V0.780721Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement("path", { d: "M37.2389 4.44401H38.4283V13.993H37.2389V4.44401Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4051 14.2698C47.3674 14.2698 49.0076 11.9551 49.0076 9.21713C49.0076 6.47917 47.3674 4.16451 44.4051 4.16451C41.4428 4.16451 39.8027 6.47645 39.8027 9.21713C39.8027 11.9578 41.4428 14.2698 44.4051 14.2698ZM44.4053 13.2874C42.1428 13.2874 40.9922 11.2333 40.9922 9.2171C40.9922 7.20093 42.1428 5.14678 44.4053 5.14678C46.6678 5.14678 47.8185 7.20093 47.8185 9.2171C47.8185 11.2333 46.6678 13.2874 44.4053 13.2874Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement("path", { d: "M89.3319 0.769871L89.3374 13.9686L97.1428 13.9658V10.5902H93.0188L93.0133 0.767157L89.3319 0.769871Z", fill: "currentColor" }), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M77.3607 13.974L77.3497 0.775323L81.0283 0.772609L81.0311 5.40463L84.7374 5.3992L84.7347 0.772609L88.4133 0.769896L88.4189 13.9686H84.743V9.05978L81.0311 9.0652L81.0366 13.9713L77.3607 13.974Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M59.5483 7.07346L64.8561 0.783463H60.0904L56.6164 4.70856V0.783463L52.9405 0.786177L52.9461 13.9849H56.6192L56.6164 9.27957H56.6247L60.7542 13.9849H65.6222L59.5483 7.07346Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    d: "M105.357 0.759042L101.579 0.767182H97.8921L97.9004 13.9659L105.399 13.9604L105.393 10.8616L101.665 10.8643V8.85355L105.07 8.84541L105.067 5.89578H101.654L101.67 3.81178L105.357 3.80093V0.759042Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.839 13.9604L113.008 8.67988C117.455 5.73839 114.88 0.748183 110.823 0.75361L106.215 0.756324L106.223 13.9523L109.821 13.9496V9.9064L112.817 13.9604H116.839ZM112.145 5.08443C112.145 5.78724 111.561 6.35708 110.848 6.35708L109.805 6.35437V3.8172L110.842 3.81449C111.561 3.81449 112.145 4.38162 112.145 5.08443Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.043 14.0011H119.292L118.847 13.3363C119.107 13.3282 119.314 13.2251 119.314 12.9374C119.314 12.6254 119.054 12.5548 118.791 12.5548H118.144L118.147 14.0011H118.352V13.3336H118.601L119.043 14.0011ZM118.667 13.1337C118.855 13.1373 119.106 13.1422 119.106 12.9347C119.104 12.7855 118.905 12.7611 118.744 12.7611H118.351V13.1301C118.351 13.1328 118.6 13.1328 118.6 13.1328C118.621 13.1328 118.644 13.1333 118.667 13.1337Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ react.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.295 13.2875C117.295 12.5494 117.892 11.966 118.647 11.966C119.403 11.966 120 12.5494 120 13.2848C120.003 14.0201 119.405 14.6063 118.65 14.6063C117.892 14.6063 117.295 14.0256 117.295 13.2875ZM119.793 13.2848C119.793 12.6661 119.261 12.1695 118.65 12.1695C118.033 12.1695 117.508 12.6661 117.508 13.2875C117.508 13.9089 118.033 14.4027 118.656 14.4027C119.267 14.4 119.793 13.9062 119.793 13.2848Z",
    fill: "currentColor"
  }
));



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/BrandLogo.utils.mjs













const BrandLogoPath = {
  Kohler: KohlerLogo,
  "Kohler Bold": KohlerBoldLogo,
  "Studio Kohler Large": StudioKohlerLargeLogo,
  "Studio Kohler Small": StudioKohlerSmallLogo,
  "Ann Sacks": AnnSacksLogo,
  Sterling: SterlingLogo,
  Kallista: KallistaLogo,
  Robern: RobernLogo,
  Mira: MiraLogo,
  Sprig: SprigLogo,
  Klafs: KlafsLogo,
  "Klafs Sauna and Spa": KlafsSaunaAndSpaLogo
};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/BrandLogo.mjs





const BrandLogo = ({ brand, className, ...rest }) => {
  const classNames = (0,clsx/* default */.Z)(classes.root, "kohler-brand-logo-root", className);
  const LogoSvg = BrandLogoPath[brand];
  if (!LogoSvg) {
    console.error(`Brand logo not found for brand: ${brand}`);
    return null;
  }
  return /* @__PURE__ */ react.createElement(LogoSvg.type, { ...LogoSvg.props, className: classNames, ...rest });
};




/***/ }),

/***/ 87338:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Typography; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(29050);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.module.css.mjs
var classes = {"root":"dTpXP","typographySizeH1":"_4VhMK","typographySizeH2":"rhd5n","typographySizeH3":"-XwLj","typographySizeH4":"QtmrM","typographySizeH5":"x-xNT","typographySizeH6":"XCPqO","typographySizeSmall":"_6Ovd0","typographySizeMedium":"zJ-0f","typographySizeLarge":"HDkX-","typographySizeTitleL":"fCgbw","typographySizeTitleM":"_8sPbT","typographySizeTitleS":"vcyFX","typographySizeLabelRegularXL":"jgb0M","typographySizeLabelRegularL":"N6j3c","typographySizeLabelRegularM":"D51Nl","typographySizeLabelRegularS":"B6qqv","typographySizeLabelRegularXS":"h5KJY","typographySizeLabelMediumXL":"S4iBM","typographySizeLabelMediumL":"_3UgoI","typographySizeLabelMediumM":"liVBY","typographySizeLabelMediumS":"bBUuT","typographySizeLabelMediumXS":"Kil4C","typographySizeLabelBoldL":"p1yGT","typographySizeLabelBoldM":"konty","typographySizeLabelBoldS":"_5VBYq","typographySizeButtonXL":"v6t3t","typographySizeButtonL":"UUATQ","typographySizeButtonM":"_358uw","typographySizeButtonS":"faKTj","typographySizeTagM":"OLsuS","typographySizeTagS":"M6Ttk","typographySizeOverline":"bE0N7","typographySizeCaptionM":"VwuCD","typographySizeCaptionS":"_8LxoF","typographySizeDisplayL":"Y-1s4","typographySizeDisplayM":"bLMPG","typographySizeNavigationBrandSwitcher":"TjkF6","typographySizeNavigationOverlayTitle":"hR1uu","typographySizeNavigationOverlayItemL":"Ni38f","typographySizeNavigationOverlayItemM":"kZM2K","typographySizeNavigationOverlayItemS":"_6C-0Q","typographySizeNavigationOverlayItemMRegular":"NyMGn","typographySizeNavigationOverlayItemMBold":"NWnLl","typographySizeNavigationOverlayCategory":"QBa-z","typographySizeNavigationL":"ba4A8","typographySizeNavigationM":"pRuiV","typographySizeNavigationS":"C7jwk","typographySizeNavigationSelected":"_0AmT3","typographySizeNavigationUnselected":"Y5FB-"};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.utils.mjs


const typographySizeClasses = {
  "display-l": classes.typographySizeDisplayL,
  "display-m": classes.typographySizeDisplayM,
  "paragraph-small": classes.typographySizeSmall,
  "paragraph-medium": classes.typographySizeMedium,
  "paragraph-large": classes.typographySizeLarge,
  h1: classes.typographySizeH1,
  h2: classes.typographySizeH2,
  h3: classes.typographySizeH3,
  h4: classes.typographySizeH4,
  h5: classes.typographySizeH5,
  h6: classes.typographySizeH6,
  "title-l": classes.typographySizeTitleL,
  "title-m": classes.typographySizeTitleM,
  "title-s": classes.typographySizeTitleS,
  "label-regular-xl": classes.typographySizeLabelRegularXL,
  "label-regular-l": classes.typographySizeLabelRegularL,
  "label-regular-m": classes.typographySizeLabelRegularM,
  "label-regular-s": classes.typographySizeLabelRegularS,
  "label-regular-xs": classes.typographySizeLabelRegularXS,
  "label-medium-xl": classes.typographySizeLabelMediumXL,
  "label-medium-l": classes.typographySizeLabelMediumL,
  "label-medium-m": classes.typographySizeLabelMediumM,
  "label-medium-s": classes.typographySizeLabelMediumS,
  "label-medium-xs": classes.typographySizeLabelMediumXS,
  "label-bold-l": classes.typographySizeLabelBoldL,
  "label-bold-m": classes.typographySizeLabelBoldM,
  "label-bold-s": classes.typographySizeLabelBoldS,
  "button-xl": classes.typographySizeButtonXL,
  "button-l": classes.typographySizeButtonL,
  "button-m": classes.typographySizeButtonM,
  "button-s": classes.typographySizeButtonS,
  "caption-m": classes.typographySizeCaptionM,
  "caption-s": classes.typographySizeCaptionS,
  "tag-m": classes.typographySizeTagM,
  "tag-s": classes.typographySizeTagS,
  overline: classes.typographySizeOverline,
  "navigation-brand-switcher": classes.typographySizeNavigationBrandSwitcher,
  "navigation-overlay-title": classes.typographySizeNavigationOverlayTitle,
  "navigation-overlay-item-l": classes.typographySizeNavigationOverlayItemL,
  "navigation-overlay-item-m": classes.typographySizeNavigationOverlayItemM,
  "navigation-overlay-item-s": classes.typographySizeNavigationOverlayItemS,
  "navigation-overlay-item-m-regular": classes.typographySizeNavigationOverlayItemMRegular,
  "navigation-overlay-item-m-bold": classes.typographySizeNavigationOverlayItemMBold,
  "navigation-overlay-category": classes.typographySizeNavigationOverlayCategory,
  "navigation-l": classes.typographySizeNavigationL,
  "navigation-m": classes.typographySizeNavigationM,
  "navigation-s": classes.typographySizeNavigationS,
  "navigation-selected": classes.typographySizeNavigationSelected,
  "navigation-unselected": classes.typographySizeNavigationUnselected
};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs







const Typography = (0,factory_utils/* polymorphicFactory */.bq)(
  (props, ref) => {
    const { size = "paragraph-medium", inherit, className, component, children, ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(
      classes.root,
      className,
      size && typographySizeClasses[size],
      `dsm-typography-${typeof component === "string" ? component : "p"}-${size}${rest.mod ? `-${rest.mod}` : ""}`
    );
    return /* @__PURE__ */ react.createElement(Box/* Box */.x, { className: classNames, component: component || "p", ref, ...rest, ...{ "data-inherit": inherit || void 0 } }, children);
  }
);




/***/ }),

/***/ 13534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ AspectRatioKeeper; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(83815);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.module.css.mjs
var classes = {"root":"-EXaH"};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.utils.mjs
const aspectRatioKeeperClasses = {
  "1:1": "1/1",
  "5:4": "5/4",
  "4:5": "4/5",
  "4:3": "4/3",
  "3:4": "3/4",
  "3:2": "3/2",
  "2:3": "2/3",
  "16:10": "16/10",
  "10:16": "10/16",
  "Golden ratio": "1.618/1",
  "Golden ratio Portrait": "1/1.618",
  "16:9": "16/9",
  "9:16": "9/16",
  "2:1": "2/1",
  "1:2": "1/2",
  "21:9": "21/9",
  "9:21": "9/21",
  A4: "297/210",
  "A4 Portrait": "210/297",
  Letter: "11/8.5",
  "Letter Portrait": "8.5/11",
  none: "unset"
};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.mjs







const AspectRatioKeeper = (0,factory_utils/* polymorphicFactory */.bq)(
  (props, ref) => {
    const { component = "figure", className, aspectRatio, style, ...rest } = props;
    const ar = aspectRatio ? aspectRatioKeeperClasses[aspectRatio] : void 0;
    const classNames = (0,clsx/* default */.Z)("kohler-aspect-ratio-keeper-root", className, classes.root);
    return /* @__PURE__ */ react.createElement(
      Flex/* Flex */.k,
      {
        className: classNames,
        component,
        ref,
        style: ar ? { ...style, ["--ar"]: ar } : style,
        ...rest
      }
    );
  }
);




/***/ }),

/***/ 83815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ Flex; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(29050);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(18543);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(95408);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 3 modules
var styleProps = __webpack_require__(50287);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(27051);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.module.css.mjs
var classes = {"root":"VBOmU"};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.utils.mjs
const FLEX_STYLE_PROPS_DATA = {
  gap: { type: "spacing", property: "gap" },
  rowGap: { type: "spacing", property: "rowGap" },
  columnGap: { type: "spacing", property: "columnGap" },
  align: { type: "identity", property: "alignItems" },
  justify: { type: "identity", property: "justifyContent" },
  wrap: { type: "identity", property: "flexWrap" },
  direction: { type: "identity", property: "flexDirection" }
};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs











const Flex = (0,factory_utils/* polymorphicFactory */.bq)(
  (props, ref) => {
    const { component = "div", className, gap, rowGap, columnGap, align, justify, wrap, direction, style, ...rest } = props;
    const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
    const parsedStyleProps = (0,styleProps/* parseStyleProps */.nM)({
      styleProps: (0,helpers/* removeEmptyProps */.t_)({
        gap,
        rowGap,
        columnGap,
        align,
        justify,
        wrap,
        direction
      }),
      data: FLEX_STYLE_PROPS_DATA
    });
    const classNames = (0,clsx/* default */.Z)(classes.root, className, "kohler-flex-root", parsedStyleProps.hasResponsiveStyles && responsiveClassName);
    const parsedStyles = {
      ...style,
      ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
    };
    return /* @__PURE__ */ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ react.createElement(InlineStyles/* InlineStyles */.f, { selector: `.${responsiveClassName}`, styles: parsedStyleProps.styles, media: parsedStyleProps.media }), /* @__PURE__ */ react.createElement(Box/* Box */.x, { ref, className: classNames, style: parsedStyles, component, ...rest }));
  }
);




/***/ }),

/***/ 82931:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Grid; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(29050);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(18543);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 3 modules
var styleProps = __webpack_require__(50287);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(27051);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.module.css.mjs
var Grid_module_css = __webpack_require__(17823);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.utils.mjs
const GRID_STYLE_PROPS_DATA = {
  rowGap: { type: "spacing", property: "rowGap" }
};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.mjs










const Grid = (0,factory_utils/* polymorphicFactory */.bq)(
  (props, ref) => {
    const { component = "div", className, children, rowGap, style, ...rest } = props;
    const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
    const parsedStyleProps = (0,styleProps/* parseStyleProps */.nM)({
      styleProps: { rowGap },
      data: GRID_STYLE_PROPS_DATA
    });
    const classNames = (0,clsx/* default */.Z)(Grid_module_css/* default.root */.Z.root, className, "kohler-grid-root", parsedStyleProps.hasResponsiveStyles && responsiveClassName);
    const parsedStyles = {
      ...style,
      ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
    };
    return /* @__PURE__ */ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ react.createElement(InlineStyles/* InlineStyles */.f, { selector: `.${responsiveClassName}`, styles: parsedStyleProps.styles, media: parsedStyleProps.media }), /* @__PURE__ */ react.createElement(Box/* Box */.x, { component, ref, className: classNames, style: parsedStyles, ...rest }, children));
  }
);




/***/ }),

/***/ 17823:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ classes; }
/* harmony export */ });
var classes = {"root":"q1PW5","gridColumnSpan":"LSXaq","gridColumnSpanSmall":"H62Zj","gridColumnFull":"vsBEc"};




/***/ }),

/***/ 60216:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ GridColumn; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(29050);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(18543);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 3 modules
var styleProps = __webpack_require__(50287);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(27051);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.module.css.mjs
var Grid_module_css = __webpack_require__(17823);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.utils.mjs
const GRID_COLUMN_STYLE_PROPS_DATA = {
  gridColumn: { type: "identity", property: "gridColumn" },
  gridColumnEnd: { type: "identity", property: "gridColumnEnd" },
  gridColumnStart: { type: "identity", property: "gridColumnStart" }
};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.mjs










const GridColumn = (0,factory_utils/* factory */.d5)((props, ref) => {
  const { className, span, spanSmall, gridColumnStart, gridColumn, gridColumnEnd, fullWidth = true, style, ...rest } = props;
  const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
  const parsedStyleProps = (0,styleProps/* parseStyleProps */.nM)({
    styleProps: { gridColumn, gridColumnStart, gridColumnEnd },
    data: GRID_COLUMN_STYLE_PROPS_DATA
  });
  const styleVars = {
    ...span ? { ["--span"]: String(span) } : {},
    ...spanSmall ? { ["--span-small"]: String(spanSmall) } : {}
  };
  const parsedStyles = {
    ...style,
    ...styleVars,
    ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
  };
  const classNames = (0,clsx/* default */.Z)(
    className,
    !span && !spanSmall && fullWidth && Grid_module_css/* default.gridColumnFull */.Z.gridColumnFull,
    span && Grid_module_css/* default.gridColumnSpan */.Z.gridColumnSpan,
    spanSmall && Grid_module_css/* default.gridColumnSpanSmall */.Z.gridColumnSpanSmall
  );
  return /* @__PURE__ */ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ react.createElement(InlineStyles/* InlineStyles */.f, { selector: `.${responsiveClassName}`, styles: parsedStyleProps.styles, media: parsedStyleProps.media }), /* @__PURE__ */ react.createElement(Box/* Box */.x, { ref, className: classNames, ...rest, style: parsedStyles }));
});




/***/ }),

/***/ 35384:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ Tab; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(87338);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(83815);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Tab/Tab.module.css.mjs
var classes = {"tab":"YhILP","tabHorizontal":"exTIC","tabVertical":"_2ShWU","tabSelected":"fkAYT","horizontalTabBar":"A3jW0","verticalTabBar":"CsShe","verticalTabBarUnselected":"CAUrL","verticalTabBarSelected":"BXqTp"};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Tab/Tab.utils.mjs


const tabTypeClasses = {
  horizontal: classes.tabHorizontal,
  vertical: classes.tabVertical
};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Tab/Tab.mjs








const Tab = (0,factory_utils/* polymorphicFactory */.bq)(
  (props, ref) => {
    const { text, component = "button", isSelected = false, variant = "horizontal", className, ...rest } = props;
    const isHorizontal = variant === "horizontal";
    return /* @__PURE__ */ react.createElement(Flex/* Flex */.k, { direction: isHorizontal ? "column" : "row" }, !isHorizontal && /* @__PURE__ */ react.createElement("div", { className: (0,clsx/* default */.Z)(classes.verticalTabBar, isSelected ? classes.verticalTabBarSelected : classes.verticalTabBarUnselected) }), /* @__PURE__ */ react.createElement(
      Typography/* Typography */.Z,
      {
        component,
        size: isHorizontal ? "label-medium-l" : "label-medium-m",
        type: component === "button" ? "button" : void 0,
        className: (0,clsx/* default */.Z)(
          classes.tab,
          className,
          tabTypeClasses[variant],
          "kohler-tab-root",
          (rest["aria-expanded"] || isSelected) && classes.tabSelected
        ),
        ref,
        ...rest
      },
      text
    ), isSelected && isHorizontal && /* @__PURE__ */ react.createElement("div", { className: classes.horizontalTabBar }));
  }
);




/***/ }),

/***/ 29050:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ Box; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(54022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 3 modules
var utils_styleProps = __webpack_require__(50287);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(27051);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(18543);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(95408);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.utils.mjs



const BOX_STYLE_PROPS_DATA = {
  margin: { type: "spacing", property: "margin" },
  marginTop: { type: "spacing", property: "marginTop" },
  marginBottom: { type: "spacing", property: "marginBottom" },
  marginLeft: { type: "spacing", property: "marginLeft" },
  marginRight: { type: "spacing", property: "marginRight" },
  marginInlineStart: { type: "spacing", property: "marginInlineStart" },
  marginInlineEnd: { type: "spacing", property: "marginInlineEnd" },
  marginInline: { type: "spacing", property: "marginInline" },
  marginBlock: { type: "spacing", property: "marginBlock" },
  padding: { type: "spacing", property: "padding" },
  paddingTop: { type: "spacing", property: "paddingTop" },
  paddingBottom: { type: "spacing", property: "paddingBottom" },
  paddingLeft: { type: "spacing", property: "paddingLeft" },
  paddingRight: { type: "spacing", property: "paddingRight" },
  paddingInlineStart: { type: "spacing", property: "paddingInlineStart" },
  paddingInlineEnd: { type: "spacing", property: "paddingInlineEnd" },
  paddingInline: { type: "spacing", property: "paddingInline" },
  paddingBlock: { type: "spacing", property: "paddingBlock" },
  backgroundColor: { type: "color", property: "background" },
  textColor: { type: "textColor", property: "color" },
  opacity: { type: "identity", property: "opacity" },
  width: { type: "spacing", property: "width" },
  minWidth: { type: "spacing", property: "minWidth" },
  maxWidth: { type: "spacing", property: "maxWidth" },
  height: { type: "spacing", property: "height" },
  minHeight: { type: "spacing", property: "minHeight" },
  maxHeight: { type: "spacing", property: "maxHeight" },
  fontFamily: { type: "fontFamily", property: "fontFamily" },
  fontSize: { type: "fontSize", property: "fontSize" },
  fontWeight: { type: "identity", property: "fontWeight" },
  letterSpacing: { type: "size", property: "letterSpacing" },
  textAlign: { type: "identity", property: "textAlign" },
  lineHeight: { type: "lineHeight", property: "lineHeight" },
  fontStyle: { type: "identity", property: "fontStyle" },
  textTransform: { type: "identity", property: "textTransform" },
  textDecoration: { type: "identity", property: "textDecoration" },
  position: { type: "identity", property: "position" },
  display: { type: "identity", property: "display" },
  objectFit: { type: "identity", property: "objectFit" },
  objectPosition: { type: "identity", property: "objectPosition" },
  zIndex: { type: "identity", property: "zIndex" },
  left: { type: "spacing", property: "left" },
  right: { type: "spacing", property: "right" },
  top: { type: "spacing", property: "top" },
  bottom: { type: "spacing", property: "bottom" },
  border: { type: "identity", property: "border" },
  borderTop: { type: "identity", property: "borderTop" },
  borderBottom: { type: "identity", property: "borderBottom" },
  borderRight: { type: "identity", property: "borderRight" },
  borderLeft: { type: "identity", property: "borderLeft" },
  borderRadius: { type: "identity", property: "borderRadius" },
  borderColor: { type: "color", property: "borderColor" },
  justifyContent: { type: "identity", property: "justifyContent" },
  cursor: { type: "identity", property: "cursor" },
  whiteSpace: { type: "identity", property: "whiteSpace" },
  visibility: { type: "identity", property: "visibility" },
  boxShadow: { type: "identity", property: "boxShadow" }
};
function extractStyleProps(others) {
  const {
    margin,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    marginInlineStart,
    marginInlineEnd,
    marginInline,
    marginBlock,
    padding,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingInlineStart,
    paddingInlineEnd,
    paddingInline,
    paddingBlock,
    opacity,
    width,
    minWidth,
    maxWidth,
    height,
    minHeight,
    maxHeight,
    display,
    textColor,
    backgroundColor,
    fontFamily,
    fontSize,
    fontWeight,
    letterSpacing,
    textAlign,
    textTransform,
    position,
    lineHeight,
    fontStyle,
    textDecoration,
    objectFit,
    objectPosition,
    zIndex,
    left,
    right,
    top,
    bottom,
    border,
    borderRight,
    borderTop,
    borderLeft,
    borderBottom,
    borderRadius,
    borderColor,
    justifyContent,
    cursor,
    whiteSpace,
    visibility,
    boxShadow,
    ...rest
  } = others;
  const styleProps = (0,helpers/* removeEmptyProps */.t_)({
    margin,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    marginInlineStart,
    marginInlineEnd,
    marginInline,
    marginBlock,
    padding,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingInlineStart,
    paddingInlineEnd,
    paddingInline,
    paddingBlock,
    opacity,
    width,
    minWidth,
    maxWidth,
    height,
    minHeight,
    maxHeight,
    display,
    textColor,
    backgroundColor,
    fontFamily,
    fontSize,
    fontWeight,
    letterSpacing,
    textAlign,
    textTransform,
    position,
    lineHeight,
    fontStyle,
    textDecoration,
    objectFit,
    objectPosition,
    zIndex,
    left,
    right,
    top,
    bottom,
    border,
    borderRight,
    borderTop,
    borderLeft,
    borderBottom,
    borderRadius,
    borderColor,
    justifyContent,
    cursor,
    whiteSpace,
    visibility,
    boxShadow
  });
  return { styleProps, rest };
}



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs








const Box = (0,factory_utils/* createPolymorphicComponent */.Fm)(
  (0,react.forwardRef)(({ component, className, style, mod, renderRoot, trackingAttributes, ...rest }, ref) => {
    const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
    const { styleProps, rest: restFiltered } = extractStyleProps(rest);
    const parsedStyleProps = (0,utils_styleProps/* parseStyleProps */.nM)({
      styleProps,
      data: BOX_STYLE_PROPS_DATA
    });
    const Element = component || "div";
    const props = {
      ref,
      className: (0,clsx/* default */.Z)(mod && `${mod}-mod`, className, parsedStyleProps.hasResponsiveStyles && responsiveClassName) || void 0,
      style: {
        ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {},
        ...style
      },
      ...restFiltered,
      ...trackingAttributes
    };
    return /* @__PURE__ */ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ react.createElement(InlineStyles/* InlineStyles */.f, { selector: `.${responsiveClassName}`, styles: parsedStyleProps.styles, media: parsedStyleProps.media }), typeof renderRoot === "function" ? renderRoot(props) : /* @__PURE__ */ react.createElement(Element, { ...props }));
  })
);




/***/ }),

/***/ 18543:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ InlineStyles; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(95408);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.utils.mjs



function stylesToString({ selector, styles, media }) {
  const baseStyles = styles ? cssObjectToString(styles) : "";
  const mediaQueryStyles = !Array.isArray(media) ? [] : media.map((item) => `@media ${item.query}{${selector}{${cssObjectToString(item.styles)}}}`);
  return `${baseStyles ? `${selector}{${baseStyles}}` : ""}${mediaQueryStyles.join("")}`.trim();
}
function cssObjectToString(css) {
  return (0,helpers/* keys */.XP)(css).reduce((acc, rule) => css[rule] !== void 0 ? `${acc}${(0,helpers/* camelToKebabCase */.Kh)(rule)}:${css[rule]};` : acc, "").trim();
}



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs



function InlineStyles({ selector, styles, media }) {
  return /* @__PURE__ */ react.createElement(
    "style",
    {
      "data-kohler-styles": "inline",
      dangerouslySetInnerHTML: {
        __html: stylesToString({ selector, styles, media })
      }
    }
  );
}




/***/ }),

/***/ 37390:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yx": function() { return /* binding */ useMergedRef; }
/* harmony export */ });
/* unused harmony exports assignRef, mergeRefs */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (typeof ref === "object" && ref !== null && "current" in ref) {
    ref.current = value;
  }
}
function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => assignRef(ref, node));
  };
}
function useMergedRef(...refs) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(mergeRefs(...refs), refs);
}




/***/ }),

/***/ 54022:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fm": function() { return /* binding */ createPolymorphicComponent; },
/* harmony export */   "bq": function() { return /* binding */ polymorphicFactory; },
/* harmony export */   "d5": function() { return /* binding */ factory; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function createPolymorphicComponent(component) {
  return component;
}
function polymorphicFactory(ui) {
  const Component = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ui);
  return Component;
}
function factory(ui) {
  const Component = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ui);
  return Component;
}




/***/ }),

/***/ 95408:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kh": function() { return /* binding */ camelToKebabCase; },
/* harmony export */   "Q1": function() { return /* binding */ pxToRem; },
/* harmony export */   "XP": function() { return /* binding */ keys; },
/* harmony export */   "rW": function() { return /* binding */ omitText; },
/* harmony export */   "t_": function() { return /* binding */ removeEmptyProps; }
/* harmony export */ });
/* unused harmony exports assignRef, clamp, debounce */
function camelToKebabCase(value) {
  return value.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}
function removeEmptyProps(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v != null));
}
function pxToRem(pxValue, baseFontSize = 16) {
  if (typeof pxValue === "number") {
    pxValue = pxValue.toString() + "px";
  }
  if (pxValue.endsWith("px")) {
    const px = parseFloat(pxValue);
    const remValue = px / baseFontSize;
    return remValue + "rem";
  }
  return pxValue.toString();
}
function keys(object) {
  return Object.keys(object);
}
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (typeof ref === "object" && ref !== null && "current" in ref) {
    ref.current = value;
  }
}
function clamp(value, min, max) {
  if (min === void 0 && max === void 0) {
    return value;
  }
  if (min !== void 0 && max === void 0) {
    return Math.max(value, min);
  }
  if (min === void 0 && max !== void 0) {
    return Math.min(value, max);
  }
  return Math.min(Math.max(value, min), max);
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function");
}
function debounce(func, wait, options) {
  let lastArgs;
  let lastThis;
  let maxWait;
  let result;
  let timerId;
  let lastCallTime;
  let lastInvokeTime = 0;
  let leading = false;
  let maxing = false;
  let trailing = true;
  if (typeof func !== "function") {
    throw new TypeError("Expected a function");
  }
  wait = +wait || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    const args = lastArgs;
    const thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function startTimer(pendingFunc, milliseconds) {
    return setTimeout(pendingFunc, milliseconds);
  }
  function cancelTimer(id) {
    clearTimeout(id);
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = startTimer(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    const timeSinceLastCall = time - (lastCallTime || 0);
    const timeSinceLastInvoke = time - lastInvokeTime;
    const timeWaiting = wait - timeSinceLastCall;
    return maxing ? Math.min(timeWaiting, (maxWait || 0) - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    const timeSinceLastCall = time - (lastCallTime || 0);
    const timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= (maxWait || 0);
  }
  function timerExpired() {
    const time = Date.now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = startTimer(timerExpired, remainingWait(time));
    return void 0;
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      cancelTimer(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(Date.now());
  }
  function pending() {
    return timerId !== void 0;
  }
  const debounced = function(...args) {
    const time = Date.now();
    const isInvoking = shouldInvoke(time);
    lastArgs = args;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        timerId = startTimer(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = startTimer(timerExpired, wait);
    }
    return result;
  };
  debounced.cancel = cancel;
  debounced.flush = flush;
  debounced.pending = pending;
  return debounced;
}
function omitText(obj) {
  const { text: _, ...rest } = obj;
  return rest;
}




/***/ }),

/***/ 27051:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lR": function() { return /* binding */ useDidUpdate; },
/* harmony export */   "m2": function() { return /* binding */ useRandomClassName; },
/* harmony export */   "sm": function() { return /* binding */ useWindowEvent; }
/* harmony export */ });
/* unused harmony exports useIsomorphicLayoutEffect, useUnmount */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useRandomClassName() {
  const randomId = Math.random().toString(36).substring(2, 10);
  return `__m__-${randomId}`;
}
function useWindowEvent(type, listener, options) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    window.addEventListener(type, listener, options);
    return () => window.removeEventListener(type, listener, options);
  }, [type, listener]);
}
function useDidUpdate(fn, dependencies) {
  const mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(
    () => () => {
      mounted.current = false;
    },
    []
  );
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (mounted.current) {
      return fn();
    }
    mounted.current = true;
    return void 0;
  }, dependencies);
}
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
function useUnmount(func) {
  const funcRef = useRef(func);
  funcRef.current = func;
  useEffect(
    () => () => {
      funcRef.current();
    },
    []
  );
}




/***/ }),

/***/ 3465:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useIsomorphicEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


const useIsomorphicEffect = typeof document !== "undefined" ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;




/***/ }),

/***/ 81962:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27051);
/* harmony import */ var _use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3465);




const eventListenerOptions = { passive: true };
function useWindowSize() {
  const getSize = () => ({
    width: typeof window !== "undefined" ? window.innerWidth : 0,
    height: typeof window !== "undefined" ? window.innerHeight : 0
  });
  const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getSize);
  const updateSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setWindowSize(getSize());
  }, []);
  (0,_hooks_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .sm)("resize", updateSize, eventListenerOptions);
  (0,_hooks_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .sm)("orientationchange", updateSize, eventListenerOptions);
  (0,_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicEffect */ .Y)(() => {
    updateSize();
  }, []);
  return windowSize;
}




/***/ }),

/***/ 50287:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nM": function() { return /* binding */ parseStyleProps; }
});

// UNUSED EXPORTS: cssObjectToString, getBaseValue, getBreakpointKeys, getBreakpointValue, hasResponsiveStyles, stylesToString

;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/breakpoints.mjs
const BREAKPOINTS = {
  xl: 1920,
  l: 1600,
  m: 1024,
  s: 640,
  xs: 320
};



// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(95408);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/mediaQuery.mjs
function replaceMediaQuery(query) {
  return query.replace("(width <", "").replace("px)", "");
}
function sortMediaQueries({ media, ...props }) {
  const breakpoints = Object.keys(media);
  const sortedMedia = breakpoints.sort((a, b) => Number(replaceMediaQuery(b)) - Number(replaceMediaQuery(a))).map((query) => ({ query, styles: media[query] }));
  return { ...props, media: sortedMedia };
}



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/resolvers.mjs


function colorResolver(color) {
  if (typeof color === "string") return color;
  return color;
}
function fontFamilyResolver(fontFamily) {
  const fontFamilyValues = {
    text: "var(--serif-font-family)"
  };
  if (typeof fontFamily === "string" && fontFamily in fontFamilyValues) {
    return fontFamilyValues[fontFamily];
  }
  return fontFamily;
}
function fontSizeResolver(value) {
  if (typeof value === "number") {
    return (0,helpers/* pxToRem */.Q1)(value);
  }
  if (typeof value === "string") {
    if (value.endsWith("px")) {
      return (0,helpers/* pxToRem */.Q1)(value);
    } else if (value.endsWith("rem")) {
      return value;
    }
  }
  return value;
}
function identityResolver(value) {
  return value;
}
function sizeResolver(value) {
  if (typeof value === "number") {
    return `${value}px`;
  }
  return value;
}
function spacingResolver(value) {
  if (typeof value === "number" || !isNaN(Number(value))) {
    return `${value}px`;
  }
  if (typeof value === "string") {
    return `${value}`;
  }
  return value;
}
function lineHeightResolver(value) {
  if (typeof value === "number") {
    return `${value}px`;
  }
  if (typeof value === "string") {
    return `${value}`;
  }
  return value;
}
const resolvers = {
  identity: identityResolver,
  size: sizeResolver,
  spacing: spacingResolver,
  color: colorResolver,
  textColor: colorResolver,
  fontSize: fontSizeResolver,
  lineHeight: lineHeightResolver,
  fontFamily: fontFamilyResolver
};



;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs





function stylesToString({ selector, styles, media }) {
  const baseStyles = styles ? cssObjectToString(styles) : "";
  const mediaQueryStyles = !Array.isArray(media) ? [] : media.map((item) => `@media ${item.query}{${selector}{${cssObjectToString(item.styles)}}}`);
  return `${baseStyles ? `${selector}{${baseStyles}}` : ""}${mediaQueryStyles.join("")}`.trim();
}
function cssObjectToString(css) {
  return keys(css).reduce((acc, rule) => css[rule] !== void 0 ? `${acc}${camelToKebabCase(rule)}:${css[rule]};` : acc, "").trim();
}
function hasResponsiveStyles(styleProp) {
  if (typeof styleProp !== "object" || styleProp === null) {
    return false;
  }
  const breakpoints = Object.keys(styleProp);
  if (breakpoints.length === 1 && breakpoints[0] === "base") {
    return false;
  }
  return true;
}
function getBaseValue(value) {
  if (typeof value === "object" && value !== null) {
    if ("base" in value) {
      return value.base;
    }
    return void 0;
  }
  return value;
}
function getBreakpointKeys(value) {
  if (typeof value === "object" && value !== null) {
    return (0,helpers/* keys */.XP)(value).filter((key) => key !== "base");
  }
  return [];
}
function getBreakpointValue(value, breakpoint) {
  if (typeof value === "object" && value !== null && breakpoint in value) {
    return value[breakpoint];
  }
  return value;
}
function parseStyleProps({ styleProps, data }) {
  return sortMediaQueries(
    (0,helpers/* keys */.XP)(styleProps).reduce(
      (acc, styleProp) => {
        const propertyData = data[styleProp];
        const properties = Array.isArray(propertyData.property) ? propertyData.property : [propertyData.property];
        const baseValue = getBaseValue(styleProps[styleProp]);
        if (!hasResponsiveStyles(styleProps[styleProp])) {
          properties.forEach((property) => {
            acc.inlineStyles[property] = resolvers[propertyData.type](baseValue);
          });
          return acc;
        }
        acc.hasResponsiveStyles = true;
        const breakpoints = getBreakpointKeys(styleProps[styleProp]);
        if (baseValue !== void 0) {
          acc.styles[styleProp] = baseValue;
        }
        properties.forEach((property) => {
          if (baseValue) {
            acc.styles[property] = resolvers[propertyData.type](baseValue);
          }
          breakpoints.forEach((breakpoint) => {
            const bp = `(width < ${BREAKPOINTS[breakpoint]}px)`;
            acc.media[bp] = {
              ...acc.media[bp],
              [property]: resolvers[propertyData.type](getBreakpointValue(styleProps[styleProp], breakpoint))
            };
          });
        });
        return acc;
      },
      {
        hasResponsiveStyles: false,
        inlineStyles: {},
        styles: {},
        media: {}
      }
    )
  );
}




/***/ }),

/***/ 98952:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ArrowDownBoldIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43228);



const withoutBoundingBoxWidth = {
  large: 30,
  medium: 22,
  small: 16,
  xSmall: 12
};
const ArrowDownBoldIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
    iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 16 16",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        stroke: "currentColor"
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        stroke: "currentColor"
      }
    )
  );
};
ArrowDownBoldIcon.iconName = "ArrowDownBoldIcon";




/***/ }),

/***/ 53832:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ArrowDownIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43228);



const withoutBoundingBoxWidth = {
  large: 30,
  medium: 22,
  small: 16,
  xSmall: 10
};
const ArrowDownIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
    iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "large":
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 40 40",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M34.2662 11L35 11.6545L20 29L5 11.6357L5.76447 11.0188L20 27.4463L34.2662 11Z",
              fill: "currentColor"
            }
          )
        );
      case "small":
      case "xSmall":
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M17.135 5.45996L17.8645 6.1439L9.99978 14.533L2.13501 6.1439L2.86455 5.45996L9.99978 13.0709L17.135 5.45996Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M17.135 5.45996L17.8645 6.1439L9.99978 14.533L2.13501 6.1439L2.86455 5.45996L9.99978 13.0709L17.135 5.45996Z",
              fill: "currentColor"
            }
          )
        );
      case "medium":
      default:
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4.75258 9L4 9.6585L15 22L26 9.6396L25.216 9.0189L15 20.5472L4.75258 9Z",
              fill: "currentColor"
            }
          )
        );
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
ArrowDownIcon.iconName = "ArrowDownIcon";




/***/ }),

/***/ 29185:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ ArrowLeftIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43228);



const withoutBoundingBoxWidth = {
  large: 30,
  medium: 13,
  small: 9,
  xSmall: 8
};
const ArrowLeftIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
    iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "large":
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 40 40",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M29 5.73378L28.3455 5L11 20L28.3643 35L28.9812 34.2355L12.5537 20L29 5.73378Z",
              fill: "currentColor"
            }
          )
        );
      case "small":
      case "xSmall":
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M14.533 17.135L13.849 17.8645L5.45996 9.99978L13.849 2.13501L14.533 2.86455L6.92202 9.99978L14.533 17.135Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M14.533 17.135L13.849 17.8645L5.45996 9.99978L13.849 2.13501L14.533 2.86455L6.92202 9.99978L14.533 17.135Z",
              fill: "currentColor"
            }
          )
        );
      case "medium":
      default:
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M21 4.75258L20.3415 4L8.00001 15L20.3604 26L20.9811 25.216L9.45275 15L21 4.75258Z",
              fill: "currentColor"
            }
          )
        );
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
ArrowLeftIcon.iconName = "ArrowLeftIcon";




/***/ }),

/***/ 98372:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ArrowRightBoldIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43228);



const withoutBoundingBoxWidth = {
  large: 19,
  medium: 16,
  small: 12,
  xSmall: 9
};
const ArrowRightBoldIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
    iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 16 16",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        stroke: "currentColor"
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        stroke: "currentColor"
      }
    )
  );
};
ArrowRightBoldIcon.iconName = "ArrowRightBoldIcon";




/***/ }),

/***/ 51315:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43228);



const withoutBoundingBoxWidth = {
  large: 30,
  medium: 17,
  small: 10,
  xSmall: 10
};
const CloseIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
    iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "large":
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 40 40",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              d: "M20.3521 20.0021L33.7871 6.56709L33.08 5.85999L19.645 19.295L6.91707 6.56709L6.20996 7.2742L18.9379 20.0021L6.20996 32.73L6.91707 33.4371L19.645 20.7092L33.08 34.1443L33.7871 33.4371L20.3521 20.0021Z",
              fill: "currentColor"
            }
          )
        );
      case "xSmall":
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 16 16",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M3.70428 3L12.8599 12.2857L12.1556 13L3 3.71429L3.70428 3Z", fill: "currentColor" }),
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12.2957 3.00001L3.1401 12.2857L3.84438 13L13 3.71429L12.2957 3.00001Z", fill: "currentColor" })
        );
      case "small":
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M5.70428 5L14.8599 14.2857L14.1556 15L5 5.71429L5.70428 5Z", fill: "currentColor" }),
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M14.2957 5.00001L5.1401 14.2857L5.84438 15L15 5.71429L14.2957 5.00001Z", fill: "currentColor" })
        );
      case "medium":
      default:
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
              fill: "currentColor"
            }
          )
        );
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
CloseIcon.iconName = "CloseIcon";




/***/ }),

/***/ 89336:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ExternalLinkIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43228);



const withoutBoundingBoxWidth = {
  large: 22,
  medium: 15,
  small: 15,
  xSmall: 13
};
const ExternalLinkIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
    iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "xSmall":
      case "small":
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            fill: "none",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              d: "M17.5 2.4978V9.00231H16.5V4.20941L8.5 12.2094L7.79289 11.5023L15.7824 3.51282L11.0045 3.55614L10.9955 2.55618L17.5 2.4978Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              d: "M2.5 17.5023V2.49807L6.67089 2.55019L6.66244 3.55016L3.5 3.50531V16.5023H16.5V13.3356H17.5V17.5023H2.5Z",
              fill: "currentColor"
            }
          )
        );
      case "medium":
      case "large":
      default:
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              d: "M22.5 7.49548V14H21.5V9.20709L13.5 17.2071L12.7929 16.5L20.7824 8.5105L16.0045 8.55382L15.9955 7.55386L22.5 7.49548Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M7.5 22.5V7.49575L11.6709 7.54788L11.6624 8.54784L8.5 8.50299V21.5H21.5V18.3333H22.5V22.5H7.5Z", fill: "currentColor" })
        );
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
ExternalLinkIcon.iconName = "ExternalLinkIcon";




/***/ }),

/***/ 89176:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ FavoriteNavFilledIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43228);



const withoutBoundingBoxWidth = {
  large: 32,
  medium: 24,
  small: 18,
  xSmall: 14
};
const FavoriteNavFilledIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
    iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.6951 7.09156C3.49859 9.29305 3.43021 12.8518 5.53178 15.106L5.68872 15.2692L15.0022 24.6039L24.2843 15.3011L24.4416 15.1385C26.57 12.8563 26.51 9.29736 24.3092 7.09156L24.1233 6.91321C21.8569 4.83246 18.3351 4.89191 16.1404 7.09156L15.0015 8.232L13.8639 7.09156C11.6693 4.89191 8.14741 4.83246 5.88101 6.91321L5.6951 7.09156Z",
        fill: "currentColor"
      }
    )
  );
};
FavoriteNavFilledIcon.iconName = "FavoriteNavFilledIcon";




/***/ }),

/***/ 32633:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ FavoriteNavIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43228);



const withoutBoundingBoxWidth = {
  large: 30,
  medium: 23,
  small: 18,
  xSmall: 12
};
const FavoriteNavIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
    iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.69461 7.09555C3.4981 9.29704 3.42972 12.8558 5.53129 15.11L5.68823 15.2732L15.0017 24.6079L24.2838 15.3051L24.4412 15.1425C26.5695 12.8603 26.5096 9.30135 24.3087 7.09555L24.1228 6.9172C21.8564 4.83646 18.3346 4.89591 16.1399 7.09555L15.001 8.23599L13.8634 7.09555C11.6688 4.89591 8.14693 4.83646 5.88052 6.9172L5.69461 7.09555ZM13.1555 7.80186L15.0017 9.65218L16.8478 7.80186C18.7127 5.93271 21.7359 5.93271 23.6008 7.80186C25.4215 9.62661 25.4711 12.5719 23.7161 14.4539L23.5705 14.6044L15.001 23.191L6.40252 14.5734L6.25733 14.4224C4.52885 12.5683 4.58545 9.62305 6.40252 7.80186C8.26744 5.93271 11.2906 5.93271 13.1555 7.80186Z",
        fill: "currentColor"
      }
    )
  );
};
FavoriteNavIcon.iconName = "FavoriteNavIcon";




/***/ }),

/***/ 11242:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ LocationIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43228);



const withoutBoundingBoxWidth = {
  large: 27,
  medium: 15,
  small: 10,
  xSmall: 8
};
const LocationIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
    iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "large":
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 40 40",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M20.0007 10.834C17.6995 10.834 15.834 12.6995 15.834 15.0007C15.834 17.3018 17.6995 19.1673 20.0007 19.1673C22.3018 19.1673 24.1673 17.3018 24.1673 15.0007C24.1673 12.6995 22.3018 10.834 20.0007 10.834ZM16.834 15.0007C16.834 13.2517 18.2517 11.834 20.0007 11.834C21.7496 11.834 23.1673 13.2517 23.1673 15.0007C23.1673 16.7496 21.7496 18.1673 20.0007 18.1673C18.2517 18.1673 16.834 16.7496 16.834 15.0007Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M20 2C12.8525 2 7 7.47319 7 14.2947C7 15.3127 7.23318 16.4956 7.67819 17.8359L7.68126 17.8448L7.94023 18.578L7.94327 18.5863C8.03879 18.8422 8.14149 19.1038 8.25133 19.3711L8.2542 19.378L8.59953 20.1842L8.60233 20.1906C8.97468 21.0275 9.41164 21.9177 9.91266 22.8614L9.91493 22.8656L10.433 23.8193L10.4374 23.8271L10.9987 24.8179L11.0007 24.8215C11.0986 24.9909 11.1982 25.1618 11.2996 25.3343L11.3015 25.3375L11.9277 26.3841L11.9313 26.3901L12.6007 27.4741L12.6024 27.4769C12.7182 27.6616 12.8357 27.8478 12.955 28.0356L12.9566 28.0381L13.6908 29.1783L13.6939 29.183L14.4714 30.3607L14.4743 30.3651L15.295 31.5805L15.2977 31.5845L16.1616 32.8376L16.1629 32.8395C16.3109 33.0521 16.4608 33.2663 16.6124 33.4821L16.6136 33.4838L17.5424 34.7937L17.5436 34.7954C17.7024 35.0174 17.863 35.241 18.0254 35.4662L18.0269 35.4684L20.1315 38.3543L22.2004 35.4581L22.2031 35.4544L23.134 34.1257L24.0248 32.8315L24.0273 32.8278L24.8735 31.5748L24.8762 31.5709L25.68 30.3557L25.6828 30.3513L26.4443 29.1738L26.4473 29.1691L27.1664 28.0291L27.1697 28.0239L27.8465 26.9214L27.8482 26.9186C27.958 26.7371 28.0661 26.557 28.1724 26.3785L28.1742 26.3754L28.7875 25.329L28.7913 25.3224L29.3623 24.3132L29.3664 24.3059L29.895 23.3338L29.8971 23.3299C29.9825 23.1696 30.066 23.0108 30.1478 22.8535L30.1501 22.8491L30.6152 21.9326L30.6176 21.9279C32.1792 18.7695 33 16.2187 33 14.2947C33 7.47319 27.1475 2 20 2ZM8 14.2947C8 8.07983 13.3488 3 20 3C26.6512 3 32 8.07983 32 14.2947C32 15.9782 31.268 18.3559 29.7223 21.4824L29.7212 21.4847L29.2606 22.3921L29.2595 22.3943C29.1799 22.5473 29.0986 22.7018 29.0155 22.8579L29.0144 22.86L28.4899 23.8244L27.9228 24.8267L27.3133 25.8667L27.3125 25.8682C27.2079 26.0438 27.1015 26.2209 26.9934 26.3996L26.9925 26.401L26.319 27.4982L25.6031 28.6331L24.8459 29.804L24.8431 29.8083L24.0448 31.0152L24.0421 31.0192L23.2011 32.2645L23.1986 32.2681L22.3149 33.5519L22.3126 33.5553L21.3867 34.8769L21.384 34.8806L20.1231 36.6457L18.8365 34.8813L18.8357 34.8802C18.6745 34.6567 18.5151 34.4348 18.3575 34.2144L17.4306 32.9071L17.4298 32.9061C17.2795 32.6921 17.1309 32.4797 16.9842 32.2689L16.1237 31.0209L16.121 31.0169L15.3059 29.8098L15.303 29.8055L14.5301 28.6345L13.799 27.4993L13.7982 27.498C13.6806 27.3129 13.5647 27.1293 13.4507 26.9473L13.4498 26.9459L12.784 25.8677L12.1616 24.8273L12.1607 24.8258C12.0612 24.6567 11.9636 24.4892 11.8678 24.3232L11.8667 24.3214L11.3096 23.3381L10.7959 22.3925L10.7948 22.3903C10.3039 21.4656 9.87828 20.5982 9.51737 19.7873L9.17491 18.9877C9.07006 18.7324 8.97231 18.4834 8.88164 18.2407L8.62576 17.5163C8.2014 16.2372 8 15.1676 8 14.2947Z",
              fill: "currentColor"
            }
          )
        );
      case "medium":
      case "small":
      case "xSmall":
      default:
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M14.9422 8.71053C13.5033 8.71053 12.3369 9.87694 12.3369 11.3158C12.3369 12.7546 13.5033 13.9211 14.9422 13.9211C16.381 13.9211 17.5474 12.7546 17.5474 11.3158C17.5474 9.87694 16.381 8.71053 14.9422 8.71053ZM14.9422 9.71053C15.8287 9.71053 16.5474 10.4292 16.5474 11.3158C16.5474 12.2024 15.8287 12.9211 14.9422 12.9211C14.0556 12.9211 13.3369 12.2024 13.3369 11.3158C13.3369 10.4292 14.0556 9.71053 14.9422 9.71053Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M14.9422 4.5C10.8897 4.5 7.6001 7.71675 7.6001 11.6905C7.6001 12.2672 7.72786 12.9542 7.98348 13.7532L8.13559 14.2002C8.19052 14.3529 8.24967 14.5093 8.31306 14.6694L8.51589 15.1609C8.73141 15.6637 8.98498 16.2 9.27661 16.7701L9.58094 17.3515L9.91064 17.9556C9.96771 18.0581 10.0258 18.1616 10.085 18.2661L10.4528 18.9041L10.846 19.565C10.9136 19.677 10.9823 19.79 11.0521 19.9039L11.4833 20.599L11.94 21.317L12.422 22.0579L12.9295 22.8219C13.0161 22.9511 13.1039 23.0814 13.1927 23.2125L13.7383 24.0111C13.8313 24.1462 13.9254 24.2822 14.0206 24.4191L15.017 25.8373L15.9957 24.4153L16.5425 23.6052L17.0643 22.8183L17.5614 22.0545L18.0335 21.3137L18.4808 20.5958L18.9032 19.9008L19.3007 19.2287C19.3649 19.1186 19.428 19.0094 19.4901 18.9012L19.8504 18.2633L20.1857 17.648L20.4962 17.0554C20.5459 16.9585 20.5945 16.8626 20.6422 16.7676L20.9154 16.2089C21.8282 14.2928 22.2843 12.7903 22.2843 11.6905C22.2843 7.71675 18.9947 4.5 14.9422 4.5ZM14.9422 5.5C18.4473 5.5 21.2843 8.27411 21.2843 11.6905L21.2811 11.8356C21.2559 12.4286 21.0789 13.1706 20.7502 14.0595L20.5733 14.5161C20.5417 14.5943 20.509 14.6734 20.4753 14.7536L20.2605 15.2469C20.1847 15.4154 20.1046 15.5879 20.0204 15.7645L19.755 16.3064L19.4644 16.8724L19.1485 17.4627C19.0938 17.563 19.038 17.6644 18.9811 17.7668L18.6274 18.3931L18.2484 19.0435L17.8441 19.7177L17.4146 20.4159L16.9599 21.1379C16.882 21.2602 16.8031 21.3835 16.7231 21.5077L16.2305 22.2653L15.7127 23.0466C15.6243 23.1787 15.5349 23.3119 15.4444 23.4461L15.0081 24.086L14.3101 23.0766L13.7915 22.3109L13.2975 21.5679L12.8283 20.8475L12.3837 20.1499L11.9638 19.4752C11.8958 19.3647 11.8289 19.2551 11.7631 19.1464L11.3802 18.506C11.3184 18.4012 11.2577 18.2974 11.198 18.1945L10.8521 17.5886L10.5309 17.0058C10.4279 16.8154 10.3291 16.6288 10.2344 16.4461L9.96258 15.9096C9.87609 15.7346 9.79372 15.5635 9.71546 15.3963L9.49304 14.9064C9.45803 14.8266 9.42405 14.7479 9.3911 14.6701L9.20573 14.2152L9.04507 13.7837C8.74846 12.9443 8.6001 12.2458 8.6001 11.6905C8.6001 8.27411 11.4371 5.5 14.9422 5.5Z",
              fill: "currentColor"
            }
          )
        );
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
LocationIcon.iconName = "LocationIcon";




/***/ }),

/***/ 28056:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ MenuIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43228);



const withoutBoundingBoxWidth = {
  large: 26,
  medium: 20,
  small: 13,
  xSmall: 10
};
const MenuIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
    iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M5 7.5H25V8.5H5V7.5Z", fill: "currentColor" }),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M5 14.5H25V15.5H5V14.5Z", fill: "currentColor" }),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M25 21.5H5V22.5H25V21.5Z", fill: "currentColor" })
  );
};
MenuIcon.iconName = "MenuIcon";




/***/ }),

/***/ 90905:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SearchIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43228);



const withoutBoundingBoxWidth = {
  large: 24,
  medium: 18,
  small: 12,
  xSmall: 10
};
const SearchIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
    iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5312 6C9.37186 6 6 9.37186 6 13.5312C6 17.6906 9.37186 21.0625 13.5312 21.0625C15.431 21.0625 17.1665 20.3591 18.4914 19.1985L23.2558 23.9629L23.9629 23.2558L19.1985 18.4914C20.3591 17.1665 21.0625 15.431 21.0625 13.5312C21.0625 9.37186 17.6906 6 13.5312 6ZM13.5312 7C17.1384 7 20.0625 9.92414 20.0625 13.5312C20.0625 17.1384 17.1384 20.0625 13.5312 20.0625C9.92414 20.0625 7 17.1384 7 13.5312C7 9.92414 9.92414 7 13.5312 7Z",
        fill: "currentColor"
      }
    )
  );
};
SearchIcon.iconName = "SearchIcon";




/***/ }),

/***/ 3423:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ UserIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43228);



const withoutBoundingBoxWidth = {
  large: 24,
  medium: 18,
  small: 14,
  xSmall: 11
};
const UserIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
    iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 5.5C12.2386 5.5 10 7.73858 10 10.5C10 13.2614 12.2386 15.5 15 15.5C17.7614 15.5 20 13.2614 20 10.5C20 7.73858 17.7614 5.5 15 5.5ZM15 6.5C17.2091 6.5 19 8.29086 19 10.5C19 12.7091 17.2091 14.5 15 14.5C12.7909 14.5 11 12.7091 11 10.5C11 8.29086 12.7909 6.5 15 6.5Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        d: "M23.9951 21.7882C23.8845 19.4012 21.9143 17.5 19.5 17.5H10.5L10.2882 17.5049C7.90124 17.6155 6 19.5857 6 22V25H7V22L7.00518 21.808C7.10487 19.9643 8.63144 18.5 10.5 18.5H19.5L19.692 18.5052C21.5357 18.6049 23 20.1314 23 22V25H24V22L23.9951 21.7882Z",
        fill: "currentColor"
      }
    )
  );
};
UserIcon.iconName = "UserIcon";




/***/ }),

/***/ 43228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ iconSize; }
/* harmony export */ });
const iconSize = {
  large: 40,
  medium: 30,
  small: 20,
  xSmall: 16
};




/***/ }),

/***/ 90512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ clsx; }
/* harmony export */ });
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f)}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 67421:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$G": function() { return /* reexport */ useTranslation_useTranslation; },
  "Zh": function() { return /* reexport */ withTranslation; }
});

// UNUSED EXPORTS: I18nContext, I18nextProvider, Trans, TransWithoutContext, Translation, composeInitialProps, date, getDefaults, getI18n, getInitialProps, initReactI18next, number, plural, select, selectOrdinal, setDefaults, setI18n, time, useSSR, withSSR

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/void-elements/index.js
var void_elements = __webpack_require__(71739);
var void_elements_default = /*#__PURE__*/__webpack_require__.n(void_elements);
;// CONCATENATED MODULE: ./node_modules/html-parse-stringify/dist/html-parse-stringify.module.js
var e=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;function n(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],((void_elements_default())[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return{type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(e),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var l=c[1].trim(),o=[l,""];l.indexOf("=")>-1&&(o=l.split("=")),r.attrs[o[0]]=o[1],a.lastIndex--}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i=/^\s*$/,s=Object.create(null);function a(t,e){switch(e.type){case"text":return t+e.content;case"tag":return t+="<"+e.name+(e.attrs?function(t){var e=[];for(var n in t)e.push(n+'="'+t[n]+'"');return e.length?" "+e.join(" "):""}(e.attrs):"")+(e.voidElement?"/>":">"),e.voidElement?t:t+e.children.reduce(a,"")+"</"+e.name+">";case"comment":return t+"\x3c!--"+e.comment+"--\x3e"}}var c={parse:function(t,e){e||(e={}),e.components||(e.components=s);var a,c=[],l=[],o=-1,u=!1;if(0!==t.indexOf("<")){var h=t.indexOf("<");c.push({type:"text",content:-1===h?t:t.substring(0,h)})}for(var v,f=[];v=r.exec(t);)f.push(v);return f.forEach(function(t,e){var n=t[0];if(n&&!n.startsWith("\x3c!--")){for(var r=0,i=0,s=-1,a=null,c=0;c<n.length;c++){var l=n.charAt(c);a?l===a&&(a=null):'"'===l||"'"===l?a=l:"<"===l?2==++r&&(s=c):">"===l&&i++}var o=s>-1&&/[a-zA-Z0-9\-!/]/.test(n.charAt(s+1));if(r>i&&o){var u=n.substring(0,s),h=n.substring(u.length);f[e][0]=h,f[e].index+=u.length}}}),f.forEach(function(r,s){var h=r[0];if(h){var v=r.index;if(u){if(h!=="</"+a.name+">")return;u=!1}var m,d,p="/"!==h.charAt(1),x=h.startsWith("\x3c!--"),g=v+h.length,y=t.charAt(g),E=f[s+1];if("<"===y&&E){var A=t.substring(g,E.index);m=A.split("<").length>A.split(">").length}if(x){var b=n(h);if(o<0)return c.push(b),c;(d=l[o]).children.push(b);var O=t.slice(g,E?E.index:void 0);return O.length>0&&d.children.push({type:"text",content:O}),c}if(p&&(o++,"tag"===(a=n(h)).type&&e.components[a.name]&&(a.type="component",u=!0),a.voidElement||u||!y||"<"===y||a.children.push({type:"text",content:t.slice(g,E?E.index:void 0)}),0===o&&c.push(a),(d=l[o-1])&&d.children.push(a),l[o]=a),(!p||a.voidElement)&&(o>-1&&(a.voidElement||a.name===h.slice(2,-1))&&(o--,a=-1===o?c:l[o]),!u&&("<"!==y||m)&&y)){d=-1===o?c:l[o].children;var W=E?E.index:-1,j=t.slice(g,-1===W?void 0:W);i.test(j)&&(j=" "),(W>-1&&o+d.length>=0||" "!==j)&&d.push({type:"text",content:j})}}}),c},stringify:function(t){return t.reduce(function(t,e){return t+a("",e)},"")}};/* harmony default export */ var html_parse_stringify_module = ((/* unused pure expression or super */ null && (c)));
//# sourceMappingURL=html-parse-stringify.module.js.map

;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/utils.js
function utils_warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function utils_warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  utils_warn.apply(void 0, args);
}

var loadedClb = function loadedClb(i18n, cb) {
  return function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  };
};

function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
function loadLanguages(i18n, lng, ns, cb) {
  if (typeof ns === 'string') ns = [ns];
  ns.forEach(function (n) {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    utils_warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function utils_getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/defaults.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function defaults_getDefaults() {
  return defaultOptions;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/TransWithoutContext.js



var _excluded = (/* unused pure expression or super */ null && (["format"])),
    _excluded2 = (/* unused pure expression or super */ null && (["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"]));

function TransWithoutContext_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TransWithoutContext_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TransWithoutContext_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TransWithoutContext_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function hasChildren(node, checkLength) {
  if (!node) return false;
  var base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}

function getChildren(node) {
  if (!node) return [];
  return node.props ? node.props.children : node.children;
}

function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(function (child) {
    return isValidElement(child);
  });
}

function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}

function mergeProps(source, target) {
  var newTarget = TransWithoutContext_objectSpread({}, target);

  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}

function nodesToString(children, i18nOptions) {
  if (!children) return '';
  var stringNode = '';
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach(function (child, childIndex) {
    if (typeof child === 'string') {
      stringNode += "".concat(child);
    } else if (isValidElement(child)) {
      var childPropsCount = Object.keys(child.props).length;
      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
      var childChildren = child.props.children;

      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += "<".concat(child.type, "/>");
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (child.props.i18nIsDynamicList) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
      } else {
        var content = nodesToString(childChildren, i18nOptions);
        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
      }
    } else if (child === null) {
      warn("Trans: the passed in value is invalid - seems you passed in a null child.");
    } else if (_typeof(child) === 'object') {
      var format = child.format,
          clone = _objectWithoutProperties(child, _excluded);

      var keys = Object.keys(clone);

      if (keys.length === 1) {
        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
        stringNode += "{{".concat(value, "}}");
      } else {
        warn("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      warn("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}

function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === '') return [];
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
  var data = {};

  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (_typeof(child) === 'object' && !isValidElement(child)) Object.assign(data, child);
    });
  }

  getData(children);
  var ast = HTML.parse("<0>".concat(targetString, "</0>"));

  var opts = TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, data), combinedTOpts);

  function renderInner(child, node, rootReactNode) {
    var childs = getChildren(child);
    var mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }

  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) child.children = inner;
    mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
      key: i
    }), isVoid ? undefined : inner));
  }

  function mapAST(reactNode, astNode, rootReactNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function (mem, node, i) {
      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);

      if (node.type === 'tag') {
        var tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        var isElement = isValidElement(child);
        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && _typeof(child) === 'object' && child.dummy && !isElement;
        var isKnownComponent = _typeof(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);

        if (typeof child === 'string') {
          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
            var inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i);
          } else if (isEmptyTransWithHTML) {
          var _inner = mapAST(reactNodes, node.children, rootReactNode);

          mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
            key: i
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            var _inner2 = renderInner(child, node, rootReactNode);

            pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }));
            } else {
              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);

              mem.push(createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }, _inner3));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);

            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
          }
        } else if (_typeof(child) === 'object' && !isElement) {
          var content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
            key: i
          }), translationContent));
        } else {
          mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
            key: i
          })));
        }
      } else if (node.type === 'text') {
        var wrapTextNodes = i18nOptions.transWrapTextNodes;

        var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);

        if (wrapTextNodes) {
          mem.push(createElement(wrapTextNodes, {
            key: "".concat(node.name, "-").concat(i)
          }, _content));
        } else {
          mem.push(_content);
        }
      }

      return mem;
    }, []);
  }

  var result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}

function Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = _objectWithoutProperties(_ref, _excluded2);

  var i18n = i18nFromProps || getI18n();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }

  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
    return k;
  };

  if (context) tOptions.context = context;

  var reactI18nextOptions = TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, getDefaults()), i18n.options && i18n.options.react);

  var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? tOptions.interpolation : {
    interpolation: TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, tOptions.interpolation), {}, {
      prefix: '#$?',
      suffix: '?$#'
    })
  };

  var combinedTOpts = TransWithoutContext_objectSpread(TransWithoutContext_objectSpread(TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, tOptions), {}, {
    count: count
  }, values), interpolationOverride), {}, {
    defaultValue: defaultValue,
    ns: namespaces
  });

  var translation = key ? t(key, combinedTOpts) : defaultValue;
  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? createElement(useAsParent, additionalProps, content) : content;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/i18nInstance.js
var i18nInstance;
function setI18n(instance) {
  i18nInstance = instance;
}
function i18nInstance_getI18n() {
  return i18nInstance;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/initReactI18next.js


var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/context.js




function context_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function context_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { context_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { context_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var context_I18nContext = (0,react.createContext)();
var ReportNamespaces = function () {
  function ReportNamespaces() {
    (0,classCallCheck/* default */.Z)(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  (0,createClass/* default */.Z)(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function context_composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(context_objectSpread(context_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Trans.js


var Trans_excluded = (/* unused pure expression or super */ null && (["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"]));

function Trans_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Trans_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Trans_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Trans_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function Trans_Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = _objectWithoutProperties(_ref, Trans_excluded);

  var _ref2 = useContext(I18nContext) || {},
      i18nFromContext = _ref2.i18n,
      defaultNSFromContext = _ref2.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  var t = tFromProps || i18n && i18n.t.bind(i18n);
  return TransWithoutContext(Trans_objectSpread({
    children: children,
    count: count,
    parent: parent,
    i18nKey: i18nKey,
    context: context,
    tOptions: tOptions,
    values: values,
    defaults: defaults,
    components: components,
    ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
    i18n: i18n,
    t: tFromProps,
    shouldUnescape: shouldUnescape
  }, additionalProps));
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js




function useTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useTranslation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation_useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(context_I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || i18nInstance_getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    utils_warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k, optsOrDefaultValue) {
      if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
      if (optsOrDefaultValue && (0,esm_typeof/* default */.Z)(optsOrDefaultValue) === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) utils_warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = useTranslation_objectSpread(useTranslation_objectSpread(useTranslation_objectSpread({}, defaults_getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      if (props.lng) {
        loadLanguages(i18n, props.lng, namespaces, function () {
          if (isMounted.current) setT(getT);
        });
      } else {
        loadNamespaces(i18n, namespaces, function () {
          if (isMounted.current) setT(getT);
        });
      }
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    if (props.lng) {
      loadLanguages(i18n, props.lng, namespaces, function () {
        return resolve();
      });
    } else {
      loadNamespaces(i18n, namespaces, function () {
        return resolve();
      });
    }
  });
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js



var withTranslation_excluded = ["forwardedRef"];

function withTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function withTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { withTranslation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { withTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function withTranslation(ns) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      var forwardedRef = _ref.forwardedRef,
          rest = (0,objectWithoutProperties/* default */.Z)(_ref, withTranslation_excluded);

      var _useTranslation = useTranslation_useTranslation(ns, withTranslation_objectSpread(withTranslation_objectSpread({}, rest), {}, {
        keyPrefix: options.keyPrefix
      })),
          _useTranslation2 = (0,slicedToArray/* default */.Z)(_useTranslation, 3),
          t = _useTranslation2[0],
          i18n = _useTranslation2[1],
          ready = _useTranslation2[2];

      var passDownProps = withTranslation_objectSpread(withTranslation_objectSpread({}, rest), {}, {
        t: t,
        i18n: i18n,
        tReady: ready
      });

      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }

      return (0,react.createElement)(WrappedComponent, passDownProps);
    }

    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat(utils_getDisplayName(WrappedComponent), ")");
    I18nextWithTranslation.WrappedComponent = WrappedComponent;

    var forwardRef = function forwardRef(props, ref) {
      return (0,react.createElement)(I18nextWithTranslation, Object.assign({}, props, {
        forwardedRef: ref
      }));
    };

    return options.withRef ? (0,react.forwardRef)(forwardRef) : I18nextWithTranslation;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Translation.js


var Translation_excluded = (/* unused pure expression or super */ null && (["ns", "children"]));

function Translation(props) {
  var ns = props.ns,
      children = props.children,
      options = _objectWithoutProperties(props, Translation_excluded);

  var _useTranslation = useTranslation(ns, options),
      _useTranslation2 = _slicedToArray(_useTranslation, 3),
      t = _useTranslation2[0],
      i18n = _useTranslation2[1],
      ready = _useTranslation2[2];

  return children(t, {
    i18n: i18n,
    lng: i18n.language
  }, ready);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = useMemo(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return createElement(I18nContext.Provider, {
    value: value
  }, children);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useSSR.js


function useSSR_useSSR(initialI18nStore, initialLanguage) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var i18nFromProps = props.i18n;

  var _ref = useContext(I18nContext) || {},
      i18nFromContext = _ref.i18n;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n.options && i18n.options.isClone) return;

  if (initialI18nStore && !i18n.initializedStoreOnce) {
    i18n.services.resourceStore.data = initialI18nStore;
    i18n.options.ns = Object.values(initialI18nStore).reduce(function (mem, lngResources) {
      Object.keys(lngResources).forEach(function (ns) {
        if (mem.indexOf(ns) < 0) mem.push(ns);
      });
      return mem;
    }, i18n.options.ns);
    i18n.initializedStoreOnce = true;
    i18n.isInitialized = true;
  }

  if (initialLanguage && !i18n.initializedLanguageOnce) {
    i18n.changeLanguage(initialLanguage);
    i18n.initializedLanguageOnce = true;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withSSR.js


var withSSR_excluded = (/* unused pure expression or super */ null && (["initialI18nStore", "initialLanguage"]));

function withSSR_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function withSSR_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { withSSR_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { withSSR_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function withSSR() {
  return function Extend(WrappedComponent) {
    function I18nextWithSSR(_ref) {
      var initialI18nStore = _ref.initialI18nStore,
          initialLanguage = _ref.initialLanguage,
          rest = _objectWithoutProperties(_ref, withSSR_excluded);

      useSSR(initialI18nStore, initialLanguage);
      return createElement(WrappedComponent, withSSR_objectSpread({}, rest));
    }

    I18nextWithSSR.getInitialProps = composeInitialProps(WrappedComponent);
    I18nextWithSSR.displayName = "withI18nextSSR(".concat(getDisplayName(WrappedComponent), ")");
    I18nextWithSSR.WrappedComponent = WrappedComponent;
    return I18nextWithSSR;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/index.js












var date = function date() {
  return '';
};
var time = function time() {
  return '';
};
var number = function number() {
  return '';
};
var es_select = function select() {
  return '';
};
var plural = function plural() {
  return '';
};
var selectOrdinal = function selectOrdinal() {
  return '';
};

/***/ }),

/***/ 18357:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef(onChange);
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current) callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef(void 0);
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ })

}]);